// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    ##########################################################################################################################################################
    EzClocker Button UX CSS Classes
    Requires:
        /src/main/webapp/public/styles/common/ez-body.css (for css variables used in this file)
    ##########################################################################################################################################################
*/
:root {
  /* General Button Variables */
  /*
  --ezButtons-font-family: 'Font-Family-ezClocker', 'Roboto', 'Verdana', 'Arial', sans-serif;
  */
  --ezButtons-font-family: "Roboto", "Verdana", "Arial", sans-serif;
  --ezButtons-cursor: pointer;
  /* Link Button Common Variables */
  --ezSmallLinkButton-text-decoration: none;
  --ezSmallLinkButton-font-weight: normal;
  --ezSmallLinkButton-font-style: normal;
  --ezSmallLinkButton-cursor: pointer;
  /* Small Link Button Variables */
  --ezLinkButton-small-font-size: 10pt;
  /* Large Button Variables */
  --ezLargeButtonMaxHeight: 32px;
  --ezLargeButtonMaxWidth: 175px;
  --ezLargeButtonMinWidth: 32px;
  --ezLargeButtonTextTransform: capitalize;
  --ezLargeButtonFontWeight: bold;
  --ezLargeButton-border-radius: 4px;
  /* Navigation Button Variables */
  --ezNavButtonColor: var(--ezOrange);
  --ezNavButtonColorHover: var(--ezClockerOrange);
  --ezNavButtonTextColor: var(--ezBlack);
  --ezNavButtonFontSize: var(--ezFontSize);
  --ezNavButtonFontWeight: var(--ezLargeButtonFontWeight);
  --ezNavButtonMaxHeight: var(--ezLargeButtonMaxHeight);
  --ezNavButtonTextTransform: var(--ezLargeButtonTextTransform);
  --ezNavButtonMaxWidth: var(--ezLargeButtonMaxWidth);
  --ezNavButtonMinWidth: var(--ezLargeButtonMinWidth);
  --ezNavButtonRippleEffect: var(--ezWhite);
  --ezNavButton-border-radius: 4px;
  /* Sign-out Button Variables */
  --ezSignOutButtonColor: var(--ezClockerAqua);
  --ezSignOutButtonTextColor: var(--ezWhite);
  --ezSignOutButtonFontSize: var(--ezFontSize);
  --ezSignOutButtonHoverColor: var(--ezDarkAqua);
  --ezSignOutButtonFontWeight: var(--ezLargeButtonFontWeight);
  --ezSignOutButtonTextTransform: var(--ezLargeButtonTextTransform);
  --ezSignOutButtonMaxHeight: var(--ezLargeButtonMaxHeight);
  --ezSignOutButtonMaxWidth: var(--ezLargeButtonMaxWidth);
  --ezSignOutButtonMinWidth: var(--ezLargeButtonMinWidth);
  --ezSignOutButtonMinWidth-border-radius: 4px;
  /* Subscription Plan Select Button Variables */
  --ezSelectPlanBtnColor: var(--ezActionGreen);
  --ezSelectPlanBtnTextColor: var(--ezBlack);
  --ezSelectPlanBtnFontSize: var(--ezFontSize);
  --ezSelectPlanBtnHoverColor: var(--ezHoverGreen);
  --ezSelectPlanBtnFontWeight: var(--ezLargeButtonFontWeight);
  --ezSelectPlanTextTransform: var(--ezLargeButtonTextTransform);
  --ezSelectPlanBtnMaxHeight: var(--ezLargeButtonMaxHeight);
  --ezSelectPlanButtonMaxWidth: var(--ezLargeButtonMaxWidth);
  --ezSelectPlanButtonMinWidth: var(--ezLargeButtonMinWidth);
  --ezSelectPlanButton-border-radius: 4px;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Link Buttons
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <a/>
    Name Templates:
        ezButtons-{name}-{color}
        ezButtons-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Large Link Buttons
    Classes:
        (DEPRECATED) a.ezButtonLink_default-large-navy
        (DEPRECATED) a.ez-button-link-large-navy
        (DEPRECATED) a.ezLargeNavyLink
    ===================================================================================================================
*/
a.ezButtonLink-hidden {
  display: none;
}

a.ezButtonLink-visible {
  display: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) a.ezButtonLink_default-large-navy
        (DEPRECATED) a.ez-button-link-large-navy
        (DEPRECATED) a.ezLargeNavyLink
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy,
a.ezButtonLink_default-large-navy:enabled,
a.ezButtonLink_default-large-navy:enabled:visited,
a.ez-button-link-large-navy,
a.ez-button-link-large-navy:enabled,
a.ez-button-link-large-navy:enabled:visited,
a.ezLargeNavyLink,
a.ezLargeNavyLink:enabled,
a.ezLargeNavyLink:enabled:visited {
  color: var(--ezClockerNavy);
  font-family: var(--ezButtons-font-family);
  font-weight: normal;
  font-style: normal;
  font-size: 14pt;
  cursor: var(--ezButtons-cursor);
  text-decoration: none;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) a.ezButtonLink_default-large-navy
        (DEPRECATED) a.ez-button-link-large-navy
        (DEPRECATED) a.ezLargeNavyLink
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
        :enabled:visited:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy:enabled:hover,
a.ezButtonLink_default-large-navy:enabled:focus:hover,
a.ezButtonLink_default-large-navy:enabled:visited:hover,
a.ez-button-link-large-navy:enabled:hover,
a.ez-button-link-large-navy:enabled:focus:hover,
a.ez-button-link-large-navy:enabled:visited:hover,
a.ezLargeNavyLink:enabled:hover,
a.ezLargeNavyLink:enabled:focus:hover,
a.ezLargeNavyLink:enabled:visited:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy:enabled:active,
a.ezButtonLink_default-large-navy:enabled:active:hover,
a.ezButtonLink_default-large-navy:enabled:visited:active,
a.ezButtonLink_default-large-navy:enabled:visited:active:hover,
a.ez-button-link-large-navy:enabled:active,
a.ez-button-link-large-navy:enabled:active:hover,
a.ez-button-link-large-navy:enabled:visited:active,
a.ez-button-link-large-navy:enabled:visited:active:hover,
a.ezLargeNavyLink:enabled:active,
a.ezLargeNavyLink:enabled:active:hover,
a.ezLargeNavyLink:enabled:visited:active,
a.ezLargeNavyLink:enabled:visited:active:hover {
  color: var(--ezDarkNavy);
  text-decoration: underline;
}

/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy:disabled,
a.ezButtonLink_default-large-navy:disabled:hover,
a.ez-button-link-large-navy:disabled,
a.ez-button-link-large-navy:disabled:hover,
a.ezLargeNavyLink:disabled,
a.ezLargeNavyLink:disabled:hover {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/* DEPRECATED a.ezLargeNavyLinkDisabled */
a.ezLargeNavyLinkDisabled,
a.ezLargeNavyLinkDisabled:disabled a.ezLargeNavyLinkDisabled:disabled:hover {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Link Buttons
    Classes:
        a.ezLink-ezClockerNavy
        (DEPRECATED) a.ezNavyLink
    ===================================================================================================================
*/
a.ezLink-ezClockerNavy,
a.ezNavyLink {
  color: var(--ezClockerNavy);
  text-decoration: none;
  font-family: var(--ezButtons-font-family);
  font-size: 12pt;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

a.ezLink-ezClockerNavy:hover,
a.ezNavyLink:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezLink-ezClockerNavy:hover:enabled,
a.ezNavyLink:hover:enabled {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezLink-ezClockerNavy:hover:active,
a.ezNavyLink:hover:active {
  color: var(--ezDarkNavy);
  text-decoration: underline;
}

a.ezLink-ezClockerNavy:visited,
a.ezNavyLink:visited {
  color: var(--ezClockerNavy);
  text-decoration: none;
}

a.ezLink-ezClockerNavy:disabled,
a.ezNavyLink:disabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/* DEPRECATED:  */
a.ezNavyLinkDisabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Link 'Button' Classes
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <a/>
    Name Templates:
        ezButtons-link-{name}-{color}
        ezButtons-link-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Link Buttons
    Classes:
        a.ezButton-link-ezClockerOrange
        a.ezButton-link-ezClockerWhite
        a.ezButton-link-ezClockerHotGreen
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :link
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerOrange,
a.ezButton-link-ezClockerOrange:link,
a.ezButton-link-ezClockerOrange:visited {
  margin: 0;
  padding: 4px;
  /* Variable --ezClockerOrange defined in ez-body.css */
  background-color: var(--ezClockerOrange);
  text-decoration: none;
  /* Variable --ezContentFontColor defined in ez-body.css */
  color: var(--ezContentFontColor);
  /* Variable ezFontFamily defined in ez-body.css */
  font-family: var(--ezFontFamily);
  /* Variable --ezContentFontSize defined in ez-body.css */
  font-size: var(--ezContentFontSize);
  /* Variable --ezContentFontWeigth defined in ez-body.css */
  font-weight: var(--ezContentFontWeigth);
  /* Variable --ezContentFontStyle defined in ez-body.css */
  font-style: var(--ezContentFontStyle);
  /* Variable --ezBorderOrange defined in ez-body.css */
  border-color: var(--ezBorderOrange);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :active
        :active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezclockerOrange:active,
a.ezButton-link-ezclockerOrange:active:hover {
  box-shadow: var(--ezBoxShadow-inset-ezClockerOrange-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
        :visited:hove
        :active:hover
        :link:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerOrange:hover,
a.ezButton-link-ezClockerOrange:visited:hover,
a.ezButton-link-ezClockerOrange:link:hover {
  background-color: var(--ezHoverOrange);
  box-shadow: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
        :disabled:visited
        :disabled:link
        :disabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerOrange:disabled,
a.ezButton-link-ezClockerOrange:disabled:active,
a.ezButton-link-ezClockerOrange:disabled:hover,
a.ezButton-link-ezClockerOrange:disabled:visited,
a.ezButton-link-ezClockerOrange:disabled:link {
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  border-color: var(--ezOrange);
  box-shadow: unset;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :link
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite,
a.ezButton-link-ezClockerWhite:link,
a.ezButton-link-ezClockerWhite:visited {
  margin: 0;
  padding: 4px;
  /* Variable --ezClockerOrange defined in ez-body.css */
  background-color: var(--ezClockerWhite);
  text-decoration: none;
  /* Variable --ezContentFontColor defined in ez-body.css */
  color: var(--ezContentFontColor);
  /* Variable ezFontFamily defined in ez-body.css */
  font-family: var(--ezFontFamily);
  /* Variable --ezContentFontSize defined in ez-body.css */
  font-size: var(--ezContentFontSize);
  /* Variable --ezContentFontWeigth defined in ez-body.css */
  font-weight: var(--ezContentFontWeigth);
  /* Variable --ezContentFontStyle defined in ez-body.css */
  font-style: var(--ezContentFontStyle);
  /* Variable --ezBorderOrange defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :active
        :active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite:active,
a.ezButton-link-ezClockerWhite:active:hover {
  box-shadow: var(--ezBoxShadow-inset-ezClockerGray-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
        :visited:hove
        :active:hover
        :link:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite:hover,
a.ezButton-link-ezClockerWhite:visited:hover,
a.ezButton-link-ezClockerWhite:link:hover {
  background-color: var(--ezClockerSilver);
  box-shadow: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
        :disabled:visited
        :disabled:link
        :disabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite:disabled,
a.ezButton-link-ezClockerWhite:disabled:hover,
a.ezButton-link-ezClockerWhite:disabled:visited,
a.ezButton-link-ezClockerWhite:disabled:link,
a.ezButton-link-ezClockerWhite:disabled:active {
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerGray);
  border-color: var(--ezClockerSilver);
  box-shadow: unset;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :link
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen,
a.ezButton-link-ezClockerHotGreen:link,
a.ezButton-link-ezClockerHotGreen:visited {
  margin: 0;
  padding: 4px;
  /* Variable --ezClockerOrange defined in ez-body.css */
  background-color: var(--ezClockerHotGreen);
  text-decoration: none;
  /* Variable --ezContentFontColor defined in ez-body.css */
  color: var(--ezContentFontColor);
  /* Variable ezFontFamily defined in ez-body.css */
  font-family: var(--ezFontFamily);
  /* Variable --ezContentFontSize defined in ez-body.css */
  font-size: var(--ezContentFontSize);
  /* Variable --ezContentFontWeigth defined in ez-body.css */
  font-weight: var(--ezContentFontWeigth);
  /* Variable --ezContentFontStyle defined in ez-body.css */
  font-style: var(--ezContentFontStyle);
  /* Variable --ezBorderOrange defined in ez-body.css */
  border-color: var(--ezBorderHotGreen);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :active
        :active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen:active,
a.ezButton-link-ezClockerHotGreen:active:hover {
  box-shadow: var(--ezBoxShadow-inset-ezBorderHotGreen-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
        :visited:hove
        :link:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen:hover,
a.ezButton-link-ezClockerHotGreen:visited:hover,
a.ezButton-link-ezClockerHotGreen:link:hover {
  background-color: var(--ezHoverHotGreen);
  box-shadow: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
        :disabled:visited
        :disabled:link
        :disabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen:disabled,
a.ezButton-link-ezClockerHotGreen:disabled:hover,
a.ezButton-link-ezClockerHotGreen:disabled:visited,
a.ezButton-link-ezClockerHotGreen:disabled:link,
a.ezButton-link-ezClockerHotGreen:disabled:active {
  background-color: var(--ezHoverHotGreen);
  color: var(--ezBorderHotGreen);
  border-color: var(--ezClockerHotGreen);
  box-shadow: unset;
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Small Link Buttons
        a.ezButtonLink_default-small-navy
        (DEPRECATED) a.ezSmallNavyLink
        (DEPRECATED) a.ez-button-link-small-navy
        (DEPRECATED) a.ezSmallNavyLinkDisabled
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Link Button]
|   ezButtonLink_default-small-navy
|   (DEPRECATED) ez-button-link-small-navy
|   (DEPRECATED) ezSmallNavyLink
------------------------------------------------- */
a.ezButtonLink_default-small-navy,
a.ezSmallNavyLink,
a.ez-button-link-small-navy {
  color: var(--ezClockerNavy);
  font-family: var(--ezFontFamily);
  text-decoration: none;
  font-size: 10pt;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

a.ezButtonLink_default-small-navy:hover,
a.ezSmallNavyLink:hover,
a.ez-button-link-small-navy:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezButtonLink_default-small-navy:hover:enabled,
a.ezSmallNavyLink:hover:enabled,
a.ez-button-link-small-navy:hover:enabled {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezButtonLink_default-small-navy:hover:active,
a.ezSmallNavyLink:hover:active,
a.ez-button-link-small-navy:hover:active {
  color: var(--ezDarkNavy);
  text-decoration: underline;
}

a.ezButtonLink_default-small-navy:visited,
a.ezSmallNavyLink:visited,
a.ez-button-link-small-navy:visited {
  color: var(--ezClockerNavy);
  text-decoration: none;
}

a.ezButtonLink_default-small-navy:disabled,
a.ezSmallNavyLink:disabled,
a.ez-button-link-small-navy:disabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/* DEPRECATED:  */
a.ezSmallNavyLinkDisabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Action Link Buttons
    Classes:
        a.ezButtonLink_action-normal-green
        (DEPRECATED) a.ezActionLink
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Link Button]
|   ezButtonLink_action-normal-green
|   (DEPRECATED) ezActionLink
------------------------------------------------- */
a.ezButtonLink_action-normal-green:link,
a.ezActionLink:link {
  margin: 0;
  padding: 8px;
  background-color: var(--ezActionGreen);
  text-decoration: none;
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  border-radius: 3px;
}

a.ezButtonLink_action-normal-green:hover:enabled,
a.ezActionLink:hover:enabled {
  background-color: var(--ezHoverHotGreen);
}

a.ezButtonLink_action-normal-green:hover:active,
a.ezActionLink:hover:active {
  background-color: var(--ezDarkHotGreen);
}

a.ezButtonLink_action-normal-green:visited,
a.ezActionLink:visited {
  margin: 0;
  padding: 8px;
  text-decoration: none;
  background-color: var(--ezActionGreen);
  font-style: normal;
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Download Link Buttons
    Classes:
        a.ezButtonLink_download-normal-navy
        (DEPRECATED) a.ezDownloadLink
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:link,
a.ezDownloadLink:link {
  margin: 0;
  padding: 8px;
  background-color: var(--ezClockerNavy);
  text-decoration: none;
  color: var(--ezClockerWhite);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover:enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:hover:enabled,
a.ezDownloadLink:hover:enabled {
  background-color: var(--ezHoverNavy);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:hover:active,
a.ezDownloadLink:hover:active {
  background-color: var(--ezDarkNavy);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:visited,
a.ezDownloadLink:visited {
  margin: 0;
  padding: 8px;
  text-decoration: none;
  background-color: var(--ezClockerNavy);
  font-style: normal;
  color: var(--ezClockerWhite);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

a.ezButtonLink_download-normal-navy:disabled,
a.ezDownloadLink:disabled {
  background-color: var(--ezLightNavy);
  color: var(--ezClockerSilver);
  border-color: var(--ezLightNavy);
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Help/More Info Link Buttons
    Classes:
        a.ezButton-what-is-this-link
        a.ezButton-what-is-this-link-margin-top4px
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link {
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: small;
  text-decoration: none;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link:hover {
  text-decoration: underline;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link-margin-top4px
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link-margin-top4px {
  margin-top: 4px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: small;
  text-decoration: none;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link-margin-top4px
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link-margin-top4px:hover {
  text-decoration: underline;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-show-more-details-link {
  /* top right bottom left */
  padding: 4px 4px 4px 18px;
  background-color: transparent;
  background-size: 10px 10px;
  background-position: 4px center;
  background-repeat: no-repeat;
  background-image: url("/public/images/icons/expand-ezClockerNavy.svg");
  /* --ezClockerNavy from ez-body.css */
  color: var(--ezClockerNavy);
  font-weight: normal;
  /* --ezSmallFontSize from ez-text.css */
  font-size: var(--ezSmallFontSize);
  text-decoration: none;
  border-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-show-more-details-link:hover {
  text-decoration: underline;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Input Buttons
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <input type="button"/>
    Name Templates:
        ezButtons-{name}-{color}
        ezButtons-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Major Input Buttons
    ===================================================================================================================
*/
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Input Buttons
| HTML Tags: <input type="button"/>
|-------------------------------------------------
| Template: ezInputButton_{name}-{size}-{color}
|
| Official Classes:
|   ezInputButton_major-normal-orange
|   ezInputButton_action-normal-ezActionGreen
|
| Deprecated Classes:
|   ez-major-button
|   ez-action-button
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
/*-------------------------------------------------
| [Input Button]
|   ezInputButton_major-normal-orange
|   (DEPRECATED) ez-major-button
------------------------------------------------- */
/* DEPRECATED:  */
input[type=button].ez-major-button,
input[type=button].ezInputButton_major-normal-orange {
  /* ez-major-button style */
  display: inline-block;
  background-color: var(--ezClockerOrange);
  padding: 6px 24px;
  font-family: var(--ezButtons-font-family);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  text-decoration: none;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
  border-radius: 3px;
}

/* DEPRECATED:  */
input[type=button].ez-major-button:hover:enabled,
input[type=button].ezInputButton_major-normal-orange:hover:enabled {
  background-color: #ffcc66;
}

/* DEPRECATED:  */
input[type=button].ez-major-button:hover:active,
input[type=button].ezInputButton_major-normal-orange:hover:active {
  background-color: #ff9933;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Action Input Buttons
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Input Button]
|   ezInputButton_action-normal-ezActionGreen
|   (DEPRECATED) ez-action-button
------------------------------------------------- */
input[type=button].ez-action-button,
input[type=button].ezInputButton_action-normal-ezActionGreen {
  background-color: var(--ezActionGreen);
  border: 1px solid var(--ezActionGreenBorderColor);
  display: inline-block;
  cursor: pointer;
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
  border-radius: 3px;
}

input[type=button].ez-action-button:hover:enabled,
input[type=button].ezInputButton_action-normal-ezActionGreen:hover:enabled {
  background-color: var(--ezActionGreenHoverColor);
}

input[type=button].ez-action-button:hover:active,
input[type=button].ezInputButton_action-normal-ezActionGreen:hover:active {
  color: var(--ezActionGreenHoverColor);
  background-color: var(--ezActionGreenBorderColor);
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Edit Input Buttons
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Input Button]
|   ezInputButton_edit-normal-ezClockerOffWhite
|   (DEPRECATED) ez-edit-button
------------------------------------------------- */
input[type=button].ezInputButton_edit-normal-ezClockerOffWhite,
input[type=button].ez-edit-button {
  display: inline-block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 12px;
  font-weight: normal;
  text-decoration: none;
  border: 1px solid var(--ezBorderOffWhite);
  cursor: pointer;
  border-radius: 3px;
}

input[type=button].ezInputButton_edit-normal-ezClockerOffWhite:hover:enabled,
input[type=button].ez-edit-button:hover:enabled {
  background-color: var(--ezHoverOffWhite);
}

input[type=button].ezInputButton_edit-normal-ezClockerOffWhite:hover:active,
input[type=button].ez-edit-button:hover:active {
  background-color: var(--ezDarkOffWhite);
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Button Classes
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <button/>
    Name Templates:
        ezButtons-{name}-{color}
        ezButtons-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button,
button:enabled,
button.ezButton-default-ezClockerOrange,
button.ezButton-default-ezClockerOrange:enabled,
button.ezButton,
button.ezButton:enabled,
button.ezButton_default-normal-ezClockerOrange,
button.ezButton_default-normal-ezClockerOrange:enabled {
  padding: 6px 24px;
  margin: 2px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 10pt;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:enabled:focus,
button.ezButton-default-ezClockerOrange:enabled:focus,
button.ezButton:enabled:focus,
button.ezButton_default-normal-ezClockerOrange:enabled:focus {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  /* box-shadow: 0 0 1px 1px transparent; */
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:enabled:hover,
button:enabled:focus:hover,
button.ezButton-default-ezClockerOrange:enabled:hover,
button.ezButton-default-ezClockerOrange:enabled:focus:hover,
button.ezButton:enabled:hover,
button.ezButton:enabled:focus:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:focus:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:enabled:active,
button:enabled:active:hover,
button:enabled:focus:active,
button:enabled:focus:active:hover,
button.ezButton-default-normal-ezClockerOrange:enabled:active,
button.ezButton-default-normal-ezClockerOrange:enabled:active:hover,
button.ezButton-default-normal-ezClockerOrange:enabled:focus:active,
button.ezButton-default-normal-ezClockerOrange:enabled:focus:active:hover,
button.ezButton:enabled:active,
button.ezButton:enabled:active:hover,
button.ezButton:enabled:focus:active,
button.ezButton:enabled:focus:active:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:active,
button.ezButton_default-normal-ezClockerOrange:enabled:active:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:focus:active,
button.ezButton_default-normal-ezClockerOrange:enabled:focus:active:hover {
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px rgba(198, 118, 0, 0.5);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:disabled,
button:disabled:hover,
button.ezButton-default-normal-ezClockerOrange:disabled,
button.ezButton-default-normal-ezClockerOrange:disabled:hover,
button.ezButton:disabled,
button.ezButton:disabled:hover,
button.ezButton_default-normal-ezClockerOrange:disabled,
button.ezButton_default-normal-ezClockerOrange:disabled:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  border-color: var(--ezClockerOrange);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.disabledButton
        (DEPRECATED) button.ezDisabledButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.disabledButton  */
button.disabledButton,
button.disabledButton:disabled,
button.disabledButton:disabled:hover,
button.ezDisabledButton,
button.ezDisabledButton:disabled,
button.ezDisabledButton:disabled:hover {
  padding: 6px 24px;
  margin: 2px;
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  font-family: var(--ezButtons-font-family);
  font-size: 10pt;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezClockerOrange);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: default;
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Header Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange,
button.ezButtons-header-ezClockerOrange:enabled,
button.ezHeaderButton,
button.ezHeaderButton:enabled,
button.headerButton,
button.headerButton:enabled {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:enabled:focus,
button.ezHeaderButton:enabled:focus,
button.headerButton:enabled:focus {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:enabled:hover,
button.ezButtons-header-ezClockerOrange:enabled:focus:hover,
button.headerButton:enabled:hover,
button.headerButton:enabled:focus:hover,
button.ezHeaderButton:enabled:hover,
button.ezHeaderButton:enabled:focus:hover {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:enabled:active,
button.ezButtons-header-ezClockerOrange:enabled:active:hover,
button.ezButtons-header-ezClockerOrange:enabled:focus:active,
button.ezButtons-header-ezClockerOrange:enabled:focus:active:hover,
button.ezHeaderButton:enabled:active,
button.ezHeaderButton:enabled:active:hover,
button.ezHeaderButton:enabled:focus:active,
button.ezHeaderButton:enabled:focus:active:hover,
button.headerButton:enabled:active,
button.headerButton:enabled:active:hover,
button.headerButton:enabled:focus:active,
button.headerButton:enabled:focus:active:hover {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:disabled,
button.ezButtons-header-ezClockerOrange:disabled:hover,
button.ezHeaderButton:disabled,
button.ezHeaderButton:disabled:hover,
button.headerButton:disabled,
button.headerButton:disabled:hover {
  font-size: 12pt;
  font-weight: normal;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledHeaderButton
        (DEPRECATED) button.disabledHeaderButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.ezDisabledHeaderButton */
button.ezDisabledHeaderButton,
button.ezDisabledHeaderButton:disabled,
button.ezDisabledHeaderButton:disabled:hover,
button.disabledHeaderButton,
button.disabledHeaderButton:disabled,
button.disabledHeaderButton:disabled:hover {
  font-size: 12pt;
  font-weight: normal;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-down-ezClockerOrange
        (DEPRECATED) button.ezHeaderButtonDown
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
        :enabled:hover,
        :enabled:active,
        :enabled:focus,
        :disabled,
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-down-ezClockerOrange,
button.ezButtons-header-down-ezClockerOrange:enabled,
button.ezButtons-header-down-ezClockerOrange:enabled:hover,
button.ezButtons-header-down-ezClockerOrange:enabled:active,
button.ezButtons-header-down-ezClockerOrange:enabled:focus,
button.ezHeaderButtonDown,
button.ezHeaderButtonDown:enabled,
button.ezHeaderButtonDown:enabled:hover,
button.ezHeaderButtonDown:enabled:active,
button.ezHeaderButtonDown:enabled:focus,
button.ezHeaderButtonDown:disabled,
button.ezHeaderButtonDown:disabled:hover {
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  color: var(--ezClockerBlack);
  background-color: var(--ezDimOrange);
  border-left-color: var(--ezBorderOrange);
  border-top-color: var(--ezBorderOrange);
  border-right-color: var(--ezOrange);
  border-bottom-color: var(--ezOrange);
}

/*

/*
====================================================================================================================
| [Class Group]
| EzClocker Toggle Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezLargeToggleButton-2col-container
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-toggle-button-large-2col-container {
  display: grid;
  grid-template-columns: auto auto;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
  justify-content: center;
  align-content: center;
  margin: 10px 10px 0;
  padding: 10px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-size: 14pt;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-unselected,
button.ezButtons-toggle-button-large-unselected:enabled {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-toggle-button-large-unselected:enabled:hover,
.ezButtons-toggle-button-large-unselected:enabled:focus:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-unselected:enabled:active,
button.ezButtons-toggle-button-large-unselected:enabled:active:hover,
button.ezButtons-toggle-button-large-unselected:enabled:focus:active,
button.ezButtons-toggle-button-large-unselected:enabled:focus:active:hover {
  background-color: var(--ezHoverNavy);
  color: var(--ezClockerWhite);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  outline-color: var(--ezNavy-alpha-50);
  outline-width: 1px;
  outline-style: auto;
  outline-offset: 2px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-unselected:disabled,
button.ezButtons-toggle-button-large-unselected:disabled:hover {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerGray);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerSilver);
  border-radius: 3px;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-selected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
        :enabled:hover
        :enabled:active,
        :enabled:active:hover
        :enabled:focus
        :enabled:focus:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-selected,
button.ezButtons-toggle-button-large-selected:enabled,
button.ezButtons-toggle-button-large-selected:enabled:hover,
button.ezButtons-toggle-button-large-selected:enabled:active,
button.ezButtons-toggle-button-large-selected:enabled:active:hover,
button.ezButtons-toggle-button-large-selected:enabled:focus,
button.ezButtons-toggle-button-large-selected:enabled:focus:hover,
button.ezButtons-toggle-button-large-selected:enabled:focus:active,
button.ezButtons-toggle-button-large-selected:enabled:focus:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-width: 2px;
  box-shadow: none;
  outline-style: none;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-selected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-selected:disabled,
button.ezButtons-toggle-button-large-selected:disabled:hover {
  background-color: var(--ezHoverNavy);
  color: var(--ezBorderNavy);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezClockerNavy);
  box-shadow: none;
  outline-style: none;
  cursor: default;
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Major Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-major-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow,
.ezButtons-major-mini-ezClockerYellow:enabled,
button.ezMiniMajorButton,
button.ezMiniMajorButton:enabled,
button.miniMajorButton,
button.miniMajorButton:enabled {
  font-size: 8pt;
  font-weight: bold;
  background-color: var(--ezClockerYellow);
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-major-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow:enabled:hover,
button.ezButtons-major-mini-ezClockerYellow:enabled:active:hover,
button.ezMiniMajorButton:enabled:hover,
button.ezMiniMajorButton:enabled:active:hover,
button.miniMajorButton:enabled:hover,
button.miniMajorButton:enabled:active:hover {
  background-color: var(--ezLightYellow);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:focus:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow:enabled:active,
button.ezButtons-major-mini-ezClockerYellow:enabled:focus:active,
button.ezMiniMajorButton:enabled:active,
button.miniMajorButton:enabled:focus:active {
  background-color: var(--ezLightYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow:disabled,
button.ezButtons-major-mini-ezClockerYellow:disabled:hover,
button.ezMiniMajorButton:disabled,
button.ezMiniMajorButton:disabled:hover,
button.miniMajorButton:disabled,
button.miniMajorButton:disabled:hover {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledMiniMajorButton
        (DEPRECATED) button.disabledMiniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.ezDisabledMiniMajorButton */
button.ezDisabledMiniMajorButton,
button.ezDisabledMiniMajorButton:disabled,
button.ezDisabledMiniMajorButton:disabled:hover,
button.disabledMiniMajorButton:disabled,
button.disabledMiniMajorButton:disabled:hover,
button.disabledMiniMajorButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Mini Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow,
button.ezButtons-default-mini-ezClockerYellow:enabled,
button.ezMiniNormalButton,
button.ezMiniNormalButton:enabled,
button.miniNormalButton,
button.miniNormalButton:enabled {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 8pt;
  font-weight: normal;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow:enabled:hover,
button.ezButtons-default-mini-ezClockerYellow:enabled:focus:hover,
button.ezMiniNormalButton:enabled:hover,
button.ezMiniNormalButton:enabled:focus:hover,
button.miniNormalButton:enabled:hover,
button.miniNormalButton:enabled:focus:hover {
  background-color: var(--ezLightYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow:enabled:active,
button.ezMiniNormalButton:enabled:active,
button.miniNormalButton:enabled:active {
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow:disabled,
button.ezButtons-default-mini-ezClockerYellow:disabled:hover,
button.ezMiniNormalButton:disabled,
button.ezMiniNormalButton:disabled:hover,
button.miniNormalButton:disabled,
button.miniNormalButton:disabled:hover {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledMiniNormalButton
        (DEPRECATED) button.disabledMiniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.disabledMiniNormalButton */
button.ezDisabledMiniNormalButton,
button.ezDisabledMiniNormalButton:disabled,
button.ezDisabledMiniNormalButton:disabled:hover,
button.disabledMiniNormalButton,
button.disabledMiniNormalButton:disabled,
button.disabledMiniNormalButton:disabled:hover {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDialogButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDialogButton {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  border-radius: 3px;
}

button.ezDialogButton:hover {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.ezDialogButton:active {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.ezDialogButton:disabled {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
}

button.ezDisabledDialogButton {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
  border-radius: 3px;
}

button.ezWhiteDialogButton {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  border-radius: 3px;
}

button.ezWhiteDialogButton:hover {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.ezWhiteDialogButton:hover:active,
button.ezWhiteDialogButton:active {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  box-shadow: var(--ezBoxShadow-inset-ezclocker-black-50);
}

button.ezWhiteDialogButton:disabled {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerStone);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
}

button.ezDisabledWhiteDialogButton {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerStone);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
  border-radius: 3px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezMajorButton,
button.ezMajorButton:enabled,
button.majorButton,
button.majorButton:enabled {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

button.ezMajorButton:enabled:focus,
button.majorButton:enabled:focus {
  font-weight: bold;
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  background-color: var(--ezLightYellow);
}

button.ezMajorButton:enabled:hover,
button.ezMajorButton:enabled:focus:hover,
button.majorButton:enabled:hover,
button.majorButton:enabled:focus:hover {
  font-weight: bold;
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  background-color: var(--ezLightYellow);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezMajorButton:enabled:active,
button.ezMajorButton:enabled:active:hover,
button.ezMajorButton:enabled:focus:active,
button.ezMajorButton:enabled:focus:active:hover,
button.majorButton:enabled:active,
button.majorButton:enabled:active:hover,
button.majorButton:enabled:focus:active,
button.majorButton:enabled:focus:active:hover {
  font-weight: bold;
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  background-color: var(--ezLightYellow);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezMajorButton:disabled,
button.ezMajorButton:disabled:hover,
button.ezMajorButton:disabled:active,
button.majorButton:disabled,
button.majorButton:disabled:hover,
button.majorButton:disabled:active {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 10pt;
  font-family: var(--ezButtons-font-family);
  border-color: var(--ezDarkYellow);
  cursor: default;
  box-shadow: none;
}

/* DEPRECATED: button.ezDisabledMajorButton */
button.ezDisabledMajorButton,
button.disabledMajorButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 10pt;
  font-family: var(--ezButtons-font-family);
  border-color: var(--ezDarkYellow);
  cursor: default;
  box-shadow: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezNormalButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezNormalButton {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

button.ezNormalButton:hover:enabled {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezNormalButton:focus {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
}

button.ezNormalButton:hover,
button.ezNormalButton:hover:active {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezNormalButton:disabled,
button.ezNormalButton:disabled:hover,
button.ezNormalButton:disabled:hover:active {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezDarkYellow);
  box-shadow: none;
  cursor: default;
}

button.ezDisabledNormalButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  border-color: var(--ezDarkYellow);
  border-radius: 3px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezNormalButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDefaultNormalButton {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

button.ezDefaultNormalButton:hover:enabled {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezDefaultNormalButton:focus {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
}

button.ezDefaultNormalButton:hover,
button.ezDefaultNormalButton:hover:active {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezDefaultNormalButton:disabled,
button.ezDefaultNormalButton:disabled:hover,
button.ezDefaultNormalButton:disabled:active {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezDarkYellow);
  box-shadow: none;
  cursor: default;
}

button.ezDisabledDefaultNormalButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezDarkYellow);
  border-radius: 3px;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezTealMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezTealMajorButton {
  background-color: var(--ezClockerTeal);
  color: var(--ezTealContainerTextColor);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  border-radius: 3px;
}

button.ezTealMajorButton:hover:enabled {
  color: var(--ezClockerBlack);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  background-color: var(--ezTealHover);
  box-shadow: var(--ezTealBoxShadow);
}

button.ezTealMajorButton:focus {
  color: var(--ezTealContainerTextColor);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  background-color: var(--ezTealHover);
}

button.ezTealMajorButton:hover,
button.ezTealMajorButton:hover:active {
  color: var(--ezTealContainerTextColor);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  background-color: var(--ezTealHover);
  box-shadow: var(--ezTealInsetBoxShadow);
}

button.ezTealMajorButton:disabled,
button.ezTealMajorButton:disabled:hover,
button.ezTealMajorButton:disabled:active {
  background-color: var(--ezDarkteal);
  color: var(--ezTealContainerDisabledTextColor);
  font-size: 10pt;
  font-weight: normal;
  border-color: var(--ezTealBorder);
  box-shadow: none;
  cursor: default;
}

button.ezTealMajorButtonDisabled {
  background-color: var(--ezDarkteal);
  color: var(--ezTealContainerDisabledTextColor);
  font-size: 10pt;
  font-weight: normal;
  border-color: var(--ezTealBorder);
  box-shadow: none;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWarningMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWarningMajorButton,
button.warningMajorButton {
  font-weight: bold;
  background-color: #CE0F0C;
  border-color: #A60400;
  color: var(--ezClockerWhite);
  border-radius: 3px;
}

button.ezWarningMajorButton:hover:enabled,
button.warningMajorButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
}

button.ezWarningMajorButton:hover:active,
button.warningMajorButton:hover:active {
  color: var(--ezClockerWhite);
  background-color: #BF3330;
}

button.ezWarningMajorButton:disabled,
button.ezWarningMajorButton:disabled:hover,
button.ezWarningMajorButton:disabled:active button.warningMajorButton:disabled button.warningMajorButton:disabled:hover,
button.warningMajorButton:disabled:active {
  color: var(--ezClockerStone);
  background-color: #FFf0f0;
  border-color: var(--ezClockerStone);
  font-weight: normal;
  box-shadow: none;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDeleteMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDeleteMajorButton,
button.ezDeleteMajorButton:enabled,
button.deleteMajorButton,
button.deleteMajorButton:enabled {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteMajorButton:enabled:focus,
button.deleteMajorButton:enabled:focus {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
}

button.ezDeleteMajorButton:enabled:hover,
button.ezDeleteMajorButton:enabled:focus:hover,
button.deleteMajorButton:enabled:hover,
button.deleteMajorButton:enabled:focus:hover {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezDeleteMajorButton:enabled:active,
button.ezDeleteMajorButton:enabled:active:hover,
button.ezDeleteMajorButton:enabled:focus:active,
button.ezDeleteMajorButton:enabled:focus:active:hover,
button.deleteMajorButton:enabled:active,
button.deleteMajorButton:enabled:active:hover,
button.deleteMajorButton:enabled:focus:active,
button.deleteMajorButton:enabled:focus:active:hover {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);
}

button.ezDeleteMajorButton:disabled,
button.ezDeleteMajorButton:disabled:hover,
button.deleteMajorButton:disabled,
button.deleteMajorButton:disabled:hover {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezHoverAlertRed);
  color: var(--ezBorderAlertRed);
  font-size: 10pt;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
  box-shadow: none;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWarningHeaderButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWarningHeaderButton,
button.warningHeaderButton {
  vertical-align: middle;
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
  background-color: #CE0F0C;
  border-color: #BF3330;
  border-radius: 3px;
}

button.ezWarningHeaderButton:hover:enabled,
button.warningHeaderButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezWarningHeaderButton:focus,
button.warningHeaderButton:focus {
  background-color: var(--ezClockerAlertRed);
}

button.ezWarningHeaderButton:hover:active,
button.warningHeaderButton:hover:active {
  box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);
}

button.ezWarningHeaderButton:disabled,
button.warningHeaderButton:disabled {
  color: #BF3330;
  background-color: var(--ezClockerAlertRed);
  border-color: #BF3330;
  font-weight: normal;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezLargeToolButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezLargeToolButton {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezLargeToolButton:hover,
button.ezLargeToolButton:hover:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezHoverNavy);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
}

button.ezLargeToolButton:active,
button.ezLargeToolButton:hover:active {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  box-shadow: inset 0 0 4px 2px rgba(6, 56, 97, 0.5);
}

button.ezLargeToolButton:disabled {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerSilver);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezLightNavy);
  cursor: default;
}

button.disabledEzLargeToolButton {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: #063565;
  color: #0d58a6;
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: #0d58a6;
  cursor: default;
  border-radius: 3px;
}

button.ezRedLargeToolButton {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: #ff7673;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: #a60400;
  border-radius: 3px;
}

button.ezRedLargeToolButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
}

button.ezRedLargeToolButton:hover:active {
  background-color: #BF3330;
}

button.ezRedLargeToolButton:disabled {
  background-color: var(--ezClockerOffWhite);
  color: #808080;
  border-color: var(--ezClockerStone);
  cursor: default;
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Tool Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy,
.ezButtons-tool-navy:enabled,
.ezToolButton,
.ezToolButton:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:enabled:focus,
.ezToolButton:enabled:focus {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: var(--ezFocusBoxShadowBlack);
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:enabled:hover,
.ezButtons-tool-navy:enabled:focus:hover,
.ezToolButton:enabled:hover,
.ezToolButton:enabled:focus:hover {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezHoverNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:enabled:active,
.ezButtons-tool-navy:enabled:active:hover,
.ezButtons-tool-navy:enabled:focus:active,
.ezButtons-tool-navy:enabled:focus:active:hover,
.ezToolButton:enabled:active,
.ezToolButton:enabled:active:hover,
.ezToolButton:enabled:focus:active,
.ezToolButton:enabled:focus:active:hover {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:disabled,
.ezButtons-tool-navy:disabled:hover,
.ezToolButton:disabled,
.ezToolButton:disabled:hover {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezHoverNavy);
  opacity: 0.5;
  color: var(--ezBorderNavy);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy-large
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large,
.ezButtons-tool-navy-large:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:enabled:focus {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:enabled:hover,
.ezButtons-tool-navy-large:enabled:focus:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezHoverNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:enabled:active,
.ezButtons-tool-navy-large:enabled:active:hover,
.ezButtons-tool-navy-large:enabled:focus:active,
.ezButtons-tool-navy-large:enabled:focus:active:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:disabled,
.ezButtons-tool-navy-large:disabled:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezHoverNavy);
  opacity: 0.5;
  color: var(--ezBorderNavy);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: default;
}

button.ezRedToolButton,
button.ezRedToolButton:enabled {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
}

button.ezRedToolButton:enabled:focus {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezRedToolButton:enabled:hover,
button.ezRedToolButton:enabled:focus:hover {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezRedToolButton:enabled:active,
button.ezRedToolButton:enabled:active:hover,
button.ezRedToolButton:enabled:focus:active,
button.ezRedToolButton:enabled:focus:active:hover {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px var(--ezBorderAlertRed-alpha-50);
  outline-width: 0;
}

button.ezRedToolButton:disabled,
button.ezRedToolButton:disabled:hover {
  opacity: 0.5;
  padding: 0;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezHoverAlertRed);
  color: var(--ezClockerGray);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerGray);
  cursor: default;
}

button.ezTransparentToolButton {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: transparent;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: rgba(255, 255, 255, 0.2);
}

button.ezTransparentToolButton:hover:enabled {
  background-color: transparent;
  color: var(--ezClockerWhite);
  border-color: var(--ezClockerWhite);
}

button.ezTransparentToolButton:focus button.ezTransparentToolButton:active {
  background-color: transparent;
  color: var(--ezClockerWhite);
  border-color: var(--ezClockerWhite);
  box-shadow: none;
}

button.ezTransparentToolButton:hover:active {
  background-color: transparent;
  color: var(--ezClockerWhite);
  border-color: var(--ezClockerWhite);
  box-shadow: inset 0 0 4px 2px rgba(255, 255, 255, 0.5);
}

button.ezTransparentToolButton:hover:disabled,
button.ezTransparentToolButton:active:disabled,
button.ezTransparentToolButton:disabled {
  opacity: 0.5;
  padding: 0;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: transparent;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: transparent;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButton-hidden-egg
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezButton-hidden-egg {
  padding: 4px;
  margin: 0;
  background-color: transparent;
  min-width: 18px;
  min-height: 18px;
  color: transparent;
  font-size: xx-small;
  vertical-align: middle;
  text-align: center;
  border-style: none;
  cursor: url("/secure/account/hack.cur"), auto;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezEditButton,
button.ezEditButton:enabled,
button.editButton,
button.editButton:enabled {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerYellow);
  min-width: 75px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerBlack);
  border-radius: 3px;
}

button.ezEditButton:enabled:focus,
button.editButton:enabled:focus {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightYellow);
  min-width: 75px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerBlack);
  border-radius: 3px;
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezEditButton:enabled:hover,
button.ezEditButton:enabled:focus:hover,
button.editButton:enabled:hover,
button.editButton:enabled:focus:hover {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  text-align: center;
  font-size: 10pt;
  vertical-align: middle;
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezEditButton:enabled:active,
button.ezEditButton:enabled:active:hover,
button.ezEditButton:enabled:focus:active,
button.ezEditButton:enabled:focus:active:hover,
button.editButton:enabled:active,
button.editButton:enabled:active:hover,
button.editButton:enabled:focus:active,
button.editButton:enabled:focus:active:hover {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  text-align: center;
  font-size: 10pt;
  vertical-align: middle;
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezEditButton:disabled,
button.ezEditButton:disabled:hover,
button.ezEditButton:disabled:active,
button.editButton:disabled,
button.editButton:disabled:hover,
button.editButton:disabled:active {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderYellow);
  cursor: default;
}

button.ezDisabledEditButton,
button.disabledEditButton {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderYellow);
  cursor: default;
  border-radius: 3px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSquareEditButton {
  width: 28px;
  height: 28px;
  padding: 4px;
  padding-left: 3px;
  margin: 1px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
}

button.ezSquareEditButton:hover:enabled {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezSquareEditButton:focus {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
}

button.ezSquareEditButton:hover:active {
  padding: 4px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezSquareEditButton:disabled {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  cursor: default;
}

button.ezDisabledSquareEditButton {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
  cursor: default;
}

img.ezSquarEditButtonImg {
  width: 20px;
  height: 20px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-edit-navy-24x24
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezButtons-edit-navy-24x24 {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezButtons-edit-navy-24x24:hover:enabled {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezButtons-edit-navy-24x24:focus {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: middle;
}

button.ezButtons-edit-navy-24x24:hover:active {
  padding: 4px;
  width: 24px;
  height: 24px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezButtons-edit-navy-24x24:disabled {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  cursor: default;
}

button.ezButtons-edit-navy-24x24-disabled {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: default;
}

img.ezButtons-square-img-24x24 {
  padding: 0;
  margin: 0;
  text-align: center;
  vertical-align: center;
  width: 24px;
  height: 24px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-edit-navy-24x48
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezButtons-edit-navy-24x48 {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezButtons-edit-navy-24x48:hover:enabled {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezButtons-edit-navy-24x48:focus {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  text-align: center;
  vertical-align: middle;
  font-size: 10pt;
}

button.ezButtons-edit-navy-24x48:hover:active {
  padding: 4px;
  width: 48px;
  height: 24px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezButtons-edit-navy-24x48:disabled {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  cursor: default;
}

button.ezButtons-edit-navy-24x48-disabled {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: default;
}

img.ezButtons-square-img-24xA {
  padding: 0;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  height: 24px;
  width: auto;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-edit-navy-48x48
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezButtons-edit-navy-48x48 {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezButtons-edit-navy-48x48:hover:enabled {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezButtons-edit-navy-48x48:focus {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: middle;
}

button.ezButtons-edit-navy-48x48:hover:active {
  padding: 4px;
  width: 48px;
  height: 48px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezButtons-edit-navy-48x48:disabled {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  cursor: default;
}

button.ezButtons-edit-navy-48x48-disabled {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: default;
}

img.ezButtons-square-img-48xA {
  padding: 0;
  margin: 0;
  height: 48px;
  width: auto;
  text-align: center;
  vertical-align: center;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDeleteEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezButtons-delete-button {
  padding: 4px;
  margin: 1px;
  background-color: #ff7673;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: #a60400;
  border-radius: 3px;
}

.ezButtons-delete-button:hover:enabled {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
}

.ezButtons-delete-button:hover:active {
  padding: 4px;
  margin: 1px;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  background-color: #BF3330;
}

.ezButtons-delete-button:disabled {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerOffWhite);
  color: #808080;
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerStone);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDeleteEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDeleteEditButton,
button.ezDeleteEditButton:enabled {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteEditButton:enabled:focus {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezDeleteEditButton:enabled:hover,
button.ezDeleteEditButton:enabled:focus:hover {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteEditButton:enabled:active,
button.ezDeleteEditButton:enabled:active:hover,
button.ezDeleteEditButton:enabled:focus:active,
button.ezDeleteEditButton:enabled:focus:active:hover {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteEditButton:disabled,
button.ezDeleteEditButton:disabled:hover,
button.ezDeleteEditButton:disabled:active {
  opacity: 50%;
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezBorderAlertRed);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezMiniActionButton styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezMiniActionButton,
button.miniActionButton {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: pointer;
  border-radius: 3px;
}

button.ezMiniActionButton:enabled:hover,
button.miniActionButton:enabled:hover {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezLightSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.3);
}

button.ezMiniActionButton:enabled:focus,
button.miniActionButton:enabled:focus {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezLightSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  outline-color: var(--ezClockerSilver-alpha-50);
}

button.miniActionButton:enabled:active,
button.ezMiniActionButton:enabled:active:hover,
button.miniActionButton:enabled:active:hover {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.5);
}

button.ezMiniActionButton:disabled,
button.ezMiniActionButton:disabled:active,
button.ezMiniActionButton:disabled:active:hover,
button.ezMiniActionButton:disabled:hover,
button.miniActionButton:disabled,
button.miniActionButton:disabled:hover,
button.miniActionButton:disabled:active,
button.miniActionButton:disabled:active:hover {
  padding: 2px;
  margin: 0;
  background-color: rgba(224, 224, 224, 0.5);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
  /*
  padding: 2px;
  margin: 0;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerStone);
  font-size: 10pt;
  font-weight: normal;
  border-color: var(--ezBorderSilver);
  cursor: default;
  */
}

button.ezDisabledMiniActionButton,
button.disabledMiniActionButton {
  opacity: 0.8;
  padding: 2px;
  margin: 0;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerStone);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezSilverActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSilverActionButton {
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: pointer;
  border-radius: 3px;
}

button.ezSilverActionButton:hover,
button.ezSilverActionButton:hover:enabled {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);
  cursor: pointer;
}

button.ezSilverActionButton:focus {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  cursor: pointer;
}

button.ezSilverActionButton:active,
button.ezSilverActionButton:hover:active {
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);
  cursor: pointer;
}

button.ezSilverActionButton:disabled {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezBorderSilver);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

button.ezDisabledSilverActionButton {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezBorderSilver);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezSilverEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSilverEditButton,
button.silverEditButton {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderSilver);
  cursor: pointer;
  border-radius: 3px;
}

button.ezSilverEditButton:focus,
button.ezSilverEditButton:hover:enabled,
button.silverEditButton:hover:enabled {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);
}

button.ezSilverEditButton:active,
button.ezSilverEditButton:active:focus,
button.ezSilverEditButton:hover,
button.ezSilverEditButton:hover:active,
button.ezSilverEditButto:hover:active {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);
}

button.ezSilverEditButton:disabled,
button.silverEditButton:disabled {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezBorderSilver);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezMiniDeleteActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezMiniDeleteActionButton,
button.miniDeleteActionButton {
  font-size: 8pt;
  font-weight: bold;
  padding: 2px;
  margin: 0;
  color: var(--ezClockerWhite);
  background-color: #CE0F0C;
  border-color: #A60400;
  cursor: pointer;
  border-radius: 3px;
}

button.ezMiniDeleteActionButton:hover:enabled,
button.miniDeleteActionButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
}

button.ezMiniDeleteActionButton:hover:active,
button.miniDeleteActionButton:hover:active {
  background-color: #BF3330;
}

button.ezMiniDeleteActionButton:disabled,
button.miniDeleteActionButtonn:disabled {
  color: var(--ezClockerStone);
  background-color: #FFf0f0;
  border-color: var(--ezClockerStone);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-quick-help
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ui-widget button.ezButtons-quick-help,
.ezButtons-quick-help {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-style: none;
  cursor: pointer;
}

.ui-widget button.ezButtons-quick-help:hover,
.ui-widget button.ezButtons-quick-help:focus,
.ui-widget button.ezButtons-quick-help:focus:hover,
.ui-widget button.ezButtons-quick-help:enabled:hover,
.ezButtons-quick-help:hover,
.ezButtons-quick-help:focus,
.ezButtons-quick-help:focus:hover,
.ezButtons-quick-help:enabled:hover {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezClockerSilver);
  border-style: dashed;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

.ui-widget button.ezButtons-quick-help:active,
.ui-widget button.ezButtons-quick-help:active:hover,
.ezButtons-quick-help:active,
.ezButtons-quick-help:active:hover {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezClockerGray);
  border-style: dashed;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

.ui-widget.button.ezButtons-quick-help:disabled,
.ezButtons-quick-help:disabled {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-style: none;
  cursor: pointer;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Action Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen,
button.ezButtons-action-ezActionGreen:enabled,
button.ezActionButton,
button.ezActionButton:enabled,
button.actionButton,
button.actionButton:enabled {
  padding: 6px 24px;
  margin: 0;
  background-color: var(--ezClockerActionGreen);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezActionGreenBorderColor);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Focus]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:enabled:focus,
button.ezActionButton:enabled:focus,
button.actionButton:enabled:focus {
  outline-color: var(--ezActionGreen-alpha-50);
  outline-style: auto;
  outline-width: 1px;
  outline-offset: 2px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Hover and Active Hover]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:enabled:hover,
button.ezButtons-action-ezActionGreen:enabled:focus:hover,
button.ezActionButton:enabled:hover,
button.ezActionButton:enabled:focus:hover,
button.actionButton:enabled:hover,
button.actionButton:enabled:focus:hover {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezActionGreenHoverColor);
  box-shadow: var(--ezBoxShadow-ezGray-30);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:enabled:active,
button.ezButtons-action-ezActionGreen:enabled:active:hover,
button.ezButtons-action-ezActionGreen:enabled:focus:active,
button.ezButtons-action-ezActionGreen:enabled:focus:active:hover,
button.ezActionButton:enabled:active,
button.ezActionButton:enabled:active:hover,
button.ezActionButton:enabled:focus:active,
button.ezActionButton:enabled:focus:active:hover,
button.actionButton:enabled:active,
button.actionButton:enabled:active:hover,
button.actionButton:enabled:focus:active,
button.actionButton:enabled:focus:active:hover {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezActionGreenHoverColor);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-80);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:disabled,
button.ezButtons-action-ezActionGreen:disabled:hover,
button.ezActionButton:disabled,
button.ezActionButton:disabled:hover,
button.actionButton:disabled,
button.actionButton:disabled:hover {
  background-color: var(--ezActionGreenHoverColor);
  color: var(--ezActionGreenBorderColor);
  font-size: 14pt;
  font-weight: normal;
  border-color: var(--ezActionGreenBorderColor);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledActionButton
        (DEPRECATED) button.disabledActionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.ezDisabledActionButton */
button.ezDisabledActionButton,
button.ezDisabledActionButton:disabled,
button.ezDisabledActionButton:disabled:hover,
button.disabledActionButton,
button.disabledActionButton:disabled,
button.disabledActionButton:disabled:hover {
  background-color: var(--ezActionGreenHoverColor);
  color: var(--ezActionGreenBorderColor);
  font-weight: normal;
  border-color: var(--ezActionGreenBorderColor);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow,
button.ezButtons-action-ezClockerYellow:enabled {
  padding: 6px 24px;
  margin: 0;
  background-color: var(--ezClockerYellow);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Focus]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:enabled:focus {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezHoverYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Hover and Active Hover]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:enabled:hover,
button.ezButtons-action-ezClockerYellow:enabled:focus:hover {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezHoverYellow);
  box-shadow: var(--ezBoxShadow-ezGray-30);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:enabled:active,
button.ezButtons-action-ezClockerYellow:enabled:active:hover,
button.ezButtons-action-ezClockerYellow:enabled:focus:active,
button.ezButtons-action-ezClockerYellow:enabled:focus:active:hover {
  font-size: 14pt;
  font-weight: bold;
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:disabled,
button.ezButtons-action-ezClockerYellow:disabled:hover {
  background-color: var(--ezHoverYellow);
  color: var(--ezBorderYellow);
  font-size: 14pt;
  font-weight: normal;
  border-color: var(--ezBorderYellow);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezNavyActionButton {
  padding: 6px 24px;
  margin: 0;
  background-color: var(--ezClockerNavy);
  color: var(--ezNavyContainerTextColor);
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezNavyActionButton:hover:enabled {
  font-weight: bold;
  background-color: var(--ezHoverNavy);
}

button.ezNavyActionButton:focus {
  font-weight: bold;
  background-color: var(--ezHoverNavy);
}

button.ezNavyActionButton:hover:active {
  font-weight: bold;
  box-shadow: var(--ezNavyInsetShadow);
}

button.ezNavyActionButton:disabled {
  background-color: var(--ezLightNavy);
  border-color: var(--ezClockerNavy);
  font-weight: normal;
  color: var(--ezNavyContainerDisabledTextColor);
  cursor: default;
}

button.ezDisabledNavyActionButton {
  background-color: var(--ezLightNavy);
  border-color: var(--ezBorderNavy);
  font-weight: normal;
  color: var(--ezNavyContainerDisabledTextColor);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezSuperActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSuperActionButton,
button.superActionButton {
  margin: 0;
  background-color: var(--ezClockerNavy);
  border-color: var(--ezClockerGray);
  color: var(--ezClockerWhite);
  font-weight: bold;
  font-size: 18pt;
  padding: 6px 24px;
  border-radius: 3px;
}

button.ezSuperActionButton:hover:enabled,
button.superActionButton:hover:enabled {
  background-color: #0d58a6;
}

button.ezSuperActionButton:hover:active,
button.superActionButton:hover:active {
  background-color: #0d58a6;
}

button.ezSuperActionButton:disabled,
button.superActionButton:disabled {
  cursor: default;
  background-color: #5387bd;
  border-color: var(--ezClockerNavy);
  font-weight: normal;
  color: var(--ezClockerNavy);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWizardNavButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWizardNavButton {
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  font-weight: bold;
  border-radius: 3px;
}

button.ezWizardHiddenNavButton {
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  display: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWizardActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWizardActionButton {
  /* background-color: var(--ezClockerHotGreen); */
  background-color: var(--ezDarkHotGreen);
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  font-weight: bold;
  /* color: var(--ezHotGreenContainerFontColor) */
  color: var(--ezClockerBlack);
  /* border-color: var(--ezBorderHotGreen); */
  border-color: var(--ezBorderHotGreen);
  border-radius: 3px;
}

button.ezWizardHiddenActionButton {
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  display: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| DIV Button
| HTML Tags: <div/>
|-------------------------------------------------
| Template: ezDivButton_{name}-{size}-{color}
|
| Official Classes:
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="")
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="UNSELECTED")
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="SELECTED")
|
| Deprecated Classes:
|   ez-navy-left-nav-button (data-state="")
|   ez-navy-left-nav-button (data-state="UNSELECTED")
|   ez-navy-left-nav-button (data-state="SELECTED")
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="")
|   (DEPRECATED) ez-navy-left-nav-button (data-state="")
------------------------------------------------- */
/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""],
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""] {
  padding-left: 8px;
  padding-top: 14px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin: 0;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: normal;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:enabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:hover {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:enabled:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:focus {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:enabled:active,
.ez-navy-left-nav-button[data-state=""]:enabled:active:focus,
.ez-navy-left-nav-button[data-state=""]:enabled:active:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:active,
.ezDivButton_LeftNavv-normal-ezClockerNavy[data-state=""]:enabled:active:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:disabled,
.ez-navy-left-nav-button[data-state=""]:disabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:disabled,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:disabled:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerGray);
  cursor: default;
}

/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="UNSELECTED")
|   (DEPRECATED) ez-navy-left-nav-button (data-state="UNSELECTED")
------------------------------------------------- */
/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED],
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED] {
  padding-left: 8px;
  padding-top: 14px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin: 0;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: normal;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:hover {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:focus {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:active,
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:active:focus,
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:active:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:active,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:active:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:disabled,
.ez-navy-left-nav-button[data-state=UNSELECTED]:disabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:disabled,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:disabled:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerGray);
  font-weight: bold;
  cursor: default;
}

/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="SELECTED")
|   (DEPRECATED) ez-navy-left-nav-button (data-state="SELECTED")
------------------------------------------------- */
/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=SELECTED],
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED] {
  padding-left: 8px;
  padding-top: 14px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin: 0;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: bold;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:hover,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:focus,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:active,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:active:focus,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:active:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:active,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:active:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: bold;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=SELECTED]:disabled,
.ez-navy-left-nav-button[data-state=SELECTED]:disabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:disabled,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:disabled:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerGray);
  font-weight: bold;
  cursor: default;
}

/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_Menu-normal-ezClockerOrange
|   (DEPRECATED) div.ezMenuButton
------------------------------------------------- */
/* DEPRECATED: div.ezMenuButton */
div.ezMenuButton,
.ezDivButton_Menu-normal-ezClockerOrange {
  background-color: var(--ezClockerOrange);
  font-family: var(--ezButtons-font-family);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-color: var(--ezBorderOrange);
  border-width: 1px;
  border-radius: 3px;
}

/* DEPRECATED: div.ezMenuButton */
div.ezMenuButton:hover:enabled,
.ezDivButton_Menu-normal-ezClockerOrange:hover:enabled {
  background-color: var(--ezHoverOrange);
}

/* DEPRECATED: div.ezMenuButton */
div.ezMenuButton:hover:active,
.ezDivButton_Menu-normal-ezClockerOrange:hover:active {
  border-width: 1px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Button Content
| HTML Tags: <div/>,<label/>,<span/>
|-------------------------------------------------
| Template: ezButtonContent_{name}-{size}-{color}
|
| Official Classes:
|   ezButtonContent_SubLabel-normal-black
|
| Deprecated Classes:
|   ezButtonSubLabel
|   buttonSubLabel
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED: label.ezButtonSubLabel */
label.ezButtonSubLabel,
label.buttonSubLabel {
  font-weight: normal;
}

.ezButtonContent_SubLabel-normal-black {
  color: var(--ezClockerBlack);
  font-size: 12px;
  font-weight: normal;
}

label.ezEditButtonLabel,
.ezButtonContent_EditLabel-small-black {
  padding-left: 4px;
  padding-right: 2px;
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 10pt;
  cursor: pointer;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Button Images
| HTML Tags: <img/>
|-------------------------------------------------
| Template: ezButtonImage_{size}
|
| Official Classes:
|   ezButtonImage_16x16
|   ezButtonImage_24x24
|   ezBtnImage_24xA
|
| Deprecated Classes:
|   ezEditButtonImage
|   ezLargeEditButtonImage
|   ezMiniButtonImg
|   miniButtonIcon
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED: img.ezEditButtonImage */
img.ezEditButtonImage,
img.ezButtonImage_16x16 {
  margin: 0;
  padding: 0;
  height: 16px;
  width: 16px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezButtonImage-disable_16x16 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 16px;
  width: 16px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage_18x18 {
  margin: 0;
  padding: 0;
  height: 18px;
  width: 18px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage-disable_18x18 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 18px;
  width: 18px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage_20x20 {
  margin: 0;
  padding: 0;
  height: 20px;
  width: 20px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage-disable_20x20 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 20px;
  width: 20px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

/* DEPRECATED: img.ezLargeEditButtonImage */
img.ezLargeEditButtonImage,
img.ezButtonImage_24x24 {
  margin: 0;
  padding: 0;
  height: 24px;
  width: 24px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezButtonImage-disable_24x24 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 24px;
  width: 24px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezMiniButtonImg,
img.miniButtonIcon,
img.ezBtnImage_24xA {
  box-sizing: border-box;
  padding-right: 4px;
  width: 24px;
  vertical-align: middle;
  border-style: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Select Button
| HTML Tags: <select/>
|-------------------------------------------------
| Template: ezSelectButton_{name}-{size}-{color}
|
| Official Classes:
|   ezSelectButton_Default-normal-ezClockerOrange
|
| Deprecated Classes:
|   ezMajorSelectButton
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton,
select.ezSelectButton_Default-normal-ezClockerYellow {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
  /*
  margin: 2px;
  padding: 6px 24px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  outline-width: 0;
  cursor: pointer;
  */
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:hover:enabled,
select.ezSelectButton_Default-normal-ezClockerOrange:hover:enabled {
  background-color: var(--ezLightYellow);
  box-shadow: var(--ezBoxShadowStone);
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:hover:active,
select.ezSelectButton_Default-normal-ezClockerOrange:hover:active {
  box-shadow: var(--ezBoxShadowDarkYellow);
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:disabled,
select.ezSelectButton_Default-normal-ezClockerOrange:disabled {
  background-color: var(--ezExtraLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:focus,
select.ezSelectButton_Default-normal-ezClockerOrange:focus {
  box-shadow: var(--ezFocusBoxShadowBlack);
}

/*
    ##########################################################################################################################################################
    [Class Section]
    Select/Drop Down/Menu Buttons
    ##########################################################################################################################################################
    Name Templates:
        ezSelectButton-{name}-{color}
        ezSelectButton-{name}-{other-properties}-color}
        ezDropDownButton-{name}-{color}
        ezDropDownButton-{name}-{other-properties}-color}
        ezMenuButton-{name}-{color}
        ezMenuButton-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Select Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange,
select.ezSelectButton-default-ezClockerOrange:enabled {
  padding: 5px 24px;
  margin: 2px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezBorderYellow);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Focus]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:enabled:focus {
  background-color: var(--ezHoverYellow);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent;
  outline-color: var(--ezBorderYellow);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Hover and Active Hover]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:enabled:hover,
select.ezSelectButton-default-ezClockerOrange:enabled:focus:hover {
  background-color: var(--ezHoverYellow);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
  outline-color: var(--ezBorderYellow);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:enabled:active,
select.ezSelectButton-default-ezClockerOrangeenabled:active:hover,
select.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active,
select.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active:hover {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px rgba(198, 118, 0, 0.5);
  outline-color: var(--ezBorderYellow);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:disabled,
select.ezSelectButton-default-ezClockerOrange:disabled:hover {
  background-color: var(--ezHoverYellow);
  color: var(--ezBorderYellow);
  border-color: var(--ezClockerYellow);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-header-ezClockerOrange
        (DEPRECATED) select.ezSelectButton-major-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-header-ezClockerOrange,
select.ezSelectButton-header-ezClockerOrange:enabled,
select.ezSelectButton-major-ezClockerOrange,
select.ezSelectButton-major-ezClockerOrange:enabled {
  padding: 4px;
  margin: 2px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: bold;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderOrange);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-width: 0;
  cursor: pointer;
}

select.ezSelectButton-header-ezClockerOrange:hover:enabled,
select.ezSelectButton-major-ezClockerOrange:hover:enabled {
  background-color: var(--ezLightOrange);
  box-shadow: var(--ezBoxShadowStone);
}

select.ezSelectButton-header-ezClockerOrange:hover:active,
select.ezSelectButton-major-ezClockerOrange:hover:active {
  box-shadow: var(--ezBoxShadowDarkOrnage);
}

select.ezSelectButton-header-ezClockerOrange:focus,
select.ezSelectButton-major-ezClockerOrange:focus {
  box-shadow: var(--ezFocusBoxShadowBlack);
}

select.ezSelectButton-header-ezClockerOrange:disabled,
select.ezSelectButton-major-ezClockerOrange:disabled {
  background-color: var(--ezLightOrange);
  color: var(--ezDarkOrange);
  border-color: var(--ezDarkOrange);
  font-weight: normal;
}

option.ezSelectButton-option-title,
option.ezSelectButton-option-title:hover,
option.ezSelectButton-option-title:active,
option.ezSelectButton-option-title:disabled,
option.ezSelectButton-option-title:focus {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
  text-align: center;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: default;
}

option.ezSelectButton-option {
  font-size: 12pt;
  text-align: left;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: pointer;
}

option.ezSelectButton-option:hover option.ezSelectButton-option:focus option.ezSelectButton-option:active {
  background-color: var(--ezClockerStone);
  font-weight: bold;
  cursor: pointer;
}

option.ezSelectButton-option:disabled {
  color: var(--ezClockerStone);
  font-size: 12pt;
  font-weight: normal;
  text-align: left;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: default;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {

}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {

}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  | ezDialogButton Styles
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  button.ezDialogButton {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezDialogButton:hover {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:active {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:disabled {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledDialogButton {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezWhiteDialogButton {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezWhiteDialogButton:hover {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezWhiteDialogButton:hover:active,
  button.ezWhiteDialogButton:active {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);
  }
  button.ezWhiteDialogButton:disabled {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledWhiteDialogButton {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
    border-radius: 3px;
  }
}
/* -------------------------------------------------------------------
| Wearable Screen Style  (https://yesviz.com/watches.php)
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  | ezDialogButton Styles
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  button.ezDialogButton {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezDialogButton:hover {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:active {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:disabled {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledDialogButton {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
    border-radius: 3px;
  }
  button.ezWhiteDialogButton {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezWhiteDialogButton:hover {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezWhiteDialogButton:hover:active,
  button.ezWhiteDialogButton:active {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);
  }
  button.ezWhiteDialogButton:disabled {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledWhiteDialogButton {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
    border-radius: 3px;
  }
}
.ezFullWidthButton {
  width: 100%;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    JQuery Button Style Overrides
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    JQuery Style Overrides
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon,
.ui-icon:enabled,
.ui-button .ui-icon,
.ui-button .ui-icon:enabled {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:enabled:focus,
.ui-button .ui-icon:enabled:focus {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:enabled:hover,
.ui-icon:enabled:focus:hover,
.ui-button .ui-icon:enabled:hover,
.ui-button .ui-icon:enabled:focus:hover {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:enabled:active,
.ui-icon:enabled:active:hover,
.ui-icon:enabled:focus:active,
.ui-icon:enabled:focus:active:hover,
.ui-button .ui-icon:enabled:active,
.ui-button .ui-icon:enabled:active:hover,
.ui-button .ui-icon:enabled:focus:active,
.ui-button .ui-icon:enabled:focus:active:hover {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:disabled,
.ui-icon:disabled:hover,
.ui-button .ui-icon:disabled,
.ui-button .ui-icon:disabled:hover {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button,
.ui-button:enabled {
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 12pt;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:enabled:focus {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent;
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:enabled:hover,
.ui-button:enabled:focus:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:enabled:active,
.ui-button:enabled:active:hover,
.ui-button:enabled:focus:active,
.ui-button:enabled:focus:active:hover {
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px rgba(198, 118, 0, 0.5);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:disabled,
.ui-button:disabled:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  border-color: var(--ezClockerOrange);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-state-active .ui-icon,
        .ui-button .ui-icon,
        .ui-button:enabled .ui-icon:enabled,
        .ui-button:enabled:active .ui-icon:enabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        none
        :enabled
        :enabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button .ui-icon,
.ui-button:enabled .ui-icon:enabled,
.ui-button:enabled:active .ui-icon:enabled:active,
.ui-state-active .ui-icon {
  /* Using black icons only */
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-dialog-titlebar-close
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        none
        :enabled
        :enabled:focus
        :enabled:hover
        :enabled:focus:hover
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-dialog-titlebar-close,
.ui-dialog-titlebar-close:enabled,
.ui-dialog-titlebar-close:enabled:focus,
.ui-dialog-titlebar-close:enabled:hover,
.ui-dialog-titlebar-close:enabled:focus:hover,
.ui-dialog-titlebar-close:enabled:active,
.ui-dialog-titlebar-close:enabled:active:hover,
.ui-dialog-titlebar-close:enabled:focus:active,
.ui-dialog-titlebar-close:enabled:focus:active:hover,
.ui-dialog-titlebar-close:disabled,
.ui-dialog-titlebar-close:disabled:hover {
  /* Hide all JQuery UI dialog's top right X butons */
  display: none;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    DEPRECATED STYLES
    DO NOT USE CLASS IN THIS SECTION
    ##########################################################################################################################################################
*/
/* @DEPRECATED: a.navButton */
a.navButton {
  font-size: medium;
  font-weight: normal;
  margin: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezActionGreenBorderColor);
  background-color: #8ef13c;
  color: var(--ezClockerBlack);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 3px;
}

/* @DEPRECATED: a.navButton */
a.navButton:hover:enabled {
  /* DEPRECATED: DO NOT USE */
  border-top-color: var(--ezActionGreenHoverColor);
  border-left-color: var(--ezActionGreenHoverColor);
  border-bottom-color: #66cc99;
  border-right-color: #66cc99;
  background-color: #a9f16c;
}

/* @DEPRECATED: a.navButton */
a.navButton:hover:active {
  border-top-color: #66cc99;
  border-left-color: #66cc99;
  border-bottom-color: var(--ezActionGreenHoverColor);
  border-right-color: var(--ezActionGreenHoverColor);
  color: #a9f16c;
  background-color: var(--ezActionGreenBorderColor);
}

/* @DEPRECATED: a.toolButton */
a.toolButton {
  font-size: small;
  font-weight: normal;
  margin: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: #996600;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
}

/* @DEPRECATED: a.toolButton */
a.toolButton:hover:enabled {
  border-top-color: #ffee00;
  border-left-color: #ffee00;
  border-bottom-color: #ff9933;
  border-right-color: #ff9933;
  background-color: #ffcc66;
}

/* @DEPRECATED: a.toolButton */
a.toolButton:hover:active {
  border-top-color: #ff9933;
  border-left-color: #ff9933;
  border-bottom-color: #ffee00;
  border-right-color: #ffee00;
  background-color: #ffcc66;
}

/* @DEPRECATED: a.disabledToolButton */
a.disabledToolButton {
  font-size: small;
  font-weight: normal;
  margin: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: #808080;
  background-color: var(--ezClockerStone);
  color: #808080;
  cursor: default;
  padding: 2px 4px;
  border-radius: 3px;
}

/* @DEPRECATED: .buttonText */
.buttonText {
  font-size: 12pt;
  font-family: verdana, sans-serif;
  font-weight: normal;
}

/* @DEPRECATED: .headerButtonText */
.headerButtonText {
  font-size: 12pt;
  font-family: verdana, sans-serif;
  font-weight: bold;
}

/* @DEPRECATED: button.ezNoButtonMargin */
button.ezNoButtonMargin {
  margin: 0;
}

/* @DEPRECATED: button.fullWidth */
button.fullWidth {
  width: 100%;
}

/* @DEPRECATED: button.paddButton10 */
button.paddButton10 {
  margin-left: 10px;
}

/* @DEPRECATED: paper-button.ez-navigation-button */
paper-button.ez-navigation-button {
  font-family: var(--ezFontFamily);
  max-height: var(--ezNavButtonMaxHeight);
  max-width: var(--ezNavButtonMaxWidth);
  min-width: var(--ezNavButtonMinWidth);
  font-size: var(--ezNavButtonFontSize);
  font-weight: var(--ezNavButtonFontWeight);
  background-color: var(--ezNavButtonColor);
  color: var(--ezNavButtonTextColor);
  text-transform: var(--ezNavButtonTextTransform);
}

/* @DEPRECATED: paper-button.ez-navigation-button */
paper-button.ez-navigation-button > paper-ripple {
  color: var(--ezWhite);
}

/* @DEPRECATED: paper-button.ez-navigation-button */
paper-button.ez-navigation-button:hover:enabled {
  background-color: var(--ezNavButtonColorHover);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/* @DEPRECATED: ez-signout-button */
paper-button.ez-signout-button {
  text-transform: var(--ezSignOutButtonTextTransform);
  max-height: var(--ezSignOutButtonMaxHeight);
  max-width: var(--ezSignOutButtonMaxWidth);
  min-width: var(--ezSignOutButtonMinWidth);
  font-size: var(--ezSignOutButtonFontSize);
  font-weight: var(--ezSignOutButtonFontWeight);
  background-color: var(--ezSignOutButtonColor);
  color: var(--ezSignOutButtonTextColor);
}

/* @DEPRECATED: ez-signout-button */
paper-button.ez-signout-button > paper-ripple {
  color: var(--ezWhite);
}

/* @DEPRECATED: ez-signout-button */
paper-button.ez-signout-button:hover:enabled {
  background-color: var(--ezSignOutButtonHoverColor);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/* @DEPRECATED: paper-button.ez-select-plan-button */
paper-button.ez-select-plan-button {
  max-width: var(--ezSelectPlanButtonMaxWidth);
  min-width: var(--ezSelectPlanButtonMinWidth);
  max-height: var(--ezSelectPlanBtnMaxHeight);
  font-size: var(--ezSelectPlanBtnFontSize);
  font-weight: var(ezSelectPlanBtnFontWeight);
  background-color: var(--ezSelectPlanBtnColor);
  color: var(--ezSelectPlanBtnTextColor);
  text-transform: var(--ezSelectPlanTextTransform);
}

/* @DEPRECATED: paper-button.ez-select-plan-button */
paper-button.ez-select-plan-button > paper-ripple {
  color: var(--ezBorderGreen);
}

/* @DEPRECATED: paper-button.ez-select-plan-button */
paper-button.ez-select-plan-button:hover:enabled {
  background-color: var(--ezSelectPlanBtnHoverColor);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/*
    ##########################################################################################################################################################
    END OF DEPRECATED CLASS SECTION
    ##########################################################################################################################################################
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-buttons.css"],"names":[],"mappings":"AAAA;;;;;;CAAA;AAQA;EACI,6BAAA;EACA;;GAAA;EAGA,iEAAA;EACA,2BAAA;EAEA,iCAAA;EACA,yCAAA;EACA,uCAAA;EACA,sCAAA;EACA,mCAAA;EAEA,gCAAA;EACA,oCAAA;EAEA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EACA,+BAAA;EACA,kCAAA;EAEA,gCAAA;EACA,mCAAA;EACA,+CAAA;EACA,sCAAA;EACA,wCAAA;EACA,uDAAA;EACA,qDAAA;EACA,6DAAA;EACA,mDAAA;EACA,mDAAA;EACA,yCAAA;EACA,gCAAA;EAEA,8BAAA;EACA,4CAAA;EACA,0CAAA;EACA,4CAAA;EACA,8CAAA;EACA,2DAAA;EACA,iEAAA;EACA,yDAAA;EACA,uDAAA;EACA,uDAAA;EACA,4CAAA;EAEA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,4CAAA;EACA,gDAAA;EACA,2DAAA;EACA,8DAAA;EACA,yDAAA;EACA,0DAAA;EACA,0DAAA;EACA,uCAAA;AANJ;;AASA;;;;;;;;;;;CAAA;AAaA;;;;;;;;;CAAA;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,cAAA;AARJ;;AAWA;;;;;;;;;;;;;CAAA;AAcA,gDAAA;AACA;;;;;;;;;EAWI,2BAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,qBAAA;AAVJ;;AAaA;;;;;;;;;;;;;;CAAA;AAeA,gDAAA;AACA;;;;;;;;;EAWI,yBAAA;EACA,0BAAA;AAZJ;;AAeA,gDAAA;AACA;;;;;;;;;;;;EAcI,wBAAA;EACA,0BAAA;AAdJ;;AAiBA,gDAAA;AACA;;;;;;EAQI,2BAAA;EACA,qBAAA;EACA,eAAA;AAhBJ;;AAmBA,yCAAA;AACA;;EAEI,2BAAA;EACA,qBAAA;EACA,eAAA;AAhBJ;;AAmBA;;;;;;;;CAAA;AAUA;;EAGI,2BAAA;EACA,qBAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAlBJ;;AAqBA;;EAGI,yBAAA;EACA,0BAAA;AAnBJ;;AAsBA;;EAGI,yBAAA;EACA,0BAAA;AApBJ;;AAuBA;;EAGI,wBAAA;EACA,0BAAA;AArBJ;;AAwBA;;EAGI,2BAAA;EACA,qBAAA;AAtBJ;;AAyBA;;EAGI,2BAAA;EACA,qBAAA;EACA,eAAA;AAvBJ;;AA0BA,iBAAA;AACA;EACI,2BAAA;EACA,qBAAA;EACA,eAAA;AAvBJ;;AA2BA;;;;;;;;;;;CAAA;AAaA;;;;;;;;;CAAA;AAWA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,SAAA;EACA,YAAA;EACA,sDAAA;EACA,wCAAA;EACA,qBAAA;EACA,yDAAA;EACA,gCAAA;EACA,iDAAA;EACA,gCAAA;EACA,wDAAA;EACA,mCAAA;EACA,0DAAA;EACA,uCAAA;EACA,yDAAA;EACA,qCAAA;EACA,qDAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;;AA6BA;;;;;;;;;;;CAAA;AAYA;;EAEI,uDAAA;AA1BJ;;AA6BA;;;;;;;;;;;;;CAAA;AAcA;;;EAGI,sCAAA;EACA,iBAAA;AA1BJ;;AA6BA;;;;;;;;;;;;;;CAAA;AAeA;;;;;EAKI,sCAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;;AA6BA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,SAAA;EACA,YAAA;EACA,sDAAA;EACA,uCAAA;EACA,qBAAA;EACA,yDAAA;EACA,gCAAA;EACA,iDAAA;EACA,gCAAA;EACA,wDAAA;EACA,mCAAA;EACA,0DAAA;EACA,uCAAA;EACA,yDAAA;EACA,qCAAA;EACA,qDAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;;AA6BA;;;;;;;;;;;CAAA;AAYA;;EAEI,qDAAA;AA1BJ;;AA6BA;;;;;;;;;;;;;CAAA;AAcA;;;EAGI,wCAAA;EACA,iBAAA;AA1BJ;;AA6BA;;;;;;;;;;;;;;CAAA;AAeA;;;;;EAKI,wCAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;;AA6BA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,SAAA;EACA,YAAA;EACA,sDAAA;EACA,0CAAA;EACA,qBAAA;EACA,yDAAA;EACA,gCAAA;EACA,iDAAA;EACA,gCAAA;EACA,wDAAA;EACA,mCAAA;EACA,0DAAA;EACA,uCAAA;EACA,yDAAA;EACA,qCAAA;EACA,qDAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;;AA6BA;;;;;;;;;;;CAAA;AAYA;;EAEI,wDAAA;AA1BJ;;AA6BA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,wCAAA;EACA,iBAAA;AA1BJ;;AA6BA;;;;;;;;;;;;;;CAAA;AAeA;;;;;EAKI,wCAAA;EACA,8BAAA;EACA,sCAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;;AA8BA;;;;;;;;;CAAA;AAWA;;;;;mDAAA;AAMA;;;EAKI,2BAAA;EACA,gCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA9BJ;;AAiCA;;;EAKI,yBAAA;EACA,0BAAA;AAhCJ;;AAmCA;;;EAKI,yBAAA;EACA,0BAAA;AAlCJ;;AAqCA;;;EAKI,wBAAA;EACA,0BAAA;AApCJ;;AAuCA;;;EAKI,2BAAA;EACA,qBAAA;AAtCJ;;AAyCA;;;EAKI,2BAAA;EACA,qBAAA;EACA,eAAA;AAxCJ;;AA2CA,iBAAA;AACA;EACI,2BAAA;EACA,qBAAA;EACA,eAAA;AAxCJ;;AA2CA;;;;;;;;CAAA;AAUA;;;;mDAAA;AAKA;;EAGI,SAAA;EACA,YAAA;EACA,sCAAA;EACA,qBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AA1CJ;;AA6CA;;EAGI,wCAAA;AA3CJ;;AA8CA;;EAGI,uCAAA;AA5CJ;;AA+CA;;EAGI,SAAA;EACA,YAAA;EACA,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA7CJ;;AAgDA;;;;;;;;CAAA;AAUA;;;;;;;;;;CAAA;AAWA;;EAGI,SAAA;EACA,YAAA;EACA,sCAAA;EACA,qBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA/CJ;;AAkDA;;;;;;;;;;CAAA;AAWA;;EAGI,oCAAA;AAhDJ;;AAmDA;;;;;;;;;;CAAA;AAWA;;EAGI,mCAAA;AAjDJ;;AAoDA;;;;;;;;;;CAAA;AAWA;;EAGI,SAAA;EACA,YAAA;EACA,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAlDJ;;AAqDA;;EAGI,oCAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;AAnDJ;;AAsDA;;;;;;;;CAAA;AAUA;;;;;;;;;;CAAA;AAWA;EACI,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AApDJ;;AAuDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;AApDJ;;AAuDA;;;;;;;;;;CAAA;AAWA;EACI,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AApDJ;;AAuDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;AApDJ;;AAuDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,sEAAA;EACA,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,uCAAA;EACA,iCAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AApDJ;;AAwDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;AArDJ;;AAyDA;;;;;;;;;;;CAAA;AAaA;;;;;CAAA;AAOA;;;;;;;;;;;;;;;;;;mDAAA;AAmBA,iBAAA;AACA;;EAEI,0BAAA;EACA,qBAAA;EACA,wCAAA;EACA,iBAAA;EACA,yCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;AAxDJ;;AA2DA,iBAAA;AACA;;EAEI,yBAAA;AAxDJ;;AA2DA,iBAAA;AACA;;EAEI,yBAAA;AAxDJ;;AA2DA;;;;;CAAA;AAQA;;;;mDAAA;AAKA;;EAEI,sCAAA;EACA,iDAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AA1DJ;;AA6DA;;EAEI,gDAAA;AA1DJ;;AA6DA;;EAEI,qCAAA;EACA,iDAAA;AA1DJ;;AA8DA;;;;;CAAA;AAOA;;;;mDAAA;AAKA;;EAGI,qBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;AA7DJ;;AAgEA;;EAGI,wCAAA;AA9DJ;;AAkEA;;EAGI,uCAAA;AAhEJ;;AAmEA;;;;;;;;;;;CAAA;AAaA;;;;;CAAA;AAOA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAUI,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AApEJ;;AAuEA;;;;;;;;;;;;;CAAA;AAcA;;;;EAMI,sCAAA;EACA,4BAAA;EACA,yCAAA;EACA,gBAAA;EACA,wCAAA;AAtEJ;;AAyEA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAUI,sCAAA;EACA,4BAAA;EACA,0CAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;AAxEJ;;AA2EA;;;;;;;;;;;;;;;;CAAA;AAiBA;;;;;;;;;;;;;;;;EAkBI,wCAAA;EACA,4BAAA;EACA,6EACI;EAEJ,mCAAA;EACA,gBAAA;EACA,qBAAA;AA5EJ;;AA+EA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAUI,sCAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;AA9EJ;;AAiFA;;;;;;;;;;;CAAA;AAYA,uCAAA;AACA;;;;;;EAOI,iBAAA;EACA,WAAA;EACA,sCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AA/EJ;;AAkFA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,iBAAA;AAlFJ;;AAqFA;;;;;;;;;;;;CAAA;AAaA;;;EAKI,eAAA;EACA,iBAAA;AApFJ;;AAuFA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,iBAAA;AAtFJ;;AAyFA;;;;;;;;;;;;;;;CAAA;AAgBA;;;;;;;;;;;;EAYI,eAAA;EACA,iBAAA;AAtFJ;;AAyFA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,mBAAA;AAxFJ;;AA2FA;;;;;;;;;;;;;CAAA;AAcA,8CAAA;AACA;;;;;;EAOI,eAAA;EACA,mBAAA;AAzFJ;;AA4FA;;;;;;;;;;;;;;;;CAAA;AAiBA;;;;;;;;;;;;EAaI,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,oCAAA;EACA,wCAAA;EACA,uCAAA;EACA,mCAAA;EACA,oCAAA;AA1FJ;;AA6FA;;;;;;;CAAA;AASA;;;;;;;;;;CAAA;AAWA;EACI,aAAA;EACA,gCAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA3FJ;;AA8FA;;;;;;;;;;;CAAA;AAYA;;EAEI,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA3FJ;;AA8FA;;;;;;;;;;;CAAA;AAYA;;EAEI,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA3FJ;;AA8FA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,8CAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA3FJ;;AA8FA;;;;;;;;;;;CAAA;AAYA;;EAEI,0CAAA;EACA,2BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AA3FJ;;AA8FA;;;;;;;;;;;;;;;;;;CAAA;AAmBA;;;;;;;;;EASI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA3FJ;;AA8FA;;;;;;;;;;;CAAA;AAYA;;EAEI,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA3FJ;;AA+FA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,cAAA;EACA,iBAAA;EACA,wCAAA;EACA,kCAAA;EACA,4BAAA;EACA,kBAAA;AA/FJ;;AAkGA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;EACA,4DAAA;AAjGJ;;AAoGA;;;;;;;;;;;;;CAAA;AAcA;;;;EAMI,sCAAA;AAnGJ;;AAsGA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;EACA,0BAAA;EACA,iCAAA;AArGJ;;AAwGA;;;;;;;;;;;;;CAAA;AAcA,iDAAA;AACA;;;;;;EAOI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAtGJ;;AA0GA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,wCAAA;EACA,4BAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AA1GJ;;AA8GA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;AA7GJ;;AAgHA;;;;;;;;;;;;CAAA;AAaA;;;EAKI,oDAAA;AA/GJ;;AAkHA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAjHJ;;AAoHA;;;;;;;;;;;;;CAAA;AAcA,gDAAA;AACA;;;;;;EAOI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAlHJ;;AAuHA;;sEAAA;AAGA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AApHJ;;AAuHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AApHJ;;AAuHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AApHJ;;AAuHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AApHJ;;AAuHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AApHJ;;AAuHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AApHJ;;AAuHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AApHJ;;AAuHA;;EAEI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AApHJ;;AAuHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AApHJ;;AAuHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AApHJ;;AAwHA;;sEAAA;AAGA;;;;EAKI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;AAtHJ;;AAyHA;;EAGI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,sCAAA;AAvHJ;;AA0HA;;;;EAKI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,sCAAA;EACA,4DAAA;AAxHJ;;AA2HA;;;;;;;;EASI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,sCAAA;EACA,oDAAA;AAzHJ;;AA4HA;;;;;;EAOI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,yCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AA1HJ;;AA6HA,6CAAA;AACA;;EAGI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,yCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AA3HJ;;AA8HA;;sEAAA;AAGA;EACI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AA3HJ;;AA8HA;EACI,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,4DAAA;AA3HJ;;AA8HA;EACI,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;AA3HJ;;AA8HA;;EAEI,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,oDAAA;AA3HJ;;AA8HA;;;EAGI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA3HJ;;AA8HA;EACI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AA3HJ;;AA+HA;;sEAAA;AAGA;EACI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;AA5HJ;;AA+HA;EACI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,4DAAA;AA5HJ;;AA+HA;EACI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;AA5HJ;;AA+HA;;EAEI,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,oDAAA;AA5HJ;;AA+HA;;;EAGI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA5HJ;;AA+HA;EACI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA5HJ;;AAgIA;;sEAAA;AAGA;EACI,sCAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AA7HJ;;AAgIA;EACI,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,oCAAA;EACA,kCAAA;AA7HJ;;AAgIA;EACI,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,oCAAA;AA7HJ;;AAgIA;;EAEI,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;AA7HJ;;AAgIA;;;EAGI,mCAAA;EACA,8CAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA7HJ;;AAgIA;EACI,mCAAA;EACA,8CAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA7HJ;;AAiIA;;sEAAA;AAGA;;EAGI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,kBAAA;AA/HJ;;AAkIA;;EAGI,0CAAA;EACA,4BAAA;AAhIJ;;AAmIA;;EAGI,4BAAA;EACA,yBAAA;AAjIJ;;AAoIA;;;;EAOI,4BAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AApIJ;;AAwIA;;sEAAA;AAGA;;;;EAKI,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,kBAAA;AAtIJ;;AAyIA;;EAGI,SAAA;EACA,iBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;AAvIJ;;AA0IA;;;;EAKI,SAAA;EACA,iBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,gDAAA;AAxIJ;;AA2IA;;;;;;;;EASI,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,gDAAA;AAzIJ;;AA4IA;;;;EAKI,SAAA;EACA,iBAAA;EACA,wCAAA;EACA,8BAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA1IJ;;AA8IA;;sEAAA;AAGA;;EAEI,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA3IJ;;AA8IA;;EAEI,0CAAA;EACA,gDAAA;AA3IJ;;AA8IA;;EAEI,0CAAA;AA3IJ;;AA8IA;;EAEI,gDAAA;AA3IJ;;AA8IA;;EAEI,cAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;AA3IJ;;AA8IA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;AA3IJ;;AA8IA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA3IJ;;AA8IA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,kDAAA;AA3IJ;;AA8IA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,6BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AA3IJ;;AA8IA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AA3IJ;;AA8IA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA3IJ;;AA8IA;EACI,0CAAA;AA3IJ;;AA8IA;EACI,yBAAA;AA3IJ;;AA8IA;EACI,0CAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;AA3IJ;;AA+IA;;;;;CAAA;AAOA;;;;;;;;;;;CAAA;AAYA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA9IJ;;AAiJA;;;;;;;;;;;CAAA;AAYA;;EAGI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;AA/IJ;;AAkJA;;;;;;;;;;;;CAAA;AAaA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAhJJ;;AAmJA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EASI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,eAAA;AAjJJ;;AAoJA;;;;;;;;;;;;CAAA;AAaA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAlJJ;;AAqJA;;;;;;;;;;;CAAA;AAYA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAlJJ;;AAqJA;;;;;;;;;;;CAAA;AAYA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;AAlJJ;;AAqJA;;;;;;;;;;;;CAAA;AAaA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;AAlJJ;;AAqJA;;;;;;;;;;;;;;CAAA;AAeA;;;;EAII,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8CAAA;EACA,eAAA;AAlJJ;;AAqJA;;;;;;;;;;;;CAAA;AAaA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAlJJ;;AAsJA;;EAEI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;AAnJJ;;AAsJA;EACI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,wCAAA;AAnJJ;;AAsJA;;EAEI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,wCAAA;AAnJJ;;AAsJA;;;;EAII,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,uFACI;EAEJ,gBAAA;AArJJ;;AAwJA;;EAEI,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AArJJ;;AAyJA;EACI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;AAtJJ;;AAyJA;EACI,6BAAA;EACA,4BAAA;EACA,mCAAA;AAtJJ;;AAyJA;EACI,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,gBAAA;AAtJJ;;AAyJA;EACI,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,sDAAA;AAtJJ;;AAyJA;;;EAGI,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAtJJ;;AAyJA;;sEAAA;AAGA;EACI,YAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;AAtJJ;;AAyJA;;sEAAA;AAGA;;;;EAKI,YAAA;EACA,WAAA;EACA,wCAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;AAvJJ;;AA0JA;;EAGI,YAAA;EACA,WAAA;EACA,sCAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AAxJJ;;AA2JA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,4DAAA;AAzJJ;;AA4JA;;;;;;;;EASI,YAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,oDAAA;AA1JJ;;AA6JA;;;;;;EAOI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;AA3JJ;;AA8JA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AA3JJ;;AA8JA;;sEAAA;AAGA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,gDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,oDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,WAAA;EACA,YAAA;AA3JJ;;AA8JA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,oDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AA3JJ;;AA8JA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,oDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AA3JJ;;AA8JA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,oDAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA3JJ;;AA8JA;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AA3JJ;;AA8JA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AA3JJ;;AA8JA;EACI,YAAA;EACA,WAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;AA3JJ;;AAgKA;;sEAAA;AAGA;;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AA7JJ;;AAgKA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AA7JJ;;AAgKA;;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AA7JJ;;AAgKA;;;;EAII,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AA7JJ;;AAgKA;;;EAGI,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;AA7JJ;;AAgKA;;sEAAA;AAGA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AA7JJ;;AAgKA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,gDAAA;AA7JJ;;AAgKA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AA7JJ;;AAgKA;;;EAGI,UAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AA7JJ;;AAgKA;;;;;;;;EAQI,YAAA;EACA,SAAA;EACA,0CAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EAEA;;;;;;;;;GAAA;AArJJ;;AAiKA;;EAEI,YAAA;EACA,YAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AA9JJ;;AAkKA;;sEAAA;AAGA;EACI,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AA/JJ;;AAkKA;;EAEI,0CAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,gDAAA;EACA,eAAA;AA/JJ;;AAkKA;EACI,0CAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AA/JJ;;AAkKA;;EAEI,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,8CAAA;EACA,eAAA;AA/JJ;;AAkKA;EACI,0CAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AA/JJ;;AAkKA;EACI,0CAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AA/JJ;;AAkKA;;sEAAA;AAGA;;EAEI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AA/JJ;;AAkKA;;;EAGI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gDAAA;AA/JJ;;AAkKA;;;;;EAKI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,8CAAA;AA/JJ;;AAkKA;;EAEI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;AA/JJ;;AAmKA;;sEAAA;AAGA;;EAEI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAhKJ;;AAmKA;;EAEI,0CAAA;EACA,4BAAA;AAhKJ;;AAmKA;;EAEI,yBAAA;AAhKJ;;AAmKA;;EAEI,4BAAA;EACA,yBAAA;EACA,mCAAA;EACA,eAAA;AAhKJ;;AAoKA;;sEAAA;AAGA;;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAjKJ;;AAoKA;;;;;;;;EAQI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAjKJ;;AAoKA;;;;EAII,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAjKJ;;AAoKA;;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAjKJ;;AAoKA;;;;;CAAA;AAOA;;;;;;;;;;;;CAAA;AAaA;;;;;;EAQI,iBAAA;EACA,SAAA;EACA,6CAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;AApKJ;;AAuKA;;;;;;;;;;;;CAAA;AAaA;;;EAKI,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAtKJ;;AAyKA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,wCAAA;AAxKJ;;AA2KA;;;;;;;;;;;;;;;CAAA;AAgBA;;;;;;;;;;;;EAcI,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,oDAAA;AA1KJ;;AA6KA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,gDAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,6CAAA;AA5KJ;;AA+KA;;;;;;;;;;;;CAAA;AAaA,8CAAA;AACA;;;;;;EAOI,gDAAA;EACA,sCAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;AA7KJ;;AAgLA;;;;;;;;;;CAAA;AAWA;;EAEI,iBAAA;EACA,SAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AA7KJ;;AAgLA;;;;;;;;;;CAAA;AAWA;EACI,eAAA;EACA,iBAAA;EACA,sCAAA;AA7KJ;;AAgLA;;;;;;;;;;;CAAA;AAYA;;EAEI,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,wCAAA;AA7KJ;;AAgLA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,eAAA;EACA,iBAAA;EACA,oDAAA;AA7KJ;;AAgLA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;AA7KJ;;AAiLA;;sEAAA;AAGA;EACI,iBAAA;EACA,SAAA;EACA,sCAAA;EACA,sCAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AA9KJ;;AAiLA;EACI,iBAAA;EACA,oCAAA;AA9KJ;;AAiLA;EACI,iBAAA;EACA,oCAAA;AA9KJ;;AAiLA;EACI,iBAAA;EACA,oCAAA;AA9KJ;;AAiLA;EACI,oCAAA;EACA,kCAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;AA9KJ;;AAiLA;EACI,oCAAA;EACA,iCAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;AA9KJ;;AAkLA;;sEAAA;AAGA;;EAEI,SAAA;EACA,sCAAA;EACA,kCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA/KJ;;AAkLA;;EAEI,yBAAA;AA/KJ;;AAkLA;;EAEI,yBAAA;AA/KJ;;AAkLA;;EAEI,eAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;AA/KJ;;AAmLA;;sEAAA;AAGA;EACI,sCAAA;EACA,yCAAA;EACA,iBAAA;EACA,kBAAA;AAhLJ;;AAmLA;EACI,sCAAA;EACA,yCAAA;EACA,aAAA;AAhLJ;;AAoLA;;sEAAA;AAGA;EACI,gDAAA;EACA,uCAAA;EAEA,sCAAA;EACA,yCAAA;EACA,iBAAA;EAEA,+CAAA;EACA,4BAAA;EAEA,2CAAA;EACA,qCAAA;EACA,kBAAA;AApLJ;;AAuLA;EACI,sCAAA;EACA,yCAAA;EACA,aAAA;AApLJ;;AAwLA;;;;;;;;;;;;;;;sEAAA;AAiBA;;;;mDAAA;AAKA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,uCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AAtLJ;;AAyLA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;EACA,0CAAA;AAtLJ;;AAyLA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;AAtLJ;;AAyLA,yCAAA;AACA;;;;;;EAMI,sCAAA;EACA,4BAAA;EACA,oDAAA;AAtLJ;;AAyLA,yCAAA;AACA;;;;EAII,uCAAA;EACA,2BAAA;EACA,eAAA;AAtLJ;;AAyLA;;;;mDAAA;AAKA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,uCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AAtLJ;;AAyLA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;EACA,0CAAA;AAtLJ;;AAyLA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;AAtLJ;;AAyLA,yCAAA;AACA;;;;;;EAMI,sCAAA;EACA,4BAAA;EACA,oDAAA;AAtLJ;;AAyLA,yCAAA;AACA;;;;EAII,uCAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AAtLJ;;AAyLA;;;;mDAAA;AAKA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AAtLJ;;AAyLA,yCAAA;AACA;;;;;;;;;;EAUI,sCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAtLJ;;AAyLA,yCAAA;AACA;;;;EAII,uCAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AAtLJ;;AAyLA;;;;mDAAA;AAKA,iCAAA;AACA;;EAEI,wCAAA;EACA,yCAAA;EACA,4BAAA;EACA,mBAAA;EACA,mCAAA;EACA,iBAAA;EACA,kBAAA;AAtLJ;;AAyLA,iCAAA;AACA;;EAEI,sCAAA;AAtLJ;;AAyLA,iCAAA;AACA;;EAEI,iBAAA;AAtLJ;;AA0LA;;;;;;;;;;;;sEAAA;AAaA,uCAAA;AACA;;EAGI,mBAAA;AAxLJ;;AA2LA;EACI,4BAAA;EACA,eAAA;EACA,mBAAA;AAxLJ;;AA2LA;;EAEI,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;AAxLJ;;AA4LA;;;;;;;;;;;;;;;;sEAAA;AAiBA,sCAAA;AACA;;EAEI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA,2CAAA;AACA;;EAEI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzLJ;;AA4LA;;;EAGI,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAzLJ;;AA6LA;;;;;;;;;;;sEAAA;AAYA,2CAAA;AACA;;EAEI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EAEA;;;;;;;;;;;;;;GAAA;AA7KJ;;AA8LA,2CAAA;AACA;;EAEI,sCAAA;EACA,mCAAA;AA3LJ;;AA8LA,2CAAA;AACA;;EAEI,wCAAA;AA3LJ;;AA8LA,2CAAA;AACA;;EAEI,2CAAA;EACA,0BAAA;EACA,iCAAA;AA3LJ;;AA8LA,2CAAA;AACA;;EAEI,wCAAA;AA3LJ;;AA8LA;;;;;;;;;;;;;CAAA;AAeA;;;;;CAAA;AAOA;;;;;;;;;;CAAA;AAWA;;EAEI,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AA7LJ;;AAgMA;;;;;;;;;;CAAA;AAWA;EACI,sCAAA;EACA,4BAAA;EACA,mCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;AA7LJ;;AAgMA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,0CAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;AA7LJ;;AAgMA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,wCAAA;EACA,4BAAA;EACA,6EACI;EAEJ,oCAAA;EACA,gBAAA;EACA,qBAAA;AA/LJ;;AAkMA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;AA/LJ;;AAkMA;;;;;;;;;;;;CAAA;AAaA;;;;EAKI,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAhMJ;;AAmMA;;EAEI,sCAAA;EACA,mCAAA;AAhMJ;;AAmMA;;EAEI,wCAAA;AAhMJ;;AAmMA;;EAEI,wCAAA;AAhMJ;;AAmMA;;EAEI,sCAAA;EACA,0BAAA;EACA,iCAAA;EACA,mBAAA;AAhMJ;;AAmMA;;;;;EAKI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AAhMJ;;AAmMA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AAhMJ;;AAmMA;EACI,uCAAA;EACA,iBAAA;EACA,eAAA;AAhMJ;;AAmMA;EACI,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AAhMJ;;AAmMA;;qEAAA;AAGA;;;;CAAA;AAOA;;qEAAA;AAGA;;;;CAAA;AAMA;;qEAAA;AAGA;EAEI;;wEAAA;EAGA;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EApMN;EAuME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EArMN;EAwME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EAtMN;EAyME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EAvMN;EA0ME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EAxMN;EA2ME;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAzMN;EA4ME;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EA1MN;EA6ME;;IAEI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,gDAAA;EA3MN;EA8ME;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EA5MN;EA+ME;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EA7MN;AACF;AAiNA;;qEAAA;AAGA;EAEI;;wEAAA;EAGA;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAhNN;EAmNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EAjNN;EAoNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EAlNN;EAqNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EAnNN;EAsNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EApNN;EAuNE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EArNN;EAwNE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EAtNN;EAyNE;;IAEI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,gDAAA;EAvNN;EA0NE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EAxNN;EA2NE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EAzNN;AACF;AA4NA;EACI,WAAA;AA1NJ;;AA6NA;;;;;CAAA;AAOA;;;;;CAAA;AAOA;;;;;;;;;;;;CAAA;AAaA;;;;EAII,sEAAA;AA5NJ;;AA+NA;;;;;;;;;;;CAAA;AAYA;;EAEI,sEAAA;AA5NJ;;AA+NA;;;;;;;;;;;CAAA;AAYA;;;;EAII,sEAAA;AA5NJ;;AA+NA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAQI,sEAAA;AA5NJ;;AA+NA;;;;;;;;;;;;CAAA;AAaA;;;;EAII,sEAAA;AA5NJ;;AA+NA;;;;;;;;;;;CAAA;AAYA;;EAEI,wCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AA5NJ;;AA+NA;;;;;;;;;;CAAA;AAWA;EACI,sCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;AA5NJ;;AA+NA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,0CAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;AA5NJ;;AA+NA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,wCAAA;EACA,4BAAA;EACA,6EACI;EAEJ,mCAAA;EACA,gBAAA;EACA,qBAAA;AA9NJ;;AAiOA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;AA9NJ;;AAiOA;;;;;;;;;;;;;;;CAAA;AAgBA;;;;EAII,2BAAA;EACA,sEAAA;AA9NJ;;AAiOA;;;;;;;;;;;;;;;;;;;;CAAA;AAqBA;;;;;;;;;;;EAWI,mDAAA;EACA,aAAA;AA9NJ;;AAiOA;;;;;;CAAA;AAQA,6BAAA;AACA;EACI,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,6CAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA/NJ;;AAkOA,6BAAA;AACA;EACI,2BAAA;EACA,gDAAA;EACA,iDAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AA/NJ;;AAkOA,6BAAA;AACA;EACI,yBAAA;EACA,0BAAA;EACA,mDAAA;EACA,kDAAA;EACA,cAAA;EACA,iDAAA;AA/NJ;;AAkOA,8BAAA;AACA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA/NJ;;AAkOA,8BAAA;AACA;EACI,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AA/NJ;;AAkOA,8BAAA;AACA;EACI,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AA/NJ;;AAkOA,sCAAA;AACA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA/NJ;;AAkOA,6BAAA;AACA;EACI,eAAA;EACA,gCAAA;EACA,mBAAA;AA/NJ;;AAkOA,mCAAA;AACA;EACI,eAAA;EACA,gCAAA;EACA,iBAAA;AA/NJ;;AAkOA,yCAAA;AACA;EACI,SAAA;AA/NJ;;AAkOA,kCAAA;AACA;EACI,WAAA;AA/NJ;;AAkOA,qCAAA;AACA;EACI,iBAAA;AA/NJ;;AAkOA,mDAAA;AACA;EACI,gCAAA;EACA,uCAAA;EACA,qCAAA;EACA,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,yCAAA;EACA,kCAAA;EACA,+CAAA;AA/NJ;;AAkOA,mDAAA;AACA;EACI,qBAAA;AA/NJ;;AAkOA,mDAAA;AACA;EACI,8CAAA;EACA,+GACI;AAhOR;;AAqOA,mCAAA;AACA;EACI,mDAAA;EACA,2CAAA;EACA,yCAAA;EACA,yCAAA;EACA,yCAAA;EACA,6CAAA;EACA,6CAAA;EACA,sCAAA;AAlOJ;;AAqOA,mCAAA;AACA;EACI,qBAAA;AAlOJ;;AAqOA,mCAAA;AACA;EACI,kDAAA;EACA,+GACI;AAnOR;;AAwOA,oDAAA;AACA;EACI,4CAAA;EACA,4CAAA;EACA,2CAAA;EACA,yCAAA;EACA,2CAAA;EACA,6CAAA;EACA,sCAAA;EACA,gDAAA;AArOJ;;AAwOA,oDAAA;AACA;EACI,2BAAA;AArOJ;;AAwOA,oDAAA;AACA;EACI,kDAAA;EACA,+GACI;AAtOR;;AA2OA;;;;CAAA","sourcesContent":["/*\r\n    ##########################################################################################################################################################\r\n    EzClocker Button UX CSS Classes\r\n    Requires:\r\n        /src/main/webapp/public/styles/common/ez-body.css (for css variables used in this file)\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n:root {\r\n    /* General Button Variables */\r\n    /*\r\n    --ezButtons-font-family: 'Font-Family-ezClocker', 'Roboto', 'Verdana', 'Arial', sans-serif;\r\n    */\r\n    --ezButtons-font-family: 'Roboto', 'Verdana', 'Arial', sans-serif;\r\n    --ezButtons-cursor: pointer;\r\n\r\n    /* Link Button Common Variables */\r\n    --ezSmallLinkButton-text-decoration: none;\r\n    --ezSmallLinkButton-font-weight: normal;\r\n    --ezSmallLinkButton-font-style: normal;\r\n    --ezSmallLinkButton-cursor: pointer;\r\n\r\n    /* Small Link Button Variables */\r\n    --ezLinkButton-small-font-size: 10pt;\r\n\r\n    /* Large Button Variables */\r\n    --ezLargeButtonMaxHeight: 32px;\r\n    --ezLargeButtonMaxWidth: 175px;\r\n    --ezLargeButtonMinWidth: 32px;\r\n    --ezLargeButtonTextTransform: capitalize;\r\n    --ezLargeButtonFontWeight: bold;\r\n    --ezLargeButton-border-radius: 4px;\r\n\r\n    /* Navigation Button Variables */\r\n    --ezNavButtonColor: var(--ezOrange);\r\n    --ezNavButtonColorHover: var(--ezClockerOrange);\r\n    --ezNavButtonTextColor: var(--ezBlack);\r\n    --ezNavButtonFontSize: var(--ezFontSize);\r\n    --ezNavButtonFontWeight: var(--ezLargeButtonFontWeight);\r\n    --ezNavButtonMaxHeight: var(--ezLargeButtonMaxHeight);\r\n    --ezNavButtonTextTransform: var(--ezLargeButtonTextTransform);\r\n    --ezNavButtonMaxWidth: var(--ezLargeButtonMaxWidth);\r\n    --ezNavButtonMinWidth: var(--ezLargeButtonMinWidth);\r\n    --ezNavButtonRippleEffect: var(--ezWhite);\r\n    --ezNavButton-border-radius: 4px;\r\n\r\n    /* Sign-out Button Variables */\r\n    --ezSignOutButtonColor: var(--ezClockerAqua);\r\n    --ezSignOutButtonTextColor: var(--ezWhite);\r\n    --ezSignOutButtonFontSize: var(--ezFontSize);\r\n    --ezSignOutButtonHoverColor: var(--ezDarkAqua);\r\n    --ezSignOutButtonFontWeight: var(--ezLargeButtonFontWeight);\r\n    --ezSignOutButtonTextTransform: var(--ezLargeButtonTextTransform);\r\n    --ezSignOutButtonMaxHeight: var(--ezLargeButtonMaxHeight);\r\n    --ezSignOutButtonMaxWidth: var(--ezLargeButtonMaxWidth);\r\n    --ezSignOutButtonMinWidth: var(--ezLargeButtonMinWidth);\r\n    --ezSignOutButtonMinWidth-border-radius: 4px;\r\n\r\n    /* Subscription Plan Select Button Variables */\r\n    --ezSelectPlanBtnColor: var(--ezActionGreen);\r\n    --ezSelectPlanBtnTextColor: var(--ezBlack);\r\n    --ezSelectPlanBtnFontSize: var(--ezFontSize);\r\n    --ezSelectPlanBtnHoverColor: var(--ezHoverGreen);\r\n    --ezSelectPlanBtnFontWeight: var(--ezLargeButtonFontWeight);\r\n    --ezSelectPlanTextTransform: var(--ezLargeButtonTextTransform);\r\n    --ezSelectPlanBtnMaxHeight: var(--ezLargeButtonMaxHeight);\r\n    --ezSelectPlanButtonMaxWidth: var(--ezLargeButtonMaxWidth);\r\n    --ezSelectPlanButtonMinWidth: var(--ezLargeButtonMinWidth);\r\n    --ezSelectPlanButton-border-radius: 4px;\r\n}\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    HTML Link Buttons\r\n    ##########################################################################################################################################################\r\n    Applies to HTML Tags:\r\n        <a/>\r\n    Name Templates:\r\n        ezButtons-{name}-{color}\r\n        ezButtons-{name}-{other-properties}-color}\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Large Link Buttons\r\n    Classes:\r\n        (DEPRECATED) a.ezButtonLink_default-large-navy\r\n        (DEPRECATED) a.ez-button-link-large-navy\r\n        (DEPRECATED) a.ezLargeNavyLink\r\n    ===================================================================================================================\r\n*/\r\n\r\na.ezButtonLink-hidden {\r\n    display: none;\r\n}\r\n\r\na.ezButtonLink-visible {\r\n    display: unset;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) a.ezButtonLink_default-large-navy\r\n        (DEPRECATED) a.ez-button-link-large-navy\r\n        (DEPRECATED) a.ezLargeNavyLink\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: ezButtonLink_default-large-navy */\r\na.ezButtonLink_default-large-navy,\r\na.ezButtonLink_default-large-navy:enabled,\r\na.ezButtonLink_default-large-navy:enabled:visited,\r\n/* DEPRECATED: a.ez-button-link-large-navy */\r\na.ez-button-link-large-navy,\r\na.ez-button-link-large-navy:enabled,\r\na.ez-button-link-large-navy:enabled:visited,\r\n/* DEPRECATED: a.ezLargeNavyLink */\r\na.ezLargeNavyLink,\r\na.ezLargeNavyLink:enabled,\r\na.ezLargeNavyLink:enabled:visited {\r\n    color: var(--ezClockerNavy);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-size: 14pt;\r\n    cursor: var(--ezButtons-cursor);\r\n    text-decoration: none;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) a.ezButtonLink_default-large-navy\r\n        (DEPRECATED) a.ez-button-link-large-navy\r\n        (DEPRECATED) a.ezLargeNavyLink\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n        :enabled:visited:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: ezButtonLink_default-large-navy */\r\na.ezButtonLink_default-large-navy:enabled:hover,\r\na.ezButtonLink_default-large-navy:enabled:focus:hover,\r\na.ezButtonLink_default-large-navy:enabled:visited:hover,\r\n/* DEPRECATED a.ez-button-link-large-navy */\r\na.ez-button-link-large-navy:enabled:hover,\r\na.ez-button-link-large-navy:enabled:focus:hover,\r\na.ez-button-link-large-navy:enabled:visited:hover,\r\n/* DEPRECATED a.ezLargeNavyLink */\r\na.ezLargeNavyLink:enabled:hover,\r\na.ezLargeNavyLink:enabled:focus:hover,\r\na.ezLargeNavyLink:enabled:visited:hover {\r\n    color: var(--ezHoverNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\n/* DEPRECATED: ezButtonLink_default-large-navy */\r\na.ezButtonLink_default-large-navy:enabled:active,\r\na.ezButtonLink_default-large-navy:enabled:active:hover,\r\na.ezButtonLink_default-large-navy:enabled:visited:active,\r\na.ezButtonLink_default-large-navy:enabled:visited:active:hover,\r\n/* DEPRECATED a.ez-button-link-large-navy */\r\na.ez-button-link-large-navy:enabled:active,\r\na.ez-button-link-large-navy:enabled:active:hover,\r\na.ez-button-link-large-navy:enabled:visited:active,\r\na.ez-button-link-large-navy:enabled:visited:active:hover,\r\n/* DEPRECATED a.ezLargeNavyLink */\r\na.ezLargeNavyLink:enabled:active,\r\na.ezLargeNavyLink:enabled:active:hover,\r\na.ezLargeNavyLink:enabled:visited:active,\r\na.ezLargeNavyLink:enabled:visited:active:hover {\r\n    color: var(--ezDarkNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\n/* DEPRECATED: ezButtonLink_default-large-navy */\r\na.ezButtonLink_default-large-navy:disabled,\r\na.ezButtonLink_default-large-navy:disabled:hover,\r\n/* DEPRECATED a.ez-button-link-large-navy */\r\na.ez-button-link-large-navy:disabled,\r\na.ez-button-link-large-navy:disabled:hover,\r\n/* DEPRECATED a.ezLargeNavyLink */\r\na.ezLargeNavyLink:disabled,\r\na.ezLargeNavyLink:disabled:hover {\r\n    color: var(--ezClockerGray);\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n/* DEPRECATED a.ezLargeNavyLinkDisabled */\r\na.ezLargeNavyLinkDisabled,\r\na.ezLargeNavyLinkDisabled:disabled a.ezLargeNavyLinkDisabled:disabled:hover {\r\n    color: var(--ezClockerGray);\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Default Link Buttons\r\n    Classes:\r\n        a.ezLink-ezClockerNavy\r\n        (DEPRECATED) a.ezNavyLink\r\n    ===================================================================================================================\r\n*/\r\n\r\na.ezLink-ezClockerNavy,\r\n/* DEPRECATED:  */\r\na.ezNavyLink {\r\n    color: var(--ezClockerNavy);\r\n    text-decoration: none;\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    cursor: pointer;\r\n}\r\n\r\na.ezLink-ezClockerNavy:hover,\r\n/* DEPRECATED:  */\r\na.ezNavyLink:hover {\r\n    color: var(--ezHoverNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\na.ezLink-ezClockerNavy:hover:enabled,\r\n/* DEPRECATED:  */\r\na.ezNavyLink:hover:enabled {\r\n    color: var(--ezHoverNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\na.ezLink-ezClockerNavy:hover:active,\r\n/* DEPRECATED:  */\r\na.ezNavyLink:hover:active {\r\n    color: var(--ezDarkNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\na.ezLink-ezClockerNavy:visited,\r\n/* DEPRECATED:  */\r\na.ezNavyLink:visited {\r\n    color: var(--ezClockerNavy);\r\n    text-decoration: none;\r\n}\r\n\r\na.ezLink-ezClockerNavy:disabled,\r\n/* DEPRECATED:  */\r\na.ezNavyLink:disabled {\r\n    color: var(--ezClockerGray);\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n/* DEPRECATED:  */\r\na.ezNavyLinkDisabled {\r\n    color: var(--ezClockerGray);\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    HTML Link 'Button' Classes\r\n    ##########################################################################################################################################################\r\n    Applies to HTML Tags:\r\n        <a/>\r\n    Name Templates:\r\n        ezButtons-link-{name}-{color}\r\n        ezButtons-link-{name}-{other-properties}-color}\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Default Link Buttons\r\n    Classes:\r\n        a.ezButton-link-ezClockerOrange\r\n        a.ezButton-link-ezClockerWhite\r\n        a.ezButton-link-ezClockerHotGreen\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :link\r\n        :visited\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerOrange,\r\na.ezButton-link-ezClockerOrange:link,\r\na.ezButton-link-ezClockerOrange:visited {\r\n    margin: 0;\r\n    padding: 4px;\r\n    /* Variable --ezClockerOrange defined in ez-body.css */\r\n    background-color: var(--ezClockerOrange);\r\n    text-decoration: none;\r\n    /* Variable --ezContentFontColor defined in ez-body.css */\r\n    color: var(--ezContentFontColor);\r\n    /* Variable ezFontFamily defined in ez-body.css */\r\n    font-family: var(--ezFontFamily);\r\n    /* Variable --ezContentFontSize defined in ez-body.css */\r\n    font-size: var(--ezContentFontSize);\r\n    /* Variable --ezContentFontWeigth defined in ez-body.css */\r\n    font-weight: var(--ezContentFontWeigth);\r\n    /* Variable --ezContentFontStyle defined in ez-body.css */\r\n    font-style: var(--ezContentFontStyle);\r\n    /* Variable --ezBorderOrange defined in ez-body.css */\r\n    border-color: var(--ezBorderOrange);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :active\r\n        :active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezclockerOrange:active,\r\na.ezButton-link-ezclockerOrange:active:hover {\r\n    box-shadow: var(--ezBoxShadow-inset-ezClockerOrange-50);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover\r\n        :visited:hove\r\n        :active:hover\r\n        :link:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerOrange:hover,\r\na.ezButton-link-ezClockerOrange:visited:hover,\r\na.ezButton-link-ezClockerOrange:link:hover {\r\n    background-color: var(--ezHoverOrange);\r\n    box-shadow: unset;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n        :disabled:visited\r\n        :disabled:link\r\n        :disabled:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerOrange:disabled,\r\na.ezButton-link-ezClockerOrange:disabled:active,\r\na.ezButton-link-ezClockerOrange:disabled:hover,\r\na.ezButton-link-ezClockerOrange:disabled:visited,\r\na.ezButton-link-ezClockerOrange:disabled:link {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezBorderOrange);\r\n    border-color: var(--ezOrange);\r\n    box-shadow: unset;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerWhite\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :link\r\n        :visited\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerWhite,\r\na.ezButton-link-ezClockerWhite:link,\r\na.ezButton-link-ezClockerWhite:visited {\r\n    margin: 0;\r\n    padding: 4px;\r\n    /* Variable --ezClockerOrange defined in ez-body.css */\r\n    background-color: var(--ezClockerWhite);\r\n    text-decoration: none;\r\n    /* Variable --ezContentFontColor defined in ez-body.css */\r\n    color: var(--ezContentFontColor);\r\n    /* Variable ezFontFamily defined in ez-body.css */\r\n    font-family: var(--ezFontFamily);\r\n    /* Variable --ezContentFontSize defined in ez-body.css */\r\n    font-size: var(--ezContentFontSize);\r\n    /* Variable --ezContentFontWeigth defined in ez-body.css */\r\n    font-weight: var(--ezContentFontWeigth);\r\n    /* Variable --ezContentFontStyle defined in ez-body.css */\r\n    font-style: var(--ezContentFontStyle);\r\n    /* Variable --ezBorderOrange defined in ez-body.css */\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerWhite\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :active\r\n        :active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerWhite:active,\r\na.ezButton-link-ezClockerWhite:active:hover {\r\n    box-shadow: var(--ezBoxShadow-inset-ezClockerGray-50);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerWhite\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover\r\n        :visited:hove\r\n        :active:hover\r\n        :link:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerWhite:hover,\r\na.ezButton-link-ezClockerWhite:visited:hover,\r\na.ezButton-link-ezClockerWhite:link:hover {\r\n    background-color: var(--ezClockerSilver);\r\n    box-shadow: unset;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerWhite\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n        :disabled:visited\r\n        :disabled:link\r\n        :disabled:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerWhite:disabled,\r\na.ezButton-link-ezClockerWhite:disabled:hover,\r\na.ezButton-link-ezClockerWhite:disabled:visited,\r\na.ezButton-link-ezClockerWhite:disabled:link,\r\na.ezButton-link-ezClockerWhite:disabled:active {\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerGray);\r\n    border-color: var(--ezClockerSilver);\r\n    box-shadow: unset;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerHotGreen\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :link\r\n        :visited\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerHotGreen,\r\na.ezButton-link-ezClockerHotGreen:link,\r\na.ezButton-link-ezClockerHotGreen:visited {\r\n    margin: 0;\r\n    padding: 4px;\r\n    /* Variable --ezClockerOrange defined in ez-body.css */\r\n    background-color: var(--ezClockerHotGreen);\r\n    text-decoration: none;\r\n    /* Variable --ezContentFontColor defined in ez-body.css */\r\n    color: var(--ezContentFontColor);\r\n    /* Variable ezFontFamily defined in ez-body.css */\r\n    font-family: var(--ezFontFamily);\r\n    /* Variable --ezContentFontSize defined in ez-body.css */\r\n    font-size: var(--ezContentFontSize);\r\n    /* Variable --ezContentFontWeigth defined in ez-body.css */\r\n    font-weight: var(--ezContentFontWeigth);\r\n    /* Variable --ezContentFontStyle defined in ez-body.css */\r\n    font-style: var(--ezContentFontStyle);\r\n    /* Variable --ezBorderOrange defined in ez-body.css */\r\n    border-color: var(--ezBorderHotGreen);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerHotGreen\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :active\r\n        :active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerHotGreen:active,\r\na.ezButton-link-ezClockerHotGreen:active:hover {\r\n    box-shadow: var(--ezBoxShadow-inset-ezBorderHotGreen-50);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerHotGreen\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover\r\n        :visited:hove\r\n        :link:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerHotGreen:hover,\r\na.ezButton-link-ezClockerHotGreen:visited:hover,\r\na.ezButton-link-ezClockerHotGreen:link:hover {\r\n    background-color: var(--ezHoverHotGreen);\r\n    box-shadow: unset;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-link-ezClockerHotGreen\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n        :disabled:visited\r\n        :disabled:link\r\n        :disabled:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-link-ezClockerHotGreen:disabled,\r\na.ezButton-link-ezClockerHotGreen:disabled:hover,\r\na.ezButton-link-ezClockerHotGreen:disabled:visited,\r\na.ezButton-link-ezClockerHotGreen:disabled:link,\r\na.ezButton-link-ezClockerHotGreen:disabled:active {\r\n    background-color: var(--ezHoverHotGreen);\r\n    color: var(--ezBorderHotGreen);\r\n    border-color: var(--ezClockerHotGreen);\r\n    box-shadow: unset;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Small Link Buttons\r\n        a.ezButtonLink_default-small-navy\r\n        (DEPRECATED) a.ezSmallNavyLink\r\n        (DEPRECATED) a.ez-button-link-small-navy\r\n        (DEPRECATED) a.ezSmallNavyLinkDisabled\r\n    ===================================================================================================================\r\n*/\r\n\r\n/* -------------------------------------------------\r\n| [Link Button]\r\n|   ezButtonLink_default-small-navy\r\n|   (DEPRECATED) ez-button-link-small-navy\r\n|   (DEPRECATED) ezSmallNavyLink\r\n------------------------------------------------- */\r\na.ezButtonLink_default-small-navy,\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLink,\r\n/* DEPRECATED:  */\r\na.ez-button-link-small-navy {\r\n    color: var(--ezClockerNavy);\r\n    font-family: var(--ezFontFamily);\r\n    text-decoration: none;\r\n    font-size: 10pt;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    cursor: pointer;\r\n}\r\n\r\na.ezButtonLink_default-small-navy:hover,\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLink:hover,\r\n/* DEPRECATED:  */\r\na.ez-button-link-small-navy:hover {\r\n    color: var(--ezHoverNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\na.ezButtonLink_default-small-navy:hover:enabled,\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLink:hover:enabled,\r\n/* DEPRECATED:  */\r\na.ez-button-link-small-navy:hover:enabled {\r\n    color: var(--ezHoverNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\na.ezButtonLink_default-small-navy:hover:active,\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLink:hover:active,\r\n/* DEPRECATED:  */\r\na.ez-button-link-small-navy:hover:active {\r\n    color: var(--ezDarkNavy);\r\n    text-decoration: underline;\r\n}\r\n\r\na.ezButtonLink_default-small-navy:visited,\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLink:visited,\r\n/* DEPRECATED:  */\r\na.ez-button-link-small-navy:visited {\r\n    color: var(--ezClockerNavy);\r\n    text-decoration: none;\r\n}\r\n\r\na.ezButtonLink_default-small-navy:disabled,\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLink:disabled,\r\n/* DEPRECATED:  */\r\na.ez-button-link-small-navy:disabled {\r\n    color: var(--ezClockerGray);\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n/* DEPRECATED:  */\r\na.ezSmallNavyLinkDisabled {\r\n    color: var(--ezClockerGray);\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Action Link Buttons\r\n    Classes:\r\n        a.ezButtonLink_action-normal-green\r\n        (DEPRECATED) a.ezActionLink\r\n    ===================================================================================================================\r\n*/\r\n\r\n/* -------------------------------------------------\r\n| [Link Button]\r\n|   ezButtonLink_action-normal-green\r\n|   (DEPRECATED) ezActionLink\r\n------------------------------------------------- */\r\na.ezButtonLink_action-normal-green:link,\r\n/* DEPRECATED:  */\r\na.ezActionLink:link {\r\n    margin: 0;\r\n    padding: 8px;\r\n    background-color: var(--ezActionGreen);\r\n    text-decoration: none;\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\na.ezButtonLink_action-normal-green:hover:enabled,\r\n/* DEPRECATED:  */\r\na.ezActionLink:hover:enabled {\r\n    background-color: var(--ezHoverHotGreen);\r\n}\r\n\r\na.ezButtonLink_action-normal-green:hover:active,\r\n/* DEPRECATED:  */\r\na.ezActionLink:hover:active {\r\n    background-color: var(--ezDarkHotGreen);\r\n}\r\n\r\na.ezButtonLink_action-normal-green:visited,\r\n/* DEPRECATED:  */\r\na.ezActionLink:visited {\r\n    margin: 0;\r\n    padding: 8px;\r\n    text-decoration: none;\r\n    background-color: var(--ezActionGreen);\r\n    font-style: normal;\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Download Link Buttons\r\n    Classes:\r\n        a.ezButtonLink_download-normal-navy\r\n        (DEPRECATED) a.ezDownloadLink\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButtonLink_download-normal-navy\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :link\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButtonLink_download-normal-navy:link,\r\n/* DEPRECATED: ezDownloadLink */\r\na.ezDownloadLink:link {\r\n    margin: 0;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerNavy);\r\n    text-decoration: none;\r\n    color: var(--ezClockerWhite);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButtonLink_download-normal-navy\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover:enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButtonLink_download-normal-navy:hover:enabled,\r\n/* DEPRECATED: ezDownloadLink */\r\na.ezDownloadLink:hover:enabled {\r\n    background-color: var(--ezHoverNavy);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButtonLink_download-normal-navy\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButtonLink_download-normal-navy:hover:active,\r\n/* DEPRECATED: ezDownloadLink */\r\na.ezDownloadLink:hover:active {\r\n    background-color: var(--ezDarkNavy);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButtonLink_download-normal-navy\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :visited\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButtonLink_download-normal-navy:visited,\r\n/* DEPRECATED: ezDownloadLink */\r\na.ezDownloadLink:visited {\r\n    margin: 0;\r\n    padding: 8px;\r\n    text-decoration: none;\r\n    background-color: var(--ezClockerNavy);\r\n    font-style: normal;\r\n    color: var(--ezClockerWhite);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    cursor: pointer;\r\n}\r\n\r\na.ezButtonLink_download-normal-navy:disabled,\r\n/* DEPRECATED: ezDownloadLink */\r\na.ezDownloadLink:disabled {\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerSilver);\r\n    border-color: var(--ezLightNavy);\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Help/More Info Link Buttons\r\n    Classes:\r\n        a.ezButton-what-is-this-link\r\n        a.ezButton-what-is-this-link-margin-top4px\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-what-is-this-link\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-what-is-this-link {\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    font-size: small;\r\n    text-decoration: none;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-what-is-this-link\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-what-is-this-link:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-what-is-this-link-margin-top4px\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-what-is-this-link-margin-top4px {\r\n    margin-top: 4px;\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    font-size: small;\r\n    text-decoration: none;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-what-is-this-link-margin-top4px\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-what-is-this-link-margin-top4px:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-what-is-this-link\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-show-more-details-link {\r\n    /* top right bottom left */\r\n    padding: 4px 4px 4px 18px;\r\n    background-color: transparent;\r\n    background-size: 10px 10px;\r\n    background-position: 4px center;\r\n    background-repeat: no-repeat;\r\n    background-image: url('/public/images/icons/expand-ezClockerNavy.svg');\r\n    /* --ezClockerNavy from ez-body.css */\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    /* --ezSmallFontSize from ez-text.css */\r\n    font-size: var(--ezSmallFontSize);\r\n    text-decoration: none;\r\n    border-style: none;\r\n    cursor: pointer;\r\n\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        a.ezButton-what-is-this-link\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\na.ezButton-show-more-details-link:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    HTML Input Buttons\r\n    ##########################################################################################################################################################\r\n    Applies to HTML Tags:\r\n        <input type=\"button\"/>\r\n    Name Templates:\r\n        ezButtons-{name}-{color}\r\n        ezButtons-{name}-{other-properties}-color}\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Major Input Buttons\r\n    ===================================================================================================================\r\n*/\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Input Buttons\r\n| HTML Tags: <input type=\"button\"/>\r\n|-------------------------------------------------\r\n| Template: ezInputButton_{name}-{size}-{color}\r\n|\r\n| Official Classes:\r\n|   ezInputButton_major-normal-orange\r\n|   ezInputButton_action-normal-ezActionGreen\r\n|\r\n| Deprecated Classes:\r\n|   ez-major-button\r\n|   ez-action-button\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n/*-------------------------------------------------\r\n| [Input Button]\r\n|   ezInputButton_major-normal-orange\r\n|   (DEPRECATED) ez-major-button\r\n------------------------------------------------- */\r\n/* DEPRECATED:  */\r\ninput[type=\"button\"].ez-major-button,\r\ninput[type=\"button\"].ezInputButton_major-normal-orange {\r\n    /* ez-major-button style */\r\n    display: inline-block;\r\n    background-color: var(--ezClockerOrange);\r\n    padding: 6px 24px;\r\n    font-family: var(--ezButtons-font-family);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    border: 1px solid var(--ezClockerBlack);\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* DEPRECATED:  */\r\ninput[type=\"button\"].ez-major-button:hover:enabled,\r\ninput[type=\"button\"].ezInputButton_major-normal-orange:hover:enabled {\r\n    background-color: #ffcc66;\r\n}\r\n\r\n/* DEPRECATED:  */\r\ninput[type=\"button\"].ez-major-button:hover:active,\r\ninput[type=\"button\"].ezInputButton_major-normal-orange:hover:active {\r\n    background-color: #ff9933;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Default Action Input Buttons\r\n    ===================================================================================================================\r\n*/\r\n\r\n\r\n/* -------------------------------------------------\r\n| [Input Button]\r\n|   ezInputButton_action-normal-ezActionGreen\r\n|   (DEPRECATED) ez-action-button\r\n------------------------------------------------- */\r\ninput[type=\"button\"].ez-action-button,\r\ninput[type=\"button\"].ezInputButton_action-normal-ezActionGreen {\r\n    background-color: var(--ezActionGreen);\r\n    border: 1px solid var(--ezActionGreenBorderColor);\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n    border-radius: 3px;\r\n}\r\n\r\ninput[type=\"button\"].ez-action-button:hover:enabled,\r\ninput[type=\"button\"].ezInputButton_action-normal-ezActionGreen:hover:enabled {\r\n    background-color: var(--ezActionGreenHoverColor);\r\n}\r\n\r\ninput[type=\"button\"].ez-action-button:hover:active,\r\ninput[type=\"button\"].ezInputButton_action-normal-ezActionGreen:hover:active {\r\n    color: var(--ezActionGreenHoverColor);\r\n    background-color: var(--ezActionGreenBorderColor);\r\n}\r\n\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Default Edit Input Buttons\r\n    ===================================================================================================================\r\n*/\r\n\r\n/* -------------------------------------------------\r\n| [Input Button]\r\n|   ezInputButton_edit-normal-ezClockerOffWhite\r\n|   (DEPRECATED) ez-edit-button\r\n------------------------------------------------- */\r\ninput[type=\"button\"].ezInputButton_edit-normal-ezClockerOffWhite,\r\n/* DEPRECATED: input[type=\"button\"].ez-edit-button */\r\ninput[type=\"button\"].ez-edit-button {\r\n    display: inline-block;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    text-decoration: none;\r\n    border: 1px solid var(--ezBorderOffWhite);\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\ninput[type=\"button\"].ezInputButton_edit-normal-ezClockerOffWhite:hover:enabled,\r\n/* DEPRECATED: input[type=\"button\"].ez-edit-button */\r\ninput[type=\"button\"].ez-edit-button:hover:enabled {\r\n    background-color: var(--ezHoverOffWhite);\r\n}\r\n\r\n\r\ninput[type=\"button\"].ezInputButton_edit-normal-ezClockerOffWhite:hover:active,\r\n/* DEPRECATED: input[type=\"button\"].ez-edit-button */\r\ninput[type=\"button\"].ez-edit-button:hover:active {\r\n    background-color: var(--ezDarkOffWhite);\r\n}\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    HTML Button Classes\r\n    ##########################################################################################################################################################\r\n    Applies to HTML Tags:\r\n        <button/>\r\n    Name Templates:\r\n        ezButtons-{name}-{color}\r\n        ezButtons-{name}-{other-properties}-color}\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Default Buttons\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezButton\r\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton,\r\nbutton:enabled,\r\nbutton.ezButton-default-ezClockerOrange,\r\nbutton.ezButton-default-ezClockerOrange:enabled,\r\n/* DEPRECATED: ezButton */\r\nbutton.ezButton,\r\nbutton.ezButton:enabled,\r\n/* DEPRECATED: ezButton_default-normal-ezClockerOrange */\r\nbutton.ezButton_default-normal-ezClockerOrange,\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled {\r\n    padding: 6px 24px;\r\n    margin: 2px;\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 10pt;\r\n    font-weight: normal;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-radius: 3px;\r\n    box-shadow: 0 0 1px 1px transparent;\r\n    outline-style: none;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezButton\r\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton:enabled:focus,\r\nbutton.ezButton-default-ezClockerOrange:enabled:focus,\r\n/* DEPRECATED: button.ezButton */\r\nbutton.ezButton:enabled:focus,\r\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezClockerBlack);\r\n    /* box-shadow: 0 0 1px 1px transparent; */\r\n    outline-width: 0;\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezButton\r\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton:enabled:hover,\r\nbutton:enabled:focus:hover,\r\nbutton.ezButton-default-ezClockerOrange:enabled:hover,\r\nbutton.ezButton-default-ezClockerOrange:enabled:focus:hover,\r\n/* DEPRECATED: button.ezButton */\r\nbutton.ezButton:enabled:hover,\r\nbutton.ezButton:enabled:focus:hover,\r\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:hover,\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus:hover {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\r\n    outline-color: var(--ezClockerGray);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezButton\r\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    States:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton:enabled:active,\r\nbutton:enabled:active:hover,\r\nbutton:enabled:focus:active,\r\nbutton:enabled:focus:active:hover,\r\nbutton.ezButton-default-normal-ezClockerOrange:enabled:active,\r\nbutton.ezButton-default-normal-ezClockerOrange:enabled:active:hover,\r\nbutton.ezButton-default-normal-ezClockerOrange:enabled:focus:active,\r\nbutton.ezButton-default-normal-ezClockerOrange:enabled:focus:active:hover,\r\n/* DEPRECATED: button.ezButton */\r\nbutton.ezButton:enabled:active,\r\nbutton.ezButton:enabled:active:hover,\r\nbutton.ezButton:enabled:focus:active,\r\nbutton.ezButton:enabled:focus:active:hover,\r\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:active,\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:active:hover,\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus:active,\r\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus:active:hover {\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow:\r\n        0 0 1px 1px transparent,\r\n        inset 0 0 4px 2px rgba(198, 118, 0, 0.5);\r\n    outline-color: var(--ezClockerGray);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezButton\r\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton:disabled,\r\nbutton:disabled:hover,\r\nbutton.ezButton-default-normal-ezClockerOrange:disabled,\r\nbutton.ezButton-default-normal-ezClockerOrange:disabled:hover,\r\n/* DEPRECATED: button.ezButton */\r\nbutton.ezButton:disabled,\r\nbutton.ezButton:disabled:hover,\r\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\r\nbutton.ezButton_default-normal-ezClockerOrange:disabled,\r\nbutton.ezButton_default-normal-ezClockerOrange:disabled:hover {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezBorderOrange);\r\n    border-color: var(--ezClockerOrange);\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]:\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) button.disabledButton\r\n        (DEPRECATED) button.ezDisabledButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        all\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: button.disabledButton  */\r\nbutton.disabledButton,\r\nbutton.disabledButton:disabled,\r\nbutton.disabledButton:disabled:hover,\r\n/* DEPRECATED: button.ezDisabledButton  */\r\nbutton.ezDisabledButton,\r\nbutton.ezDisabledButton:disabled,\r\nbutton.ezDisabledButton:disabled:hover {\r\n    padding: 6px 24px;\r\n    margin: 2px;\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezBorderOrange);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 10pt;\r\n    font-weight: normal;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    border-color: var(--ezClockerOrange);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-radius: 3px;\r\n    box-shadow: 0 0 1px 1px transparent;\r\n    outline-style: none;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n====================================================================================================================\r\n| [Class Group]\r\n| EzClocker Header Buttons\r\n====================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-header-ezClockerOrange\r\n        (DEPRECATED) button.ezHeaderButton\r\n        (DEPRECATED) button.headerButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-header-ezClockerOrange,\r\nbutton.ezButtons-header-ezClockerOrange:enabled,\r\n/* DEPRECATED: button.ezHeaderButton */\r\nbutton.ezHeaderButton,\r\nbutton.ezHeaderButton:enabled,\r\n/* DEPRECATED: button.headerButton */\r\nbutton.headerButton,\r\nbutton.headerButton:enabled {\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-header-ezClockerOrange\r\n        (DEPRECATED) button.ezHeaderButton\r\n        (DEPRECATED) button.headerButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-header-ezClockerOrange:enabled:focus,\r\n/* DEPRECATED: button.ezHeaderButton */\r\nbutton.ezHeaderButton:enabled:focus,\r\n/* DEPRECATED: button.headerButton */\r\nbutton.headerButton:enabled:focus {\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-header-ezClockerOrange\r\n        (DEPRECATED) button.ezHeaderButton\r\n        (DEPRECATED) button.headerButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-header-ezClockerOrange:enabled:hover,\r\nbutton.ezButtons-header-ezClockerOrange:enabled:focus:hover,\r\n/* DEPRECATED: button.headerButton */\r\nbutton.headerButton:enabled:hover,\r\nbutton.headerButton:enabled:focus:hover,\r\n/* DEPRECATED: button.ezHeaderButton */\r\nbutton.ezHeaderButton:enabled:hover,\r\nbutton.ezHeaderButton:enabled:focus:hover {\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-header-ezClockerOrange\r\n        (DEPRECATED) button.ezHeaderButton\r\n        (DEPRECATED) button.headerButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-header-ezClockerOrange:enabled:active,\r\nbutton.ezButtons-header-ezClockerOrange:enabled:active:hover,\r\nbutton.ezButtons-header-ezClockerOrange:enabled:focus:active,\r\nbutton.ezButtons-header-ezClockerOrange:enabled:focus:active:hover,\r\nbutton.ezHeaderButton:enabled:active,\r\nbutton.ezHeaderButton:enabled:active:hover,\r\nbutton.ezHeaderButton:enabled:focus:active,\r\nbutton.ezHeaderButton:enabled:focus:active:hover,\r\nbutton.headerButton:enabled:active,\r\nbutton.headerButton:enabled:active:hover,\r\nbutton.headerButton:enabled:focus:active,\r\nbutton.headerButton:enabled:focus:active:hover {\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-header-ezClockerOrange\r\n        (DEPRECATED) button.ezHeaderButton\r\n        (DEPRECATED) button.headerButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-header-ezClockerOrange:disabled,\r\nbutton.ezButtons-header-ezClockerOrange:disabled:hover,\r\n/* DEPRECATED: button.headerButton */\r\nbutton.ezHeaderButton:disabled,\r\nbutton.ezHeaderButton:disabled:hover,\r\n/* DEPRECATED: button.headerButton */\r\nbutton.headerButton:disabled,\r\nbutton.headerButton:disabled:hover {\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) button.ezDisabledHeaderButton\r\n        (DEPRECATED) button.disabledHeaderButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: button.ezDisabledHeaderButton */\r\nbutton.ezDisabledHeaderButton,\r\nbutton.ezDisabledHeaderButton:disabled,\r\nbutton.ezDisabledHeaderButton:disabled:hover,\r\n/* DEPRECATED: button.disabledHeaderButton */\r\nbutton.disabledHeaderButton,\r\nbutton.disabledHeaderButton:disabled,\r\nbutton.disabledHeaderButton:disabled:hover {\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-header-down-ezClockerOrange\r\n        (DEPRECATED) button.ezHeaderButtonDown\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled\r\n        :enabled:hover,\r\n        :enabled:active,\r\n        :enabled:focus,\r\n        :disabled,\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-header-down-ezClockerOrange,\r\nbutton.ezButtons-header-down-ezClockerOrange:enabled,\r\nbutton.ezButtons-header-down-ezClockerOrange:enabled:hover,\r\nbutton.ezButtons-header-down-ezClockerOrange:enabled:active,\r\nbutton.ezButtons-header-down-ezClockerOrange:enabled:focus,\r\n/* DEPRECATED: button.ezHeaderButtonDown */\r\nbutton.ezHeaderButtonDown,\r\nbutton.ezHeaderButtonDown:enabled,\r\nbutton.ezHeaderButtonDown:enabled:hover,\r\nbutton.ezHeaderButtonDown:enabled:active,\r\nbutton.ezHeaderButtonDown:enabled:focus,\r\nbutton.ezHeaderButtonDown:disabled,\r\nbutton.ezHeaderButtonDown:disabled:hover {\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezDimOrange);\r\n    border-left-color: var(--ezBorderOrange);\r\n    border-top-color: var(--ezBorderOrange);\r\n    border-right-color: var(--ezOrange);\r\n    border-bottom-color: var(--ezOrange);\r\n}\r\n\r\n/*\r\n\r\n/*\r\n====================================================================================================================\r\n| [Class Group]\r\n| EzClocker Toggle Buttons\r\n====================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezLargeToggleButton-2col-container\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        all\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-toggle-button-large-2col-container {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-row-gap: 4px;\r\n    grid-column-gap: 4px;\r\n    justify-content: center;\r\n    align-content: center;\r\n    margin: 10px 10px 0;\r\n    padding: 10px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 14pt;\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-toggle-button-large-unselected\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-toggle-button-large-unselected,\r\nbutton.ezButtons-toggle-button-large-unselected:enabled {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 14pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-toggle-button-large-unselected\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-toggle-button-large-unselected:enabled:hover,\r\n.ezButtons-toggle-button-large-unselected:enabled:focus:hover {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 14pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-toggle-button-large-unselected\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-toggle-button-large-unselected:enabled:active,\r\nbutton.ezButtons-toggle-button-large-unselected:enabled:active:hover,\r\nbutton.ezButtons-toggle-button-large-unselected:enabled:focus:active,\r\nbutton.ezButtons-toggle-button-large-unselected:enabled:focus:active:hover {\r\n    background-color: var(--ezHoverNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 14pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\r\n    outline-color: var(--ezNavy-alpha-50);\r\n    outline-width: 1px;\r\n    outline-style: auto;\r\n    outline-offset: 2px;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-toggle-button-large-unselected\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-toggle-button-large-unselected:disabled,\r\nbutton.ezButtons-toggle-button-large-unselected:disabled:hover {\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerGray);\r\n    font-size: 14pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezClockerSilver);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-toggle-button-large-selected\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n        :enabled:hover\r\n        :enabled:active,\r\n        :enabled:active:hover\r\n        :enabled:focus\r\n        :enabled:focus:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-toggle-button-large-selected,\r\nbutton.ezButtons-toggle-button-large-selected:enabled,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:hover,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:active,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:active:hover,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:focus,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:focus:hover,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:focus:active,\r\nbutton.ezButtons-toggle-button-large-selected:enabled:focus:active:hover {\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderNavy);\r\n    border-width: 2px;\r\n    box-shadow: none;\r\n    outline-style: none;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-toggle-button-large-selected\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-toggle-button-large-selected:disabled,\r\nbutton.ezButtons-toggle-button-large-selected:disabled:hover {\r\n    background-color: var(--ezHoverNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerNavy);\r\n    box-shadow: none;\r\n    outline-style: none;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/*\r\n====================================================================================================================\r\n| [Class Group]\r\n| EzClocker Major Buttons\r\n====================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-major-mini-ezClockerYellow\r\n        (DEPRECATED) button.ezMiniMajorButton\r\n        (DEPRECATED) button.miniMajorButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-major-mini-ezClockerYellow,\r\n.ezButtons-major-mini-ezClockerYellow:enabled,\r\n/* DEPRECATED: button.ezMiniMajorButton */\r\nbutton.ezMiniMajorButton,\r\nbutton.ezMiniMajorButton:enabled,\r\n/* DEPRECATED:  */\r\nbutton.miniMajorButton,\r\nbutton.miniMajorButton:enabled {\r\n    font-size: 8pt;\r\n    font-weight: bold;\r\n    background-color: var(--ezClockerYellow);\r\n    border-color: var(--ezClockerGray);\r\n    color: var(--ezClockerBlack);\r\n    border-radius: 3px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-major-mini-ezClockerYellow\r\n        (DEPRECATED) button.ezMiniMajorButton\r\n        (DEPRECATED) button.miniMajorButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:hover,\r\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:active:hover,\r\n/* DEPRECATED: button.ezMiniMajorButton */\r\nbutton.ezMiniMajorButton:enabled:hover,\r\nbutton.ezMiniMajorButton:enabled:active:hover,\r\n/* DEPRECATED: button.miniMajorButton */\r\nbutton.miniMajorButton:enabled:hover,\r\nbutton.miniMajorButton:enabled:active:hover {\r\n    background-color: var(--ezLightYellow);\r\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezMiniMajorButton\r\n        (DEPRECATED) button.miniMajorButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:focus:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:active,\r\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:focus:active,\r\n/* DEPRECATED: button.ezMiniMajorButton */\r\nbutton.ezMiniMajorButton:enabled:active,\r\n/* DEPRECATED: button.ezMiniMajorButton */\r\nbutton.miniMajorButton:enabled:focus:active {\r\n    background-color: var(--ezLightYellow);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButton-default-normal-ezClockerOrange\r\n        (DEPRECATED) button.ezMiniMajorButton\r\n        (DEPRECATED) button.miniMajorButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-major-mini-ezClockerYellow:disabled,\r\nbutton.ezButtons-major-mini-ezClockerYellow:disabled:hover,\r\n/* DEPRECATED: button.ezMiniMajorButton */\r\nbutton.ezMiniMajorButton:disabled,\r\nbutton.ezMiniMajorButton:disabled:hover,\r\n/* DEPRECATED: button.ezMiniMajorButton */\r\nbutton.miniMajorButton:disabled,\r\nbutton.miniMajorButton:disabled:hover {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    border-color: var(--ezDarkYellow);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) button.ezDisabledMiniMajorButton\r\n        (DEPRECATED) button.disabledMiniMajorButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: button.ezDisabledMiniMajorButton */\r\nbutton.ezDisabledMiniMajorButton,\r\nbutton.ezDisabledMiniMajorButton:disabled,\r\nbutton.ezDisabledMiniMajorButton:disabled:hover,\r\n/* DEPRECATED: button.ezDisabledMiniMajorButton */\r\nbutton.disabledMiniMajorButton:disabled,\r\nbutton.disabledMiniMajorButton:disabled:hover,\r\nbutton.disabledMiniMajorButton {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    border-color: var(--ezDarkYellow);\r\n}\r\n\r\n\r\n/*\r\n====================================================================================================================\r\n| [Class Group]\r\n| EzClocker Mini Buttons\r\n====================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-default-mini-ezClockerYellow\r\n        (DEPRECATED) button.ezMiniNormalButton\r\n        (DEPRECATED) button.miniNormalButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-default-mini-ezClockerYellow,\r\nbutton.ezButtons-default-mini-ezClockerYellow:enabled,\r\n/* DEPRECATED: button.ezMiniNormalButton */\r\nbutton.ezMiniNormalButton,\r\nbutton.ezMiniNormalButton:enabled,\r\n/* DEPRECATED: button.miniNormalButton */\r\nbutton.miniNormalButton,\r\nbutton.miniNormalButton:enabled {\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 8pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezClockerGray);\r\n    border-radius: 3px;\r\n}\r\n\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-default-mini-ezClockerYellow\r\n        (DEPRECATED) button.ezMiniNormalButton\r\n        (DEPRECATED) button.miniNormalButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-default-mini-ezClockerYellow:enabled:hover,\r\nbutton.ezButtons-default-mini-ezClockerYellow:enabled:focus:hover,\r\n/* DEPRECATED: button.ezMiniNormalButton */\r\nbutton.ezMiniNormalButton:enabled:hover,\r\nbutton.ezMiniNormalButton:enabled:focus:hover,\r\n/* DEPRECATED: button.miniNormalButton */\r\nbutton.miniNormalButton:enabled:hover,\r\nbutton.miniNormalButton:enabled:focus:hover {\r\n    background-color: var(--ezLightYellow);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-default-mini-ezClockerYellow\r\n        (DEPRECATED) button.ezMiniNormalButton\r\n        (DEPRECATED) button.miniNormalButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-default-mini-ezClockerYellow:enabled:active,\r\n/* DEPRECATED: button.ezMiniNormalButton */\r\nbutton.ezMiniNormalButton:enabled:active,\r\n/* DEPRECATED: button.miniNormalButton */\r\nbutton.miniNormalButton:enabled:active {\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50)\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-default-mini-ezClockerYellow\r\n        (DEPRECATED) button.ezMiniNormalButton\r\n        (DEPRECATED) button.miniNormalButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-default-mini-ezClockerYellow:disabled,\r\nbutton.ezButtons-default-mini-ezClockerYellow:disabled:hover,\r\n/* DEPRECATED: button.ezMiniNormalButton */\r\nbutton.ezMiniNormalButton:disabled,\r\nbutton.ezMiniNormalButton:disabled:hover,\r\n/* DEPRECATED: button.miniNormalButton */\r\nbutton.miniNormalButton:disabled,\r\nbutton.miniNormalButton:disabled:hover {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    border-color: var(--ezDarkYellow);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) button.ezDisabledMiniNormalButton\r\n        (DEPRECATED) button.disabledMiniNormalButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: button.disabledMiniNormalButton */\r\nbutton.ezDisabledMiniNormalButton,\r\nbutton.ezDisabledMiniNormalButton:disabled,\r\nbutton.ezDisabledMiniNormalButton:disabled:hover,\r\n/* DEPRECATED: button.disabledMiniNormalButton */\r\nbutton.disabledMiniNormalButton,\r\nbutton.disabledMiniNormalButton:disabled,\r\nbutton.disabledMiniNormalButton:disabled:hover {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    border-color: var(--ezDarkYellow);\r\n}\r\n\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezDialogButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezDialogButton {\r\n    padding: 18px;\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezDialogButton:hover {\r\n    padding: 18px;\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\nbutton.ezDialogButton:active {\r\n    padding: 18px;\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\nbutton.ezDialogButton:disabled {\r\n    padding: 18px;\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n}\r\n\r\nbutton.ezDisabledDialogButton {\r\n    padding: 18px;\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezWhiteDialogButton {\r\n    padding: 18px 24px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezWhiteDialogButton:hover {\r\n    padding: 18px 24px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\nbutton.ezWhiteDialogButton:hover:active,\r\nbutton.ezWhiteDialogButton:active {\r\n    padding: 18px 24px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    box-shadow: var(--ezBoxShadow-inset-ezclocker-black-50);\r\n}\r\n\r\nbutton.ezWhiteDialogButton:disabled {\r\n    padding: 18px 24px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerStone);\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n}\r\n\r\nbutton.ezDisabledWhiteDialogButton {\r\n    padding: 18px 24px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerStone);\r\n    vertical-align: middle;\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-radius: 3px;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezMajorButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezMajorButton,\r\nbutton.ezMajorButton:enabled,\r\n/* DEPRECATED: button.majorButton */\r\nbutton.majorButton,\r\nbutton.majorButton:enabled {\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezMajorButton:enabled:focus,\r\n/* DEPRECATED: button.majorButton */\r\nbutton.majorButton:enabled:focus {\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    background-color: var(--ezLightYellow);\r\n}\r\n\r\nbutton.ezMajorButton:enabled:hover,\r\nbutton.ezMajorButton:enabled:focus:hover,\r\n/* DEPRECATED: button.majorButton */\r\nbutton.majorButton:enabled:hover,\r\nbutton.majorButton:enabled:focus:hover {\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    background-color: var(--ezLightYellow);\r\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\r\n}\r\n\r\nbutton.ezMajorButton:enabled:active,\r\nbutton.ezMajorButton:enabled:active:hover,\r\nbutton.ezMajorButton:enabled:focus:active,\r\nbutton.ezMajorButton:enabled:focus:active:hover,\r\n/* DEPRECATED: button.majorButton */\r\nbutton.majorButton:enabled:active,\r\nbutton.majorButton:enabled:active:hover,\r\nbutton.majorButton:enabled:focus:active,\r\nbutton.majorButton:enabled:focus:active:hover {\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    background-color: var(--ezLightYellow);\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50)\r\n}\r\n\r\nbutton.ezMajorButton:disabled,\r\nbutton.ezMajorButton:disabled:hover,\r\nbutton.ezMajorButton:disabled:active,\r\n/* DEPRECATED: button.majorButton */\r\nbutton.majorButton:disabled,\r\nbutton.majorButton:disabled:hover,\r\nbutton.majorButton:disabled:active {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    font-size: 10pt;\r\n    font-family: var(--ezButtons-font-family);\r\n    border-color: var(--ezDarkYellow);\r\n    cursor: default;\r\n    box-shadow: none;\r\n}\r\n\r\n/* DEPRECATED: button.ezDisabledMajorButton */\r\nbutton.ezDisabledMajorButton,\r\n/* DEPRECATED: button.disabledMajorButton */\r\nbutton.disabledMajorButton {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    font-size: 10pt;\r\n    font-family: var(--ezButtons-font-family);\r\n    border-color: var(--ezDarkYellow);\r\n    cursor: default;\r\n    box-shadow: none;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezNormalButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezNormalButton {\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezClockerGray);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezNormalButton:hover:enabled {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 12pt;\r\n    border-color: var(--ezClockerGray);\r\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\r\n}\r\n\r\nbutton.ezNormalButton:focus {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 12pt;\r\n    border-color: var(--ezClockerGray);\r\n}\r\n\r\nbutton.ezNormalButton:hover,\r\nbutton.ezNormalButton:hover:active {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 12pt;\r\n    border-color: var(--ezClockerGray);\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50)\r\n}\r\n\r\nbutton.ezNormalButton:disabled,\r\nbutton.ezNormalButton:disabled:hover,\r\nbutton.ezNormalButton:disabled:hover:active {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezDarkYellow);\r\n    box-shadow: none;\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezDisabledNormalButton {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    font-size: 12pt;\r\n    border-color: var(--ezDarkYellow);\r\n    border-radius: 3px;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezNormalButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezDefaultNormalButton {\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezDefaultNormalButton:hover:enabled {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\r\n}\r\n\r\nbutton.ezDefaultNormalButton:focus {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n}\r\n\r\nbutton.ezDefaultNormalButton:hover,\r\nbutton.ezDefaultNormalButton:hover:active {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    font-size: 12pt;\r\n    border-color: var(--ezClockerGray);\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);\r\n}\r\n\r\nbutton.ezDefaultNormalButton:disabled,\r\nbutton.ezDefaultNormalButton:disabled:hover,\r\nbutton.ezDefaultNormalButton:disabled:active {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezDarkYellow);\r\n    box-shadow: none;\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezDisabledDefaultNormalButton {\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezDarkYellow);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezTealMajorButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezTealMajorButton {\r\n    background-color: var(--ezClockerTeal);\r\n    color: var(--ezTealContainerTextColor);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezTealBorder);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezTealMajorButton:hover:enabled {\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezTealBorder);\r\n    background-color: var(--ezTealHover);\r\n    box-shadow: var(--ezTealBoxShadow);\r\n}\r\n\r\nbutton.ezTealMajorButton:focus {\r\n    color: var(--ezTealContainerTextColor);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezTealBorder);\r\n    background-color: var(--ezTealHover);\r\n}\r\n\r\nbutton.ezTealMajorButton:hover,\r\nbutton.ezTealMajorButton:hover:active {\r\n    color: var(--ezTealContainerTextColor);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezTealBorder);\r\n    background-color: var(--ezTealHover);\r\n    box-shadow: var(--ezTealInsetBoxShadow);\r\n}\r\n\r\nbutton.ezTealMajorButton:disabled,\r\nbutton.ezTealMajorButton:disabled:hover,\r\nbutton.ezTealMajorButton:disabled:active {\r\n    background-color: var(--ezDarkteal);\r\n    color: var(--ezTealContainerDisabledTextColor);\r\n    font-size: 10pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezTealBorder);\r\n    box-shadow: none;\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezTealMajorButtonDisabled {\r\n    background-color: var(--ezDarkteal);\r\n    color: var(--ezTealContainerDisabledTextColor);\r\n    font-size: 10pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezTealBorder);\r\n    box-shadow: none;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezWarningMajorButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezWarningMajorButton,\r\n/* DEPRECATED: button.warningMajorButton */\r\nbutton.warningMajorButton {\r\n    font-weight: bold;\r\n    background-color: #CE0F0C;\r\n    border-color: #A60400;\r\n    color: var(--ezClockerWhite);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezWarningMajorButton:hover:enabled,\r\n/* DEPRECATED: button.warningMajorButton */\r\nbutton.warningMajorButton:hover:enabled {\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n}\r\n\r\nbutton.ezWarningMajorButton:hover:active,\r\n/* DEPRECATED: button.warningMajorButton */\r\nbutton.warningMajorButton:hover:active {\r\n    color: var(--ezClockerWhite);\r\n    background-color: #BF3330;\r\n}\r\n\r\nbutton.ezWarningMajorButton:disabled,\r\nbutton.ezWarningMajorButton:disabled:hover,\r\nbutton.ezWarningMajorButton:disabled:active\r\n\r\n/* DEPRECATED: button.warningMajorButton */\r\nbutton.warningMajorButton:disabled button.warningMajorButton:disabled:hover,\r\nbutton.warningMajorButton:disabled:active {\r\n    color: var(--ezClockerStone);\r\n    background-color: #FFf0f0;\r\n    border-color: var(--ezClockerStone);\r\n    font-weight: normal;\r\n    box-shadow: none;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezDeleteMajorButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezDeleteMajorButton,\r\nbutton.ezDeleteMajorButton:enabled,\r\n/* DEPRECATED: button.deleteMajorButton */\r\nbutton.deleteMajorButton,\r\nbutton.deleteMajorButton:enabled {\r\n    margin: 0;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezDarkAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezDeleteMajorButton:enabled:focus,\r\n/* DEPRECATED: button.deleteMajorButton */\r\nbutton.deleteMajorButton:enabled:focus {\r\n    margin: 0;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n}\r\n\r\nbutton.ezDeleteMajorButton:enabled:hover,\r\nbutton.ezDeleteMajorButton:enabled:focus:hover,\r\n/* DEPRECATED: button.deleteMajorButton */\r\nbutton.deleteMajorButton:enabled:hover,\r\nbutton.deleteMajorButton:enabled:focus:hover {\r\n    margin: 0;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\r\n}\r\n\r\nbutton.ezDeleteMajorButton:enabled:active,\r\nbutton.ezDeleteMajorButton:enabled:active:hover,\r\nbutton.ezDeleteMajorButton:enabled:focus:active,\r\nbutton.ezDeleteMajorButton:enabled:focus:active:hover,\r\n/* DEPRECATED: button.deleteMajorButton */\r\nbutton.deleteMajorButton:enabled:active,\r\nbutton.deleteMajorButton:enabled:active:hover,\r\nbutton.deleteMajorButton:enabled:focus:active,\r\nbutton.deleteMajorButton:enabled:focus:active:hover {\r\n    margin: 0;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezDarkAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\nbutton.ezDeleteMajorButton:disabled,\r\nbutton.ezDeleteMajorButton:disabled:hover,\r\n/* DEPRECATED: button.deleteMajorButton */\r\nbutton.deleteMajorButton:disabled,\r\nbutton.deleteMajorButton:disabled:hover {\r\n    margin: 0;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezHoverAlertRed);\r\n    color: var(--ezBorderAlertRed);\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n    box-shadow: none;\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezWarningHeaderButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezWarningHeaderButton,\r\nbutton.warningHeaderButton {\r\n    vertical-align: middle;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    background-color: #CE0F0C;\r\n    border-color: #BF3330;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezWarningHeaderButton:hover:enabled,\r\nbutton.warningHeaderButton:hover:enabled {\r\n    background-color: var(--ezClockerAlertRed);\r\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\r\n}\r\n\r\nbutton.ezWarningHeaderButton:focus,\r\nbutton.warningHeaderButton:focus {\r\n    background-color: var(--ezClockerAlertRed);\r\n}\r\n\r\nbutton.ezWarningHeaderButton:hover:active,\r\nbutton.warningHeaderButton:hover:active {\r\n    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\nbutton.ezWarningHeaderButton:disabled,\r\nbutton.warningHeaderButton:disabled {\r\n    color: #BF3330;\r\n    background-color: var(--ezClockerAlertRed);\r\n    border-color: #BF3330;\r\n    font-weight: normal;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezLargeToolButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezLargeToolButton {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n    max-height: 32px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezLargeToolButton:hover,\r\nbutton.ezLargeToolButton:hover:enabled {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n    max-height: 32px;\r\n    background-color: var(--ezHoverNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\nbutton.ezLargeToolButton:active,\r\nbutton.ezLargeToolButton:hover:active {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n    max-height: 32px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    box-shadow: inset 0 0 4px 2px rgba(6, 56, 97, 0.5);\r\n}\r\n\r\nbutton.ezLargeToolButton:disabled {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n    max-height: 32px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerSilver);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezLightNavy);\r\n    cursor: default;\r\n}\r\n\r\nbutton.disabledEzLargeToolButton {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n    max-height: 32px;\r\n    background-color: #063565;\r\n    color: #0d58a6;\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: #0d58a6;\r\n    cursor: default;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezRedLargeToolButton {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n    max-height: 32px;\r\n    background-color: #ff7673;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: #a60400;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezRedLargeToolButton:hover:enabled {\r\n    background-color: var(--ezClockerAlertRed);\r\n}\r\n\r\nbutton.ezRedLargeToolButton:hover:active {\r\n    background-color: #BF3330;\r\n}\r\n\r\nbutton.ezRedLargeToolButton:disabled {\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: #808080;\r\n    border-color: var(--ezClockerStone);\r\n    cursor: default;\r\n}\r\n\r\n\r\n/*\r\n====================================================================================================================\r\n| [Class Group]\r\n| EzClocker Tool Buttons\r\n====================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy,\r\n.ezButtons-tool-navy:enabled,\r\n/* DEPRECATED .ezToolButton */\r\n.ezToolButton,\r\n.ezToolButton:enabled {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezClockerNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: none;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy:enabled:focus,\r\n/* DEPRECATED .ezToolButton */\r\n.ezToolButton:enabled:focus {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezClockerNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy:enabled:hover,\r\n.ezButtons-tool-navy:enabled:focus:hover,\r\n/* DEPRECATED .ezToolButton */\r\n.ezToolButton:enabled:hover,\r\n.ezToolButton:enabled:focus:hover {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezHoverNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy:enabled:active,\r\n.ezButtons-tool-navy:enabled:active:hover,\r\n.ezButtons-tool-navy:enabled:focus:active,\r\n.ezButtons-tool-navy:enabled:focus:active:hover,\r\n/* DEPRECATED .ezToolButton */\r\n.ezToolButton:enabled:active,\r\n.ezToolButton:enabled:active:hover,\r\n.ezToolButton:enabled:focus:active,\r\n.ezToolButton:enabled:focus:active:hover {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezClockerNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy:disabled,\r\n.ezButtons-tool-navy:disabled:hover,\r\n/* DEPRECATED .ezToolButton */\r\n.ezToolButton:disabled,\r\n.ezToolButton:disabled:hover {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezHoverNavy);\r\n    opacity: 0.5;\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: none;\r\n    box-shadow: unset;\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy-large\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy-large,\r\n.ezButtons-tool-navy-large:enabled {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 38px;\r\n    min-height: 38px;\r\n    max-height: 38px;\r\n    background-color: var(--ezClockerNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 12pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: none;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy-large:enabled:focus {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 38px;\r\n    min-height: 38px;\r\n    max-height: 38px;\r\n    background-color: var(--ezClockerNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 12pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: auto;\r\n    outline-width: 1px;\r\n    outline-color: var(--ezNavy-alpha-50);\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy-large:enabled:hover,\r\n.ezButtons-tool-navy-large:enabled:focus:hover {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 38px;\r\n    min-height: 38px;\r\n    max-height: 38px;\r\n    background-color: var(--ezHoverNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 12pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: auto;\r\n    outline-width: 1px;\r\n    outline-color: var(--ezNavy-alpha-50);\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy-large:enabled:active,\r\n.ezButtons-tool-navy-large:enabled:active:hover,\r\n.ezButtons-tool-navy-large:enabled:focus:active,\r\n.ezButtons-tool-navy-large:enabled:focus:active:hover {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 38px;\r\n    min-height: 38px;\r\n    max-height: 38px;\r\n    background-color: var(--ezClockerNavy);\r\n    opacity: 1;\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-size: 12pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: auto;\r\n    outline-width: 1px;\r\n    outline-color: var(--ezNavy-alpha-50);\r\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezButtons-tool-navy\r\n        (DEPRECATED) .ezToolButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezButtons-tool-navy-large:disabled,\r\n.ezButtons-tool-navy-large:disabled:hover {\r\n    padding: 2px;\r\n    margin: 1px;\r\n    min-width: 38px;\r\n    min-height: 38px;\r\n    max-height: 38px;\r\n    background-color: var(--ezHoverNavy);\r\n    opacity: 0.5;\r\n    color: var(--ezBorderNavy);\r\n    font-size: 12pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-style: none;\r\n    box-shadow: unset;\r\n    cursor: default;\r\n}\r\n\r\n\r\nbutton.ezRedToolButton,\r\nbutton.ezRedToolButton:enabled {\r\n    opacity: 1;\r\n    padding: 0;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n}\r\n\r\nbutton.ezRedToolButton:enabled:focus {\r\n    opacity: 1;\r\n    padding: 0;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    outline-width: 0;\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\nbutton.ezRedToolButton:enabled:hover,\r\nbutton.ezRedToolButton:enabled:focus:hover {\r\n    opacity: 1;\r\n    padding: 0;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezLightAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    outline-width: 0;\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\nbutton.ezRedToolButton:enabled:active,\r\nbutton.ezRedToolButton:enabled:active:hover,\r\nbutton.ezRedToolButton:enabled:focus:active,\r\nbutton.ezRedToolButton:enabled:focus:active:hover {\r\n    opacity: 1;\r\n    padding: 0;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezDarkAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    box-shadow:\r\n        0 0 1px 1px transparent,\r\n        inset 0 0 4px 2px var(--ezBorderAlertRed-alpha-50);\r\n    outline-width: 0;\r\n}\r\n\r\nbutton.ezRedToolButton:disabled,\r\nbutton.ezRedToolButton:disabled:hover {\r\n    opacity: 0.50;\r\n    padding: 0;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: var(--ezHoverAlertRed);\r\n    color: var(--ezClockerGray);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezClockerGray);\r\n    cursor: default;\r\n}\r\n\r\n\r\nbutton.ezTransparentToolButton {\r\n    opacity: 1;\r\n    padding: 0;\r\n    margin: 1px;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: transparent;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\nbutton.ezTransparentToolButton:hover:enabled {\r\n    background-color: transparent;\r\n    color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerWhite);\r\n}\r\n\r\nbutton.ezTransparentToolButton:focus button.ezTransparentToolButton:active {\r\n    background-color: transparent;\r\n    color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerWhite);\r\n    box-shadow: none;\r\n}\r\n\r\nbutton.ezTransparentToolButton:hover:active {\r\n    background-color: transparent;\r\n    color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerWhite);\r\n    box-shadow: inset 0 0 4px 2px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\nbutton.ezTransparentToolButton:hover:disabled,\r\nbutton.ezTransparentToolButton:active:disabled,\r\nbutton.ezTransparentToolButton:disabled {\r\n    opacity: 0.50;\r\n    padding: 0;\r\n    min-width: 28px;\r\n    min-height: 28px;\r\n    max-height: 28px;\r\n    background-color: transparent;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: transparent;\r\n    cursor: default;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezButton-hidden-egg\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n.ezButton-hidden-egg {\r\n    padding: 4px;\r\n    margin: 0;\r\n    background-color: transparent;\r\n    min-width: 18px;\r\n    min-height: 18px;\r\n    color: transparent;\r\n    font-size: xx-small;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-style: none;\r\n    cursor: url('/secure/account/hack.cur'), auto;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezEditButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezEditButton,\r\nbutton.ezEditButton:enabled,\r\n/* DEPRECATED: editButton */\r\nbutton.editButton,\r\nbutton.editButton:enabled {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezClockerYellow);\r\n    min-width: 75px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezClockerBlack);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezEditButton:enabled:focus,\r\n/* DEPRECATED: editButton */\r\nbutton.editButton:enabled:focus {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezLightYellow);\r\n    min-width: 75px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezClockerBlack);\r\n    border-radius: 3px;\r\n    outline-width: 0;\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\nbutton.ezEditButton:enabled:hover,\r\nbutton.ezEditButton:enabled:focus:hover,\r\n/* DEPRECATED: editButton */\r\nbutton.editButton:enabled:hover,\r\nbutton.editButton:enabled:focus:hover {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    min-width: 75px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    text-align: center;\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\r\n}\r\n\r\nbutton.ezEditButton:enabled:active,\r\nbutton.ezEditButton:enabled:active:hover,\r\nbutton.ezEditButton:enabled:focus:active,\r\nbutton.ezEditButton:enabled:focus:active:hover,\r\n/* DEPRECATED: editButton */\r\nbutton.editButton:enabled:active,\r\nbutton.editButton:enabled:active:hover,\r\nbutton.editButton:enabled:focus:active,\r\nbutton.editButton:enabled:focus:active:hover {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    min-width: 75px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    text-align: center;\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);\r\n}\r\n\r\nbutton.ezEditButton:disabled,\r\nbutton.ezEditButton:disabled:hover,\r\nbutton.ezEditButton:disabled:active,\r\n/* DEPRECATED: editButton */\r\nbutton.editButton:disabled,\r\nbutton.editButton:disabled:hover,\r\nbutton.editButton:disabled:active {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    min-width: 75px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezBorderYellow);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderYellow);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezDisabledEditButton,\r\nbutton.disabledEditButton {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    min-width: 75px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezBorderYellow);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderYellow);\r\n    cursor: default;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezEditButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezSquareEditButton {\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 4px;\r\n    padding-left: 3px;\r\n    margin: 1px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderYellow);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezSquareEditButton:hover:enabled {\r\n    padding: 4px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\r\n}\r\n\r\nbutton.ezSquareEditButton:focus {\r\n    padding: 4px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\nbutton.ezSquareEditButton:hover:active {\r\n    padding: 4px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderYellow);\r\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\r\n}\r\n\r\nbutton.ezSquareEditButton:disabled {\r\n    padding: 4px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezBorderYellow);\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderYellow);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezDisabledSquareEditButton {\r\n    padding: 4px;\r\n    background-color: var(--ezLightYellow);\r\n    color: var(--ezBorderYellow);\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderYellow);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\nimg.ezSquarEditButtonImg {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezButtons-edit-navy-24x24\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezButtons-edit-navy-24x24 {\r\n    padding: 4px;\r\n    width: 24px;\r\n    height: 24px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x24:hover:enabled {\r\n    padding: 4px;\r\n    width: 24px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x24:focus {\r\n    padding: 4px;\r\n    width: 24px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x24:hover:active {\r\n    padding: 4px;\r\n    width: 24px;\r\n    height: 24px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x24:disabled {\r\n    padding: 4px;\r\n    width: 24px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x24-disabled {\r\n    padding: 4px;\r\n    width: 24px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\nimg.ezButtons-square-img-24x24 {\r\n    padding: 0;\r\n    margin: 0;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezButtons-edit-navy-24x48\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezButtons-edit-navy-24x48 {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 24px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x48:hover:enabled {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x48:focus {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerBlack);\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    font-size: 10pt;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x48:hover:active {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 24px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x48:disabled {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-24x48-disabled {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 24px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\nimg.ezButtons-square-img-24xA {\r\n    padding: 0;\r\n    margin: 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    height: 24px;\r\n    width: auto;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezButtons-edit-navy-48x48\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezButtons-edit-navy-48x48 {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 48px;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-48x48:hover:enabled {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 48px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\r\n}\r\n\r\nbutton.ezButtons-edit-navy-48x48:focus {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 48px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-48x48:hover:active {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 48px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\r\n}\r\n\r\nbutton.ezButtons-edit-navy-48x48:disabled {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 48px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezButtons-edit-navy-48x48-disabled {\r\n    padding: 4px;\r\n    width: 48px;\r\n    height: 48px;\r\n    background-color: var(--ezLightNavy);\r\n    color: var(--ezBorderNavy);\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    vertical-align: center;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\nimg.ezButtons-square-img-48xA {\r\n    padding: 0;\r\n    margin: 0;\r\n    height: 48px;\r\n    width: auto;\r\n    text-align: center;\r\n    vertical-align: center;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezDeleteEditButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n.ezButtons-delete-button {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: #ff7673;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: #a60400;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezButtons-delete-button:hover:enabled {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\n.ezButtons-delete-button:hover:active {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    background-color: #BF3330;\r\n}\r\n\r\n.ezButtons-delete-button:disabled {\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: #808080;\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezClockerStone);\r\n    cursor: default;\r\n}\r\n\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezDeleteEditButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezDeleteEditButton,\r\nbutton.ezDeleteEditButton:enabled {\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezDeleteEditButton:enabled:focus {\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezLightAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n    outline-width: 0;\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\nbutton.ezDeleteEditButton:enabled:hover,\r\nbutton.ezDeleteEditButton:enabled:focus:hover {\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezLightAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezDeleteEditButton:enabled:active,\r\nbutton.ezDeleteEditButton:enabled:active:hover,\r\nbutton.ezDeleteEditButton:enabled:focus:active,\r\nbutton.ezDeleteEditButton:enabled:focus:active:hover {\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezDarkAlertRed);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezDeleteEditButton:disabled,\r\nbutton.ezDeleteEditButton:disabled:hover,\r\nbutton.ezDeleteEditButton:disabled:active {\r\n    opacity: 50%;\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 4px;\r\n    margin: 1px;\r\n    background-color: var(--ezLightAlertRed);\r\n    color: var(--ezBorderAlertRed);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezMiniActionButton styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezMiniActionButton,\r\nbutton.miniActionButton {\r\n    opacity: 1;\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: var(--ezSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezMiniActionButton:enabled:hover,\r\nbutton.miniActionButton:enabled:hover {\r\n    opacity: 1;\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: var(--ezLightSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.3);\r\n}\r\n\r\nbutton.ezMiniActionButton:enabled:focus,\r\nbutton.miniActionButton:enabled:focus {\r\n    opacity: 1;\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: var(--ezLightSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    outline-color: var(--ezClockerSilver-alpha-50);\r\n}\r\n\r\nbutton.miniActionButton:enabled:active,\r\nbutton.ezMiniActionButton:enabled:active:hover,\r\nbutton.miniActionButton:enabled:active:hover {\r\n    opacity: 1;\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: var(--ezSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.5)\r\n}\r\n\r\nbutton.ezMiniActionButton:disabled,\r\nbutton.ezMiniActionButton:disabled:active,\r\nbutton.ezMiniActionButton:disabled:active:hover,\r\nbutton.ezMiniActionButton:disabled:hover,\r\nbutton.miniActionButton:disabled,\r\nbutton.miniActionButton:disabled:hover,\r\nbutton.miniActionButton:disabled:active,\r\nbutton.miniActionButton:disabled:active:hover {\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: rgba(224, 224, 224, 0.5);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: default;\r\n\r\n    /*\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerGray);\r\n    color: var(--ezClockerStone);\r\n    font-size: 10pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: default;\r\n    */\r\n}\r\n\r\nbutton.ezDisabledMiniActionButton,\r\nbutton.disabledMiniActionButton {\r\n    opacity: 0.8;\r\n    padding: 2px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerGray);\r\n    color: var(--ezClockerStone);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezSilverActionButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezSilverActionButton {\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezSilverActionButton:hover,\r\nbutton.ezSilverActionButton:hover:enabled {\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    font-size: 10pt;\r\n    box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);\r\n    cursor: pointer;\r\n}\r\n\r\nbutton.ezSilverActionButton:focus {\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    font-size: 10pt;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton.ezSilverActionButton:active,\r\nbutton.ezSilverActionButton:hover:active {\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    font-size: 10pt;\r\n    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);\r\n    cursor: pointer;\r\n}\r\n\r\nbutton.ezSilverActionButton:disabled {\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezBorderSilver);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezDisabledSilverActionButton {\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezBorderSilver);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: default;\r\n}\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezSilverEditButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezSilverEditButton,\r\nbutton.silverEditButton {\r\n    padding: 2px 4px;\r\n    margin: 0;\r\n    margin-right: 2px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezSilverEditButton:focus,\r\nbutton.ezSilverEditButton:hover:enabled,\r\nbutton.silverEditButton:hover:enabled {\r\n    padding: 2px 4px;\r\n    margin: 0;\r\n    margin-right: 2px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);\r\n}\r\n\r\nbutton.ezSilverEditButton:active,\r\nbutton.ezSilverEditButton:active:focus,\r\nbutton.ezSilverEditButton:hover,\r\nbutton.ezSilverEditButton:hover:active,\r\nbutton.ezSilverEditButto:hover:active {\r\n    padding: 2px 4px;\r\n    margin: 0;\r\n    margin-right: 2px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);\r\n}\r\n\r\nbutton.ezSilverEditButton:disabled,\r\nbutton.silverEditButton:disabled {\r\n    padding: 2px 4px;\r\n    margin: 0;\r\n    margin-right: 2px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezBorderSilver);\r\n    font-size: 10pt;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderSilver);\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezMiniDeleteActionButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezMiniDeleteActionButton,\r\nbutton.miniDeleteActionButton {\r\n    font-size: 8pt;\r\n    font-weight: bold;\r\n    padding: 2px;\r\n    margin: 0;\r\n    color: var(--ezClockerWhite);\r\n    background-color: #CE0F0C;\r\n    border-color: #A60400;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezMiniDeleteActionButton:hover:enabled,\r\nbutton.miniDeleteActionButton:hover:enabled {\r\n    background-color: var(--ezClockerAlertRed);\r\n    color: var(--ezClockerWhite);\r\n}\r\n\r\nbutton.ezMiniDeleteActionButton:hover:active,\r\nbutton.miniDeleteActionButton:hover:active {\r\n    background-color: #BF3330;\r\n}\r\n\r\nbutton.ezMiniDeleteActionButton:disabled,\r\nbutton.miniDeleteActionButtonn:disabled {\r\n    color: var(--ezClockerStone);\r\n    background-color: #FFf0f0;\r\n    border-color: var(--ezClockerStone);\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezButtons-quick-help\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n.ui-widget button.ezButtons-quick-help,\r\n.ezButtons-quick-help {\r\n    margin: 4px;\r\n    padding-left: 25px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    opacity: 1;\r\n    background-color: transparent;\r\n    background-image: url('/public/images/icons/info.svg');\r\n    background-position: 4px center;\r\n    background-repeat: no-repeat;\r\n    background-size: 18px;\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-style: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.ui-widget button.ezButtons-quick-help:hover,\r\n.ui-widget button.ezButtons-quick-help:focus,\r\n.ui-widget button.ezButtons-quick-help:focus:hover,\r\n.ui-widget button.ezButtons-quick-help:enabled:hover,\r\n.ezButtons-quick-help:hover,\r\n.ezButtons-quick-help:focus,\r\n.ezButtons-quick-help:focus:hover,\r\n.ezButtons-quick-help:enabled:hover {\r\n    margin: 4px;\r\n    padding-left: 25px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    opacity: 1;\r\n    background-color: transparent;\r\n    background-image: url('/public/images/icons/info.svg');\r\n    background-position: 4px center;\r\n    background-repeat: no-repeat;\r\n    background-size: 18px;\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: dashed;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n.ui-widget button.ezButtons-quick-help:active,\r\n.ui-widget button.ezButtons-quick-help:active:hover,\r\n.ezButtons-quick-help:active,\r\n.ezButtons-quick-help:active:hover {\r\n    margin: 4px;\r\n    padding-left: 25px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    opacity: 1;\r\n    background-color: transparent;\r\n    background-image: url('/public/images/icons/info.svg');\r\n    background-position: 4px center;\r\n    background-repeat: no-repeat;\r\n    background-size: 18px;\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-color: var(--ezClockerGray);\r\n    border-style: dashed;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    box-shadow: unset;\r\n    cursor: pointer;\r\n}\r\n\r\n.ui-widget.button.ezButtons-quick-help:disabled,\r\n.ezButtons-quick-help:disabled {\r\n    margin: 4px;\r\n    padding-left: 25px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    opacity: 1;\r\n    background-color: transparent;\r\n    background-image: url('/public/images/icons/info.svg');\r\n    background-position: 4px center;\r\n    background-repeat: no-repeat;\r\n    background-size: 18px;\r\n    color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    font-size: 10pt;\r\n    border-style: none;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Default Action Buttons\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezActionGreen\r\n        (DEPRECATED) button.ezActionButton\r\n        (DEPRECATED) button.actionButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezActionGreen,\r\nbutton.ezButtons-action-ezActionGreen:enabled,\r\n/* DEPRECATED: button.ezActionButton */\r\nbutton.ezActionButton,\r\nbutton.ezActionButton:enabled,\r\n/* DEPRECATED: button.actionButton */\r\nbutton.actionButton,\r\nbutton.actionButton:enabled {\r\n    padding: 6px 24px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerActionGreen);\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezActionGreenBorderColor);\r\n    border-radius: 3px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class State Definition: Enabled Focus]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezActionGreen\r\n        (DEPRECATED) button.ezActionButton\r\n        (DEPRECATED) button.actionButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezActionGreen:enabled:focus,\r\n/* DEPRECATED: button.ezActionButton */\r\nbutton.ezActionButton:enabled:focus,\r\n/* DEPRECATED: button.actionButton */\r\nbutton.actionButton:enabled:focus {\r\n    outline-color: var(--ezActionGreen-alpha-50);\r\n    outline-style: auto;\r\n    outline-width: 1px;\r\n    outline-offset: 2px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class State Definition: Enabled Hover and Active Hover]:\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezActionGreen\r\n        (DEPRECATED) button.ezActionButton\r\n        (DEPRECATED) button.actionButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezActionGreen:enabled:hover,\r\nbutton.ezButtons-action-ezActionGreen:enabled:focus:hover,\r\n/* DEPRECATED: button.ezActionButton */\r\nbutton.ezActionButton:enabled:hover,\r\nbutton.ezActionButton:enabled:focus:hover,\r\n/* DEPRECATED: button.actionButton */\r\nbutton.actionButton:enabled:hover,\r\nbutton.actionButton:enabled:focus:hover {\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    background-color: var(--ezActionGreenHoverColor);\r\n    box-shadow: var(--ezBoxShadow-ezGray-30);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezActionGreen\r\n        (DEPRECATED) button.ezActionButton\r\n        (DEPRECATED) button.actionButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezActionGreen:enabled:active,\r\nbutton.ezButtons-action-ezActionGreen:enabled:active:hover,\r\nbutton.ezButtons-action-ezActionGreen:enabled:focus:active,\r\nbutton.ezButtons-action-ezActionGreen:enabled:focus:active:hover,\r\n/* DEPRECATED: button.ezActionButton */\r\nbutton.ezActionButton:enabled:active,\r\nbutton.ezActionButton:enabled:active:hover,\r\nbutton.ezActionButton:enabled:focus:active,\r\nbutton.ezActionButton:enabled:focus:active:hover,\r\n/* DEPRECATED: button.actionButton */\r\nbutton.actionButton:enabled:active,\r\nbutton.actionButton:enabled:active:hover,\r\nbutton.actionButton:enabled:focus:active,\r\nbutton.actionButton:enabled:focus:active:hover {\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    background-color: var(--ezActionGreenHoverColor);\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-80);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezActionGreen\r\n        (DEPRECATED) button.ezActionButton\r\n        (DEPRECATED) button.actionButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezActionGreen:disabled,\r\nbutton.ezButtons-action-ezActionGreen:disabled:hover,\r\n/* DEPRECATED: button.ezActionButton */\r\nbutton.ezActionButton:disabled,\r\nbutton.ezActionButton:disabled:hover,\r\n/* DEPRECATED: button.actionButton */\r\nbutton.actionButton:disabled,\r\nbutton.actionButton:disabled:hover {\r\n    background-color: var(--ezActionGreenHoverColor);\r\n    color: var(--ezActionGreenBorderColor);\r\n    font-size: 14pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezActionGreenBorderColor);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        (DEPRECATED) button.ezDisabledActionButton\r\n        (DEPRECATED) button.disabledActionButton\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n/* DEPRECATED: button.ezDisabledActionButton */\r\nbutton.ezDisabledActionButton,\r\nbutton.ezDisabledActionButton:disabled,\r\nbutton.ezDisabledActionButton:disabled:hover,\r\n/* DEPRECATED: button.disabledActionButton */\r\nbutton.disabledActionButton,\r\nbutton.disabledActionButton:disabled,\r\nbutton.disabledActionButton:disabled:hover {\r\n    background-color: var(--ezActionGreenHoverColor);\r\n    color: var(--ezActionGreenBorderColor);\r\n    font-weight: normal;\r\n    border-color: var(--ezActionGreenBorderColor);\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezClockerYellow\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezClockerYellow,\r\nbutton.ezButtons-action-ezClockerYellow:enabled {\r\n    padding: 6px 24px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerYellow);\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderYellow);\r\n    border-radius: 3px;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class State Definition: Enabled Focus]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezClockerYellow\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezClockerYellow:enabled:focus {\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    background-color: var(--ezHoverYellow);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class State Definition: Enabled Hover and Active Hover]:\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezClockerYellow\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezClockerYellow:enabled:hover,\r\nbutton.ezButtons-action-ezClockerYellow:enabled:focus:hover {\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    background-color: var(--ezHoverYellow);\r\n    box-shadow: var(--ezBoxShadow-ezGray-30);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezClockerYellow\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezClockerYellow:enabled:active,\r\nbutton.ezButtons-action-ezClockerYellow:enabled:active:hover,\r\nbutton.ezButtons-action-ezClockerYellow:enabled:focus:active,\r\nbutton.ezButtons-action-ezClockerYellow:enabled:focus:active:hover {\r\n    font-size: 14pt;\r\n    font-weight: bold;\r\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        button.ezButtons-action-ezClockerYellow\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nbutton.ezButtons-action-ezClockerYellow:disabled,\r\nbutton.ezButtons-action-ezClockerYellow:disabled:hover {\r\n    background-color: var(--ezHoverYellow);\r\n    color: var(--ezBorderYellow);\r\n    font-size: 14pt;\r\n    font-weight: normal;\r\n    border-color: var(--ezBorderYellow);\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezActionButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezNavyActionButton {\r\n    padding: 6px 24px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezNavyActionButton:hover:enabled {\r\n    font-weight: bold;\r\n    background-color: var(--ezHoverNavy);\r\n}\r\n\r\nbutton.ezNavyActionButton:focus {\r\n    font-weight: bold;\r\n    background-color: var(--ezHoverNavy);\r\n}\r\n\r\nbutton.ezNavyActionButton:hover:active {\r\n    font-weight: bold;\r\n    box-shadow: var(--ezNavyInsetShadow);\r\n}\r\n\r\nbutton.ezNavyActionButton:disabled {\r\n    background-color: var(--ezLightNavy);\r\n    border-color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    color: var(--ezNavyContainerDisabledTextColor);\r\n    cursor: default;\r\n}\r\n\r\nbutton.ezDisabledNavyActionButton {\r\n    background-color: var(--ezLightNavy);\r\n    border-color: var(--ezBorderNavy);\r\n    font-weight: normal;\r\n    color: var(--ezNavyContainerDisabledTextColor);\r\n    cursor: default;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezSuperActionButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezSuperActionButton,\r\nbutton.superActionButton {\r\n    margin: 0;\r\n    background-color: var(--ezClockerNavy);\r\n    border-color: var(--ezClockerGray);\r\n    color: var(--ezClockerWhite);\r\n    font-weight: bold;\r\n    font-size: 18pt;\r\n    padding: 6px 24px;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezSuperActionButton:hover:enabled,\r\nbutton.superActionButton:hover:enabled {\r\n    background-color: #0d58a6;\r\n}\r\n\r\nbutton.ezSuperActionButton:hover:active,\r\nbutton.superActionButton:hover:active {\r\n    background-color: #0d58a6;\r\n}\r\n\r\nbutton.ezSuperActionButton:disabled,\r\nbutton.superActionButton:disabled {\r\n    cursor: default;\r\n    background-color: #5387bd;\r\n    border-color: var(--ezClockerNavy);\r\n    font-weight: normal;\r\n    color: var(--ezClockerNavy);\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezWizardNavButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezWizardNavButton {\r\n    /* font-family: var(--ezFontFamily); */\r\n    font-family: var(--ezButtons-font-family);\r\n    font-weight: bold;\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezWizardHiddenNavButton {\r\n    /* font-family: var(--ezFontFamily); */\r\n    font-family: var(--ezButtons-font-family);\r\n    display: none;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezWizardActionButton Styles\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\nbutton.ezWizardActionButton {\r\n    /* background-color: var(--ezClockerHotGreen); */\r\n    background-color: var(--ezDarkHotGreen);\r\n\r\n    /* font-family: var(--ezFontFamily); */\r\n    font-family: var(--ezButtons-font-family);\r\n    font-weight: bold;\r\n\r\n    /* color: var(--ezHotGreenContainerFontColor) */\r\n    color: var(--ezClockerBlack);\r\n\r\n    /* border-color: var(--ezBorderHotGreen); */\r\n    border-color: var(--ezBorderHotGreen);\r\n    border-radius: 3px;\r\n}\r\n\r\nbutton.ezWizardHiddenActionButton {\r\n    /* font-family: var(--ezFontFamily); */\r\n    font-family: var(--ezButtons-font-family);\r\n    display: none;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| DIV Button\r\n| HTML Tags: <div/>\r\n|-------------------------------------------------\r\n| Template: ezDivButton_{name}-{size}-{color}\r\n|\r\n| Official Classes:\r\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"\")\r\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"UNSELECTED\")\r\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"SELECTED\")\r\n|\r\n| Deprecated Classes:\r\n|   ez-navy-left-nav-button (data-state=\"\")\r\n|   ez-navy-left-nav-button (data-state=\"UNSELECTED\")\r\n|   ez-navy-left-nav-button (data-state=\"SELECTED\")\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n/* -------------------------------------------------\r\n| [DIV Button]\r\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"\")\r\n|   (DEPRECATED) ez-navy-left-nav-button (data-state=\"\")\r\n------------------------------------------------- */\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"\"],\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"] {\r\n    padding-left: 8px;\r\n    padding-top: 14px;\r\n    padding-right: 24px;\r\n    padding-bottom: 15px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-right-style: none;\r\n    border-color: var(--ezClockerNavy);\r\n    outline-color: var(--ezClockerBlack);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:hover {\r\n    background-color: var(--ezClockerLightNavy);\r\n    color: var(--ezClockerWhite);\r\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:focus,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:focus {\r\n    background-color: var(--ezClockerLightNavy);\r\n    color: var(--ezClockerWhite);\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:active,\r\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:active:focus,\r\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:active:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:active,\r\n.ezDivButton_LeftNavv-normal-ezClockerNavy[data-state=\"\"]:enabled:active:focus,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:active:hover {\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"\"]:disabled,\r\n.ez-navy-left-nav-button[data-state=\"\"]:disabled:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:disabled,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:disabled:hover {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerGray);\r\n    cursor: default;\r\n}\r\n\r\n/* -------------------------------------------------\r\n| [DIV Button]\r\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"UNSELECTED\")\r\n|   (DEPRECATED) ez-navy-left-nav-button (data-state=\"UNSELECTED\")\r\n------------------------------------------------- */\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"],\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"] {\r\n    padding-left: 8px;\r\n    padding-top: 14px;\r\n    padding-right: 24px;\r\n    padding-bottom: 15px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-right-style: none;\r\n    border-color: var(--ezClockerNavy);\r\n    outline-color: var(--ezClockerBlack);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:hover {\r\n    background-color: var(--ezClockerLightNavy);\r\n    color: var(--ezClockerWhite);\r\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:focus,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:focus {\r\n    background-color: var(--ezClockerLightNavy);\r\n    color: var(--ezClockerWhite);\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:active,\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:active:focus,\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:active:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:active,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:active:focus,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:active:hover {\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:disabled,\r\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:disabled:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:disabled,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:disabled:hover {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerGray);\r\n    font-weight: bold;\r\n    cursor: default;\r\n}\r\n\r\n/* -------------------------------------------------\r\n| [DIV Button]\r\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"SELECTED\")\r\n|   (DEPRECATED) ez-navy-left-nav-button (data-state=\"SELECTED\")\r\n------------------------------------------------- */\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"],\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"] {\r\n    padding-left: 8px;\r\n    padding-top: 14px;\r\n    padding-right: 24px;\r\n    padding-bottom: 15px;\r\n    margin: 0;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-right-style: none;\r\n    border-color: var(--ezClockerNavy);\r\n    outline-color: var(--ezClockerBlack);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:hover,\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:focus,\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:active,\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:active:focus,\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:active:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:focus,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:active,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:active:focus,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:active:hover {\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-right-style: none;\r\n    border-color: var(--ezClockerNavy);\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 0;\r\n    outline-color: var(--ezClockerBlack);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n    text-align: left;\r\n    cursor: pointer;\r\n}\r\n\r\n/* DEPRECATED: .ez-navy-left-nav-button */\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:disabled,\r\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:disabled:hover,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:disabled,\r\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:disabled:hover {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerGray);\r\n    font-weight: bold;\r\n    cursor: default;\r\n}\r\n\r\n/* -------------------------------------------------\r\n| [DIV Button]\r\n|   ezDivButton_Menu-normal-ezClockerOrange\r\n|   (DEPRECATED) div.ezMenuButton\r\n------------------------------------------------- */\r\n/* DEPRECATED: div.ezMenuButton */\r\ndiv.ezMenuButton,\r\n.ezDivButton_Menu-normal-ezClockerOrange {\r\n    background-color: var(--ezClockerOrange);\r\n    font-family: var(--ezButtons-font-family);\r\n    color: var(--ezClockerWhite);\r\n    border-style: solid;\r\n    border-color: var(--ezBorderOrange);\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* DEPRECATED: div.ezMenuButton */\r\ndiv.ezMenuButton:hover:enabled,\r\n.ezDivButton_Menu-normal-ezClockerOrange:hover:enabled {\r\n    background-color: var(--ezHoverOrange);\r\n}\r\n\r\n/* DEPRECATED: div.ezMenuButton */\r\ndiv.ezMenuButton:hover:active,\r\n.ezDivButton_Menu-normal-ezClockerOrange:hover:active {\r\n    border-width: 1px;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Button Content\r\n| HTML Tags: <div/>,<label/>,<span/>\r\n|-------------------------------------------------\r\n| Template: ezButtonContent_{name}-{size}-{color}\r\n|\r\n| Official Classes:\r\n|   ezButtonContent_SubLabel-normal-black\r\n|\r\n| Deprecated Classes:\r\n|   ezButtonSubLabel\r\n|   buttonSubLabel\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n/* DEPRECATED: label.ezButtonSubLabel */\r\nlabel.ezButtonSubLabel,\r\n/* DEPRECATED: label.buttonSubLabel */\r\nlabel.buttonSubLabel {\r\n    font-weight: normal;\r\n}\r\n\r\n.ezButtonContent_SubLabel-normal-black {\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n}\r\n\r\nlabel.ezEditButtonLabel,\r\n.ezButtonContent_EditLabel-small-black {\r\n    padding-left: 4px;\r\n    padding-right: 2px;\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 10pt;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Button Images\r\n| HTML Tags: <img/>\r\n|-------------------------------------------------\r\n| Template: ezButtonImage_{size}\r\n|\r\n| Official Classes:\r\n|   ezButtonImage_16x16\r\n|   ezButtonImage_24x24\r\n|   ezBtnImage_24xA\r\n|\r\n| Deprecated Classes:\r\n|   ezEditButtonImage\r\n|   ezLargeEditButtonImage\r\n|   ezMiniButtonImg\r\n|   miniButtonIcon\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n/* DEPRECATED: img.ezEditButtonImage */\r\nimg.ezEditButtonImage,\r\nimg.ezButtonImage_16x16 {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 16px;\r\n    width: 16px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezButtonImage-disable_16x16 {\r\n    opacity: .5;\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 16px;\r\n    width: 16px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezEditButtonImage_18x18 {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 18px;\r\n    width: 18px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezEditButtonImage-disable_18x18 {\r\n    opacity: .5;\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 18px;\r\n    width: 18px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezEditButtonImage_20x20 {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 20px;\r\n    width: 20px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezEditButtonImage-disable_20x20 {\r\n    opacity: .5;\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 20px;\r\n    width: 20px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\n/* DEPRECATED: img.ezLargeEditButtonImage */\r\nimg.ezLargeEditButtonImage,\r\nimg.ezButtonImage_24x24 {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 24px;\r\n    width: 24px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezButtonImage-disable_24x24 {\r\n    opacity: .5;\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 24px;\r\n    width: 24px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n}\r\n\r\nimg.ezMiniButtonImg,\r\nimg.miniButtonIcon,\r\nimg.ezBtnImage_24xA {\r\n    box-sizing: border-box;\r\n    padding-right: 4px;\r\n    width: 24px;\r\n    vertical-align: middle;\r\n    border-style: none;\r\n}\r\n\r\n\r\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Select Button\r\n| HTML Tags: <select/>\r\n|-------------------------------------------------\r\n| Template: ezSelectButton_{name}-{size}-{color}\r\n|\r\n| Official Classes:\r\n|   ezSelectButton_Default-normal-ezClockerOrange\r\n|\r\n| Deprecated Classes:\r\n|   ezMajorSelectButton\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n/* DEPRECATED: select.ezMajorSelectButton */\r\nselect.ezMajorSelectButton,\r\nselect.ezSelectButton_Default-normal-ezClockerYellow {\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    border-radius: 3px;\r\n\r\n    /*\r\n    margin: 2px;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderYellow);\r\n    border-radius: 3px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    outline-width: 0;\r\n    cursor: pointer;\r\n    */\r\n}\r\n\r\n/* DEPRECATED: select.ezMajorSelectButton */\r\nselect.ezMajorSelectButton:hover:enabled,\r\nselect.ezSelectButton_Default-normal-ezClockerOrange:hover:enabled {\r\n    background-color: var(--ezLightYellow);\r\n    box-shadow: var(--ezBoxShadowStone);\r\n}\r\n\r\n/* DEPRECATED: select.ezMajorSelectButton */\r\nselect.ezMajorSelectButton:hover:active,\r\nselect.ezSelectButton_Default-normal-ezClockerOrange:hover:active {\r\n    box-shadow: var(--ezBoxShadowDarkYellow);\r\n}\r\n\r\n/* DEPRECATED: select.ezMajorSelectButton */\r\nselect.ezMajorSelectButton:disabled,\r\nselect.ezSelectButton_Default-normal-ezClockerOrange:disabled {\r\n    background-color: var(--ezExtraLightYellow);\r\n    color: var(--ezDarkYellow);\r\n    border-color: var(--ezDarkYellow);\r\n}\r\n\r\n/* DEPRECATED: select.ezMajorSelectButton */\r\nselect.ezMajorSelectButton:focus,\r\nselect.ezSelectButton_Default-normal-ezClockerOrange:focus {\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    Select/Drop Down/Menu Buttons\r\n    ##########################################################################################################################################################\r\n    Name Templates:\r\n        ezSelectButton-{name}-{color}\r\n        ezSelectButton-{name}-{other-properties}-color}\r\n        ezDropDownButton-{name}-{color}\r\n        ezDropDownButton-{name}-{other-properties}-color}\r\n        ezMenuButton-{name}-{color}\r\n        ezMenuButton-{name}-{other-properties}-color}\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    EzClocker Select Buttons\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        select.ezSelectButton-default-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nselect.ezSelectButton-default-ezClockerOrange,\r\nselect.ezSelectButton-default-ezClockerOrange:enabled {\r\n    padding: 5px 24px;\r\n    margin: 2px;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 10pt;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    border-color: var(--ezBorderYellow);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-radius: 3px;\r\n    box-shadow: 0 0 1px 1px transparent;\r\n    outline-style: none;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class State Definition: Enabled Focus]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        select.ezSelectButton-default-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nselect.ezSelectButton-default-ezClockerOrange:enabled:focus {\r\n    background-color: var(--ezHoverYellow);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow: 0 0 1px 1px transparent;\r\n    outline-color: var(--ezBorderYellow);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class State Definition: Enabled Hover and Active Hover]:\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        select.ezSelectButton-default-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nselect.ezSelectButton-default-ezClockerOrange:enabled:hover,\r\nselect.ezSelectButton-default-ezClockerOrange:enabled:focus:hover {\r\n    background-color: var(--ezHoverYellow);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\r\n    outline-color: var(--ezBorderYellow);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        select.ezSelectButton-default-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nselect.ezSelectButton-default-ezClockerOrange:enabled:active,\r\nselect.ezSelectButton-default-ezClockerOrangeenabled:active:hover,\r\nselect.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active,\r\nselect.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active:hover {\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow:\r\n        0 0 1px 1px transparent,\r\n        inset 0 0 4px 2px rgba(198, 118, 0, 0.5);\r\n    outline-color: var(--ezBorderYellow);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        select.ezSelectButton-default-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nselect.ezSelectButton-default-ezClockerOrange:disabled,\r\nselect.ezSelectButton-default-ezClockerOrange:disabled:hover {\r\n    background-color: var(--ezHoverYellow);\r\n    color: var(--ezBorderYellow);\r\n    border-color: var(--ezClockerYellow);\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        select.ezSelectButton-header-ezClockerOrange\r\n        (DEPRECATED) select.ezSelectButton-major-ezClockerOrange\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\nselect.ezSelectButton-header-ezClockerOrange,\r\nselect.ezSelectButton-header-ezClockerOrange:enabled,\r\n/* DEPRECATED: select.ezSelectButton-major-ezClockerOrange */\r\nselect.ezSelectButton-major-ezClockerOrange,\r\nselect.ezSelectButton-major-ezClockerOrange:enabled {\r\n    padding: 4px;\r\n    margin: 2px;\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtonFontFamily);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    border-color: var(--ezBorderOrange);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    outline-width: 0;\r\n    cursor: pointer;\r\n}\r\n\r\nselect.ezSelectButton-header-ezClockerOrange:hover:enabled,\r\nselect.ezSelectButton-major-ezClockerOrange:hover:enabled {\r\n    background-color: var(--ezLightOrange);\r\n    box-shadow: var(--ezBoxShadowStone);\r\n}\r\n\r\nselect.ezSelectButton-header-ezClockerOrange:hover:active,\r\nselect.ezSelectButton-major-ezClockerOrange:hover:active {\r\n    box-shadow: var(--ezBoxShadowDarkOrnage);\r\n}\r\n\r\nselect.ezSelectButton-header-ezClockerOrange:focus,\r\nselect.ezSelectButton-major-ezClockerOrange:focus {\r\n    box-shadow: var(--ezFocusBoxShadowBlack);\r\n}\r\n\r\nselect.ezSelectButton-header-ezClockerOrange:disabled,\r\nselect.ezSelectButton-major-ezClockerOrange:disabled {\r\n    background-color: var(--ezLightOrange);\r\n    color: var(--ezDarkOrange);\r\n    border-color: var(--ezDarkOrange);\r\n    font-weight: normal;\r\n}\r\n\r\noption.ezSelectButton-option-title,\r\noption.ezSelectButton-option-title:hover,\r\noption.ezSelectButton-option-title:active,\r\noption.ezSelectButton-option-title:disabled,\r\noption.ezSelectButton-option-title:focus {\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezClockerWhite);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\noption.ezSelectButton-option {\r\n    font-size: 12pt;\r\n    text-align: left;\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n    cursor: pointer;\r\n}\r\n\r\noption.ezSelectButton-option:hover option.ezSelectButton-option:focus option.ezSelectButton-option:active {\r\n    background-color: var(--ezClockerStone);\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n\r\noption.ezSelectButton-option:disabled {\r\n    color: var(--ezClockerStone);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    text-align: left;\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n    cursor: default;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n\r\n}\r\n*/\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 480px) {\r\n\r\n    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    | ezDialogButton Styles\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n    button.ezDialogButton {\r\n        padding: 10px 18px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n        border-radius: 3px;\r\n    }\r\n\r\n    button.ezDialogButton:hover {\r\n        padding: 10px 18px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n    }\r\n\r\n    button.ezDialogButton:active {\r\n        padding: 10px 18px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n    }\r\n\r\n    button.ezDialogButton:disabled {\r\n        padding: 10px 18px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n    }\r\n\r\n    button.ezDisabledDialogButton {\r\n        padding: 10px 18px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n    }\r\n\r\n    button.ezWhiteDialogButton {\r\n        padding: 10px 18px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerBlack);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n        border-radius: 3px;\r\n    }\r\n\r\n    button.ezWhiteDialogButton:hover {\r\n        padding: 10px 18px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerBlack);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n    }\r\n\r\n    button.ezWhiteDialogButton:hover:active,\r\n    button.ezWhiteDialogButton:active {\r\n        padding: 10px 18px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerBlack);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n        box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n\r\n    button.ezWhiteDialogButton:disabled {\r\n        padding: 10px 18px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerStone);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n    }\r\n\r\n    button.ezDisabledWhiteDialogButton {\r\n        padding: 10px 18px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerStone);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n        border-radius: 3px;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Wearable Screen Style  (https://yesviz.com/watches.php)\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 319px) {\r\n\r\n    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    | ezDialogButton Styles\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n    button.ezDialogButton {\r\n        padding: 4px 10px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n        border-radius: 3px;\r\n    }\r\n\r\n    button.ezDialogButton:hover {\r\n        padding: 4px 10px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n    }\r\n\r\n    button.ezDialogButton:active {\r\n        padding: 4px 10px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n    }\r\n\r\n    button.ezDialogButton:disabled {\r\n        padding: 4px 10px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n    }\r\n\r\n    button.ezDisabledDialogButton {\r\n        padding: 4px 10px;\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n        border-radius: 3px;\r\n    }\r\n\r\n    button.ezWhiteDialogButton {\r\n        padding: 4px 10px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerBlack);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n        border-radius: 3px;\r\n    }\r\n\r\n    button.ezWhiteDialogButton:hover {\r\n        padding: 4px 10px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerBlack);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n    }\r\n\r\n    button.ezWhiteDialogButton:hover:active,\r\n    button.ezWhiteDialogButton:active {\r\n        padding: 4px 10px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerBlack);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: bold;\r\n        box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n\r\n    button.ezWhiteDialogButton:disabled {\r\n        padding: 4px 10px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerStone);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n    }\r\n\r\n    button.ezDisabledWhiteDialogButton {\r\n        padding: 4px 10px;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezClockerStone);\r\n        vertical-align: middle;\r\n        font-size: 12pt;\r\n        font-weight: normal;\r\n        border-radius: 3px;\r\n    }\r\n}\r\n\r\n.ezFullWidthButton {\r\n    width: 100%;\r\n}\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    JQuery Button Style Overrides\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    JQuery Style Overrides\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-icon\r\n        .ui-button .ui-icon\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-icon,\r\n.ui-icon:enabled,\r\n.ui-button .ui-icon,\r\n.ui-button .ui-icon:enabled {\r\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-icon\r\n        .ui-button .ui-icon\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-icon:enabled:focus,\r\n.ui-button .ui-icon:enabled:focus {\r\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-icon\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-icon:enabled:hover,\r\n.ui-icon:enabled:focus:hover,\r\n.ui-button .ui-icon:enabled:hover,\r\n.ui-button .ui-icon:enabled:focus:hover {\r\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-icon\r\n        .ui-button .ui-icon\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    States:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-icon:enabled:active,\r\n.ui-icon:enabled:active:hover,\r\n.ui-icon:enabled:focus:active,\r\n.ui-icon:enabled:focus:active:hover,\r\n.ui-button .ui-icon:enabled:active,\r\n.ui-button .ui-icon:enabled:active:hover,\r\n.ui-button .ui-icon:enabled:focus:active,\r\n.ui-button .ui-icon:enabled:focus:active:hover {\r\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-icon\r\n        .ui-button .ui-icon\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-icon:disabled,\r\n.ui-icon:disabled:hover,\r\n.ui-button .ui-icon:disabled,\r\n.ui-button .ui-icon:disabled:hover {\r\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-button\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        none\r\n        :enabled\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-button,\r\n.ui-button:enabled {\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezButtons-font-family);\r\n    font-size: 12pt;\r\n    font-weight: normal;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-radius: 3px;\r\n    box-shadow: 0 0 1px 1px transparent;\r\n    outline-style: none;\r\n    cursor: pointer;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-button\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:focus\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-button:enabled:focus {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow: 0 0 1px 1px transparent;\r\n    outline-color: var(--ezClockerGray);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-button\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-button:enabled:hover,\r\n.ui-button:enabled:focus:hover {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\r\n    outline-color: var(--ezClockerGray);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-button\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    States:\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-button:enabled:active,\r\n.ui-button:enabled:active:hover,\r\n.ui-button:enabled:focus:active,\r\n.ui-button:enabled:focus:active:hover {\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    box-shadow:\r\n        0 0 1px 1px transparent,\r\n        inset 0 0 4px 2px rgba(198, 118, 0, 0.5);\r\n    outline-color: var(--ezClockerGray);\r\n    outline-width: 0;\r\n    outline-style: groove;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-button\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-button:disabled,\r\n.ui-button:disabled:hover {\r\n    background-color: var(--ezHoverOrange);\r\n    color: var(--ezBorderOrange);\r\n    border-color: var(--ezClockerOrange);\r\n    cursor: default;\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-state-active .ui-icon,\r\n        .ui-button .ui-icon,\r\n        .ui-button:enabled .ui-icon:enabled,\r\n        .ui-button:enabled:active .ui-icon:enabled:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    States:\r\n        none\r\n        :enabled\r\n        :enabled:active\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-button .ui-icon,\r\n.ui-button:enabled .ui-icon:enabled,\r\n.ui-button:enabled:active .ui-icon:enabled:active,\r\n.ui-state-active .ui-icon {\r\n    /* Using black icons only */\r\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ui-dialog-titlebar-close\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    States:\r\n        none\r\n        :enabled\r\n        :enabled:focus\r\n        :enabled:hover\r\n        :enabled:focus:hover\r\n        :enabled:active\r\n        :enabled:active:hover\r\n        :enabled:focus:active\r\n        :enabled:focus:active:hover\r\n        :disabled\r\n        :disabled:hover\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ui-dialog-titlebar-close,\r\n.ui-dialog-titlebar-close:enabled,\r\n.ui-dialog-titlebar-close:enabled:focus,\r\n.ui-dialog-titlebar-close:enabled:hover,\r\n.ui-dialog-titlebar-close:enabled:focus:hover,\r\n.ui-dialog-titlebar-close:enabled:active,\r\n.ui-dialog-titlebar-close:enabled:active:hover,\r\n.ui-dialog-titlebar-close:enabled:focus:active,\r\n.ui-dialog-titlebar-close:enabled:focus:active:hover,\r\n.ui-dialog-titlebar-close:disabled,\r\n.ui-dialog-titlebar-close:disabled:hover {\r\n    /* Hide all JQuery UI dialog's top right X butons */\r\n    display: none\r\n}\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    [Class Section]\r\n    DEPRECATED STYLES\r\n    DO NOT USE CLASS IN THIS SECTION\r\n    ##########################################################################################################################################################\r\n*/\r\n\r\n/* @DEPRECATED: a.navButton */\r\na.navButton {\r\n    font-size: medium;\r\n    font-weight: normal;\r\n    margin: 2px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezActionGreenBorderColor);\r\n    background-color: #8ef13c;\r\n    color: var(--ezClockerBlack);\r\n    cursor: pointer;\r\n    padding: 4px 8px;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* @DEPRECATED: a.navButton */\r\na.navButton:hover:enabled {\r\n    /* DEPRECATED: DO NOT USE */\r\n    border-top-color: var(--ezActionGreenHoverColor);\r\n    border-left-color: var(--ezActionGreenHoverColor);\r\n    border-bottom-color: #66cc99;\r\n    border-right-color: #66cc99;\r\n    background-color: #a9f16c;\r\n}\r\n\r\n/* @DEPRECATED: a.navButton */\r\na.navButton:hover:active {\r\n    border-top-color: #66cc99;\r\n    border-left-color: #66cc99;\r\n    border-bottom-color: var(--ezActionGreenHoverColor);\r\n    border-right-color: var(--ezActionGreenHoverColor);\r\n    color: #a9f16c;\r\n    background-color: var(--ezActionGreenBorderColor);\r\n}\r\n\r\n/* @DEPRECATED: a.toolButton */\r\na.toolButton {\r\n    font-size: small;\r\n    font-weight: normal;\r\n    margin: 2px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #996600;\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    cursor: pointer;\r\n    padding: 2px 4px;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* @DEPRECATED: a.toolButton */\r\na.toolButton:hover:enabled {\r\n    border-top-color: #ffee00;\r\n    border-left-color: #ffee00;\r\n    border-bottom-color: #ff9933;\r\n    border-right-color: #ff9933;\r\n    background-color: #ffcc66;\r\n}\r\n\r\n/* @DEPRECATED: a.toolButton */\r\na.toolButton:hover:active {\r\n    border-top-color: #ff9933;\r\n    border-left-color: #ff9933;\r\n    border-bottom-color: #ffee00;\r\n    border-right-color: #ffee00;\r\n    background-color: #ffcc66;\r\n}\r\n\r\n/* @DEPRECATED: a.disabledToolButton */\r\na.disabledToolButton {\r\n    font-size: small;\r\n    font-weight: normal;\r\n    margin: 2px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #808080;\r\n    background-color: var(--ezClockerStone);\r\n    color: #808080;\r\n    cursor: default;\r\n    padding: 2px 4px;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* @DEPRECATED: .buttonText */\r\n.buttonText {\r\n    font-size: 12pt;\r\n    font-family: verdana, sans-serif;\r\n    font-weight: normal;\r\n}\r\n\r\n/* @DEPRECATED: .headerButtonText */\r\n.headerButtonText {\r\n    font-size: 12pt;\r\n    font-family: verdana, sans-serif;\r\n    font-weight: bold;\r\n}\r\n\r\n/* @DEPRECATED: button.ezNoButtonMargin */\r\nbutton.ezNoButtonMargin {\r\n    margin: 0;\r\n}\r\n\r\n/* @DEPRECATED: button.fullWidth */\r\nbutton.fullWidth {\r\n    width: 100%;\r\n}\r\n\r\n/* @DEPRECATED: button.paddButton10 */\r\nbutton.paddButton10 {\r\n    margin-left: 10px;\r\n}\r\n\r\n/* @DEPRECATED: paper-button.ez-navigation-button */\r\npaper-button.ez-navigation-button {\r\n    font-family: var(--ezFontFamily);\r\n    max-height: var(--ezNavButtonMaxHeight);\r\n    max-width: var(--ezNavButtonMaxWidth);\r\n    min-width: var(--ezNavButtonMinWidth);\r\n    font-size: var(--ezNavButtonFontSize);\r\n    font-weight: var(--ezNavButtonFontWeight);\r\n    background-color: var(--ezNavButtonColor);\r\n    color: var(--ezNavButtonTextColor);\r\n    text-transform: var(--ezNavButtonTextTransform);\r\n}\r\n\r\n/* @DEPRECATED: paper-button.ez-navigation-button */\r\npaper-button.ez-navigation-button>paper-ripple {\r\n    color: var(--ezWhite);\r\n}\r\n\r\n/* @DEPRECATED: paper-button.ez-navigation-button */\r\npaper-button.ez-navigation-button:hover:enabled {\r\n    background-color: var(--ezNavButtonColorHover);\r\n    box-shadow:\r\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n        0 1px 5px 0 rgba(0, 0, 0, 0.12),\r\n        0 3px 1px -2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* @DEPRECATED: ez-signout-button */\r\npaper-button.ez-signout-button {\r\n    text-transform: var(--ezSignOutButtonTextTransform);\r\n    max-height: var(--ezSignOutButtonMaxHeight);\r\n    max-width: var(--ezSignOutButtonMaxWidth);\r\n    min-width: var(--ezSignOutButtonMinWidth);\r\n    font-size: var(--ezSignOutButtonFontSize);\r\n    font-weight: var(--ezSignOutButtonFontWeight);\r\n    background-color: var(--ezSignOutButtonColor);\r\n    color: var(--ezSignOutButtonTextColor);\r\n}\r\n\r\n/* @DEPRECATED: ez-signout-button */\r\npaper-button.ez-signout-button>paper-ripple {\r\n    color: var(--ezWhite);\r\n}\r\n\r\n/* @DEPRECATED: ez-signout-button */\r\npaper-button.ez-signout-button:hover:enabled {\r\n    background-color: var(--ezSignOutButtonHoverColor);\r\n    box-shadow:\r\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n        0 1px 5px 0 rgba(0, 0, 0, 0.12),\r\n        0 3px 1px -2px rgba(0, 0, 0, 0.20);\r\n}\r\n\r\n/* @DEPRECATED: paper-button.ez-select-plan-button */\r\npaper-button.ez-select-plan-button {\r\n    max-width: var(--ezSelectPlanButtonMaxWidth);\r\n    min-width: var(--ezSelectPlanButtonMinWidth);\r\n    max-height: var(--ezSelectPlanBtnMaxHeight);\r\n    font-size: var(--ezSelectPlanBtnFontSize);\r\n    font-weight: var(ezSelectPlanBtnFontWeight);\r\n    background-color: var(--ezSelectPlanBtnColor);\r\n    color: var(--ezSelectPlanBtnTextColor);\r\n    text-transform: var(--ezSelectPlanTextTransform);\r\n}\r\n\r\n/* @DEPRECATED: paper-button.ez-select-plan-button */\r\npaper-button.ez-select-plan-button>paper-ripple {\r\n    color: var(--ezBorderGreen);\r\n}\r\n\r\n/* @DEPRECATED: paper-button.ez-select-plan-button */\r\npaper-button.ez-select-plan-button:hover:enabled {\r\n    background-color: var(--ezSelectPlanBtnHoverColor);\r\n    box-shadow:\r\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n        0 1px 5px 0 rgba(0, 0, 0, 0.12),\r\n        0 3px 1px -2px rgba(0, 0, 0, 0.20);\r\n}\r\n\r\n/*\r\n    ##########################################################################################################################################################\r\n    END OF DEPRECATED CLASS SECTION\r\n    ##########################################################################################################################################################\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
